(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 5914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.059 8.378c-.83-.793-1.884-1.196-3.058-1.196-2.084 0-3.848 1.407-4.477 3.298A4.81 4.81 0 0 0 7.273 12c0 .527.09 1.04.25 1.52.63 1.89 2.394 3.298 4.478 3.298 1.076 0 1.992-.283 2.708-.763a3.68 3.68 0 0 0 1.596-2.415H12v-3.095h7.535c.094.524.145 1.07.145 1.637 0 2.436-.873 4.487-2.385 5.88C15.97 19.282 14.16 20 12 20A7.997 7.997 0 0 1 4 12a7.997 7.997 0 0 1 8-8c2.157 0 3.968.793 5.353 2.084L15.06 8.378Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m14.886 8.559.177.169.173-.173L17.53 6.26l.183-.183-.19-.176c-1.43-1.333-3.3-2.151-5.522-2.151a8.247 8.247 0 0 0-7.373 11.955 8.247 8.247 0 0 0 7.373 4.545c2.217 0 4.09-.737 5.463-2.005 1.57-1.445 2.466-3.566 2.466-6.063a9.44 9.44 0 0 0-.15-1.681l-.037-.206H11.75v3.595h4.242a3.43 3.43 0 0 1-1.422 1.957c-.671.45-1.538.721-2.57.721-1.967 0-3.641-1.33-4.24-3.127A4.559 4.559 0 0 1 7.524 12c0-.498.086-.984.238-1.44v-.001c.598-1.797 2.272-3.127 4.24-3.127 1.114 0 2.105.381 2.885 1.127Z",
    stroke: "#000",
    strokeOpacity: 0.16,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.68 12.182c0-.568-.05-1.113-.145-1.637H12v3.095h4.305a3.68 3.68 0 0 1-1.596 2.415v2.007h2.585c1.513-1.393 2.386-3.444 2.386-5.88Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20c2.16 0 3.972-.716 5.295-1.938l-2.585-2.008c-.717.48-1.633.764-2.71.764-2.083 0-3.847-1.407-4.476-3.298H4.852v2.073A7.997 7.997 0 0 0 12 20Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.524 13.52c-.16-.48-.251-.993-.251-1.52s.09-1.04.25-1.52V8.407H4.852A7.997 7.997 0 0 0 4 12c0 1.29.31 2.513.85 3.593l2.674-2.073Z",
    fill: "#FBBC05"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.182c1.175 0 2.23.403 3.059 1.196l2.294-2.294C15.968 4.793 14.157 4 12.001 4a7.997 7.997 0 0 0-7.15 4.407l2.673 2.073c.63-1.89 2.393-3.298 4.477-3.298Z",
    fill: "#EA4335"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgGoogle);

/***/ }),

/***/ 5620:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(4619);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ buttonStyles; },
/* harmony export */   "Z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _ButtonOrLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7112);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1942);





var buttonStyles = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_2__/* .cva */ .j)("flex items-center justify-center font-semibold duration-200 transition ring-2 ring-inset ring-transparent focus:outline-none disabled:opacity-90 disabled:pointer-events-none", {
    variants: {
        importance: {
            premium: "bg-gradient-to-b from-[#131619] via-[#0F1215] to-[#0E1114] text-white/90 !text-base !ring-0 hover:from-[#1A1D21] hover:via-[#15171C] hover:to-[#13161B] focus:from-[#1A1D21] focus:via-[#15171C] focus:to-[#13161B] disabled:bg-none disabled:bg-[#111418] disabled:text-white/50",
            primary: "bg-gradient-to-b from-[#3377FF] to-[#0055FF] shadow-btn text-white hover:from-[#4C86FF] hover:to-[#1F69FF] focus:ring-white/40 disabled:text-white/50 disabled:bg-none disabled:bg-[#1D222A]/[.85]",
            secondary: "bg-gradient-to-b from-[#14191D] via-[#11161A] to-[#0F1418] text-white/90 shadow-btn-dark hover:from-[#1A1D21] hover:via-[#15171C] hover:to-[#13161B] focus:from-[#1A1D21] focus:via-[#15171C] focus:to-[#13161B] focus:ring-white/20 disabled:bg-none disabled:;bg-[#111418] disabled:text-white/50 disabled:shadow-btn-dark-inactive",
            space: "bg-gradient-to-r from-white/03 bg-[#0C0F12] hover:bg-[#13161B] text-white/90 ring-white/[.24] ",
            clear: "bg-transparent"
        },
        size: {
            large: "py-4 px-6 text-sm rounded-2xl",
            medium: "py-3 px-6 text-sm rounded-xl h-12",
            small: "py-2.5 px-4 text-sm rounded-[10px]",
            xsmall: "py-1 px-3 text-sm text-[0.8125rem] rounded-lg"
        },
        fullWidth: {
            true: "w-full"
        }
    },
    defaultVariants: {
        importance: "primary",
        size: "medium"
    }
});
function Button(_param) {
    var className = _param.className, importance = _param.importance, size = _param.size, fullWidth = _param.fullWidth, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "importance",
        "size",
        "fullWidth"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ButtonOrLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: buttonStyles({
            className: className,
            importance: importance,
            size: size,
            fullWidth: fullWidth
        })
    }, props));
}


/***/ }),

/***/ 7112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ButtonOrLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);





/**
 * This is a base component that will render either a button or a link,
 * depending on the props that are passed to it. The link rendered will
 * also correctly get wrapped in a next/link component to ensure ideal
 * page-to-page transitions.
 */ function ButtonOrLink(_param) {
    var href = _param.href, _smoothScroll = _param.smoothScroll, smoothScroll = _smoothScroll === void 0 ? false : _smoothScroll, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "href",
        "smoothScroll"
    ]);
    var isLink = typeof href !== "undefined";
    var ButtonOrLink = isLink ? "a" : "button";
    var content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonOrLink, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
    if (!smoothScroll && isLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: href,
            children: content
        });
    }
    if (smoothScroll) {
        var scroll = function(e) {
            if (smoothScroll) {
                var ref;
                e.preventDefault();
                (ref = document.querySelector(href)) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                    behavior: "smooth"
                });
            }
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonOrLink, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
            onClick: scroll
        }));
    }
    return content;
}


/***/ }),

/***/ 5379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_in_viewport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9231);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4539);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8831);
/* harmony import */ var components_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1107);






var Dialog = function(param) {
    var show = param.show, onClose = param.onClose, title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, image = param.image, _small = param.small, small = _small === void 0 ? false : _small, _smallImage = param.smallImage, smallImage = _smallImage === void 0 ? false : _smallImage, _children = param.children, children = _children === void 0 ? "" : _children;
    var buttonHeaderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,react_in_viewport__WEBPACK_IMPORTED_MODULE_2__/* .useInViewport */ .NM)(buttonHeaderRef, {
        rootMargin: "0px 0px 20px 0px"
    }), buttonHeaderInViewport = ref.inViewport;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showFloatingButtonHeader = ref1[0], setShowFloatingButtonHeader = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setShowFloatingButtonHeader(show);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition */ .u, {
        show: show,
        as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Dialog */ .V, {
            onClose: function() {
                return onClose === null || onClose === void 0 ? void 0 : onClose();
            },
            className: "absolute inset-0 z-50 sm:py-16",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition.Child */ .u.Child, {
                    as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "fixed inset-0 bg-black/90"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "fixed inset-0 overflow-y-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex min-h-full justify-center text-center sm:items-center sm:p-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition.Child */ .u.Child, {
                            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 scale-95",
                            enterTo: "opacity-100 scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 scale-100",
                            leaveTo: "opacity-0 scale-95",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Dialog.Panel */ .V.Panel, {
                                className: "relative min-h-screen w-full bg-surface-700 bg-target-pattern bg-contain bg-no-repeat sm:mx-auto sm:min-h-0 sm:rounded-3xl sm:shadow-modal ".concat(small ? "sm:max-w-[400px]" : " sm:max-w-[480px]"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute inset-x-0 top-0 flex w-full justify-start px-3 py-4 ".concat(small ? "sm:p-6" : "sm:p-8"),
                                        ref: buttonHeaderRef,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            hidden: onClose === undefined,
                                            onClick: function() {
                                                return onClose === null || onClose === void 0 ? void 0 : onClose();
                                            },
                                            className: "rounded-md p-1 text-white transition hover:text-white/75 focus-visible:text-white/75 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/10",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                className: "w-6",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M17.655 6.345c.165.164.247.247.285.339a.5.5 0 0 1 0 .382c-.038.092-.12.175-.285.34l-4.312 4.311c-.098.1-.148.149-.167.206a.25.25 0 0 0 0 .154c.019.057.069.107.168.206l4.311 4.312c.165.164.247.247.285.339a.5.5 0 0 1 0 .382c-.038.092-.12.175-.285.34-.164.164-.247.247-.339.285a.5.5 0 0 1-.382 0c-.092-.038-.175-.12-.34-.286l-4.311-4.312c-.1-.098-.149-.148-.206-.166a.25.25 0 0 0-.154 0c-.057.018-.107.068-.206.167l-4.312 4.311c-.164.165-.247.247-.339.285a.5.5 0 0 1-.382 0c-.092-.038-.175-.12-.34-.285-.164-.164-.246-.247-.284-.339a.5.5 0 0 1 0-.382c.038-.092.12-.175.285-.34l4.311-4.311c.1-.1.149-.149.168-.206a.25.25 0 0 0 0-.154c-.019-.057-.069-.107-.168-.206L6.345 7.405c-.165-.164-.247-.247-.285-.339a.5.5 0 0 1 0-.382c.038-.092.12-.175.285-.34.164-.164.247-.246.339-.284a.5.5 0 0 1 .382 0c.092.038.175.12.34.285l4.311 4.311c.1.1.149.149.206.168a.25.25 0 0 0 .154 0c.057-.019.107-.069.206-.168l4.312-4.311c.164-.165.247-.247.339-.285a.5.5 0 0 1 .382 0c.092.038.175.12.34.285Z",
                                                    fill: "currentColor"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pointer-events-none sticky inset-x-0 top-0 flex w-full justify-start px-3 py-4 ".concat(small ? "sm:p-6" : "sm:p-8"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            importance: "secondary",
                                            onClick: function() {
                                                return onClose === null || onClose === void 0 ? void 0 : onClose();
                                            },
                                            className: "pointer-events-auto h-auto origin-center !rounded-full !p-1 transition ease-bounce ".concat(showFloatingButtonHeader && !buttonHeaderInViewport ? "opactity-100 translate-y-0" : "-translate-y-full opacity-0"),
                                            tabIndex: -1,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                className: "w-6",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M17.655 6.345c.165.164.247.247.285.339a.5.5 0 0 1 0 .382c-.038.092-.12.175-.285.34l-4.312 4.311c-.098.1-.148.149-.167.206a.25.25 0 0 0 0 .154c.019.057.069.107.168.206l4.311 4.312c.165.164.247.247.285.339a.5.5 0 0 1 0 .382c-.038.092-.12.175-.285.34-.164.164-.247.247-.339.285a.5.5 0 0 1-.382 0c-.092-.038-.175-.12-.34-.286l-4.311-4.312c-.1-.098-.149-.148-.206-.166a.25.25 0 0 0-.154 0c-.057.018-.107.068-.206.167l-4.312 4.311c-.164.165-.247.247-.339.285a.5.5 0 0 1-.382 0c-.092-.038-.175-.12-.34-.285-.164-.164-.246-.247-.284-.339a.5.5 0 0 1 0-.382c.038-.092.12-.175.285-.34l4.311-4.311c.1-.1.149-.149.168-.206a.25.25 0 0 0 0-.154c-.019-.057-.069-.107-.168-.206L6.345 7.405c-.165-.164-.247-.247-.285-.339a.5.5 0 0 1 0-.382c.038-.092.12-.175.285-.34.164-.164.247-.246.339-.284a.5.5 0 0 1 .382 0c.092.038.175.12.34.285l4.311 4.311c.1.1.149.149.206.168a.25.25 0 0 0 .154 0c.057-.019.107-.069.206-.168l4.312-4.311c.164-.165.247-.247.339-.285a.5.5 0 0 1 .382 0c.092.038.175.12.34.285Z",
                                                    fill: "currentColor"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mx-auto -mt-10 max-w-md px-4 pb-5 text-white sm:-mt-14 sm:max-w-full ".concat(small ? "sm:px-8 sm:pb-8" : "sm:px-12 sm:pb-12"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: small || smallImage ? "mx-auto h-32 w-32" : "mx-auto h-[196px] w-[196px]",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    className: small || smallImage ? "h-32 w-32" : "h-[196px] w-[196px]",
                                                    src: image ? image : "",
                                                    width: small ? 128 : 196,
                                                    height: small ? 128 : 196,
                                                    quality: 100
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Dialog.Title */ .V.Title, {
                                                className: "mt-4 font-display text-[32px] font-bold leading-none",
                                                children: title
                                            }),
                                            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Dialog.Description */ .V.Description, {
                                                as: "p",
                                                className: "mt-3 text-center text-white/70",
                                                children: description
                                            }),
                                            children
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dialog);


/***/ }),

/***/ 5998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6215);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4539);



var Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var name = param.name, _value = param.value, value = _value === void 0 ? "" : _value, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, _onKeyDown = param.onKeyDown, onKeyDown = _onKeyDown === void 0 ? function() {} : _onKeyDown, _type = param.type, type = _type === void 0 ? "text" : _type, _label = param.label, label = _label === void 0 ? "" : _label, _small = param.small, small = _small === void 0 ? false : _small, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _icon = param.icon, icon = _icon === void 0 ? null : _icon, _rightIcon = param.rightIcon, rightIcon = _rightIcon === void 0 ? null : _rightIcon, _error = param.error, error = _error === void 0 ? "" : _error, _info = param.info, info = _info === void 0 ? "" : _info, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _theme = param.theme, theme = _theme === void 0 ? "dark" : _theme;
    var inputRef = ref;
    if (!ref) {
        inputRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)();
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "space-y-3 text-left",
        children: [
            label ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: name,
                        className: "text-sm font-semibold text-white",
                        children: label
                    }),
                    info ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Popover */ .J, {
                        className: "relative h-5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Popover.Button */ .J.Button, {
                                className: "inline-flex items-center justify-center rounded-full p-0.5 text-white/50 transition hover:text-white focus:text-white focus:shadow-input-focus focus:outline-none",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "sr-only",
                                        children: "More information"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InfoIcon, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Transition */ .u, {
                                enter: "transition duration-100 ease-out",
                                enterFrom: "transform scale-95 opacity-0",
                                enterTo: "transform scale-100 opacity-100",
                                leave: "transition duration-75 ease-out",
                                leaveFrom: "transform scale-100 opacity-100",
                                leaveTo: "transform scale-95 opacity-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Popover.Panel */ .J.Panel, {
                                    className: "absolute left-0 w-48 rounded-xl border border-white/10 bg-surface-500 p-4 text-xs text-white/75",
                                    children: info
                                })
                            })
                        ]
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "group px-4 ".concat(small ? "rounded-[10px]" : "rounded-xl", " ").concat(theme == "dark" ? "bg-surface-700 shadow-input" : "bg-[#1C1C21] shadow-input-light", "\n        flex cursor-text items-center gap-3 transition-all ").concat(disabled ? "bg-surface-800 shadow-input-disabled" : "focus-within:!shadow-input-focus hover:shadow-input-hover"),
                onClick: function() {
                    var _$ref;
                    return inputRef === null || inputRef === void 0 ? void 0 : (_$ref = inputRef.current) === null || _$ref === void 0 ? void 0 : _$ref.focus();
                },
                children: [
                    icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pointer-events-none",
                        children: icon
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        ref: inputRef,
                        id: name,
                        name: name,
                        type: type,
                        value: value,
                        onChange: onChange,
                        onKeyDown: onKeyDown,
                        placeholder: placeholder,
                        disabled: disabled,
                        className: "w-full ".concat(small ? "h-9" : "h-12", " border-none bg-transparent p-0 font-medium text-white placeholder-white/50 transition focus:border-none focus:placeholder-white/20 focus:outline-none focus:ring-0 disabled:text-white/50 sm:text-sm sm:leading-none")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Transition */ .u, {
                        show: error ? true : false,
                        as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 scale-95",
                        enterTo: "opacity-100 scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 scale-100",
                        leaveTo: "opacity-0 scale-95",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "pointer-events-none text-comp-yellow-600",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExclamationIcon, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Transition */ .u, {
                        show: disabled && !error && !rightIcon,
                        as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 scale-95",
                        enterTo: "opacity-100 scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 scale-100",
                        leaveTo: "opacity-0 scale-95",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "pointer-events-none text-white/50",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LockIcon, {})
                        })
                    }),
                    rightIcon && !error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pointer-events-none inline-flex items-center",
                        children: rightIcon
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Transition */ .u, {
                show: error ? true : false,
                as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                enter: "ease-out duration-300",
                enterFrom: "opacity-0 scale-95",
                enterTo: "opacity-100 scale-100",
                leave: "ease-in duration-200",
                leaveFrom: "opacity-100 scale-100",
                leaveTo: "opacity-0 scale-95",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-xs text-comp-yellow-600",
                    children: error
                })
            })
        ]
    });
});
var InfoIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: "h-4 w-4 shrink-0",
        "aria-hidden": "true",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8 6.5a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75ZM7.288 7.809c-.038.092-.038.208-.038.441v2c0 .233 0 .35.038.441a.5.5 0 0 0 .27.27C7.652 11 7.768 11 8 11s.35 0 .441-.038a.5.5 0 0 0 .27-.27c.039-.092.039-.209.039-.442v-2c0-.233 0-.35-.038-.441a.5.5 0 0 0-.27-.27C8.348 7.5 8.232 7.5 8 7.5s-.35 0-.441.038a.5.5 0 0 0-.27.27Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z",
                fill: "currentColor"
            })
        ]
    });
};
var ExclamationIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: "h-4 w-4 shrink-0",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.822 8.28c-.025.254-.038.381-.096.478a.5.5 0 0 1-.215.194C8.41 9 8.281 9 8.026 9h-.052c-.256 0-.384 0-.485-.048a.5.5 0 0 1-.215-.194c-.058-.097-.07-.224-.096-.478l-.34-3.4c-.03-.305-.046-.458.004-.575a.5.5 0 0 1 .22-.244C7.175 4 7.328 4 7.634 4h.732c.306 0 .46 0 .572.061a.5.5 0 0 1 .22.244c.05.117.035.27.004.575l-.34 3.4ZM8 10.25A.875.875 0 1 0 8 12a.875.875 0 0 0 0-1.75Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z",
                fill: "currentColor"
            })
        ]
    });
};
var LockIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: "h-4 w-4 shrink-0",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_1974_95)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8 1.5a3.75 3.75 0 0 0-3.75 3.75v1.762c-.245.015-.419.049-.567.124a1.25 1.25 0 0 0-.547.547C3 7.95 3 8.3 3 9v3.2c0 .98 0 1.47.19 1.845.169.329.436.597.766.764C4.33 15 4.82 15 5.8 15h4.4c.98 0 1.47 0 1.845-.19a1.75 1.75 0 0 0 .764-.766C13 13.67 13 13.18 13 12.2V9c0-.7 0-1.05-.136-1.317a1.25 1.25 0 0 0-.546-.547c-.149-.075-.323-.109-.568-.124V5.25A3.75 3.75 0 0 0 8 1.5ZM9.85 7c.14 0 .21 0 .264-.027a.25.25 0 0 0 .109-.11c.027-.053.027-.123.027-.263V5.25a2.25 2.25 0 0 0-4.5 0V6.6c0 .14 0 .21.027.264a.25.25 0 0 0 .11.109C5.94 7 6.01 7 6.15 7h3.7Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_1974_95",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M3 1h10v14H3z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 7237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RadioGroup; },
/* harmony export */   "m": function() { return /* binding */ RadioGroupItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1603);





function RadioGroup(_param) {
    var children = _param.children, value = _param.value, _defaultValue = _param.defaultValue, defaultValue = _defaultValue === void 0 ? null : _defaultValue, onChange = _param.onChange, className = _param.className, _name = _param.name, name = _name === void 0 ? "" : _name, _label = _param.label, label = _label === void 0 ? null : _label, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "value",
        "defaultValue",
        "onChange",
        "className",
        "name",
        "label"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .RadioGroup */ .E, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        name: name,
        value: value,
        defaultValue: defaultValue,
        onChange: onChange,
        className: className
    }, props), {
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .RadioGroup.Label */ .E.Label, {
                className: "flex items-center gap-4 text-sm font-semibold text-white lg:text-base",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "h-px w-full flex-1 bg-white/[.08]"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat(label && "mt-6", " space-y-2"),
                children: children
            })
        ]
    }));
}
function RadioGroupItem(param) {
    var children = param.children, className = param.className, value = param.value, _indicator = param.indicator, indicator = _indicator === void 0 ? true : _indicator, _theme = param.theme, theme = _theme === void 0 ? "dark/white" : _theme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .RadioGroup.Option */ .E.Option, {
        className: "group flex rounded-2xl border border-white/[.08] py-3 pl-5 pr-4 font-semibold ring-2 ring-transparent transition duration-300 hover:cursor-pointer hover:border-white/20 hover:!text-white focus:outline-none ui-checked:!border-transparent ui-checked:bg-surface-700 ui-checked:text-white/90 ".concat(className, " ").concat({
            "dark/white": "  text-white/70 ui-checked:ring-white/90",
            "dark/blue": "text-white/90 ui-checked:shadow-input-focus ui-checked:ring-transparent"
        }[theme]),
        value: value,
        children: [
            indicator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "my-1 mr-5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full ring-1 ring-inset ring-white/10 transition duration-300 group-hover:ring-white/50 ui-checked:bg-[#0657FA] ui-checked:bg-gradient-to-br ui-checked:!ring-white/[.05]",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "flex h-1.5 w-1.5 items-center justify-center rounded-full bg-white opacity-0 transition duration-300 ui-checked:opacity-100"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-1 items-center",
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 5330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Switch; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7768);


function Switch(param) {
    var label = param.label, _name = param.name, name = _name === void 0 ? "" : _name, _className = param.className, className = _className === void 0 ? "" : _className, _small = param.small, small = _small === void 0 ? false : _small, _checked = param.checked, checked = _checked === void 0 ? undefined : _checked, _onChange = param.onChange, onChange = _onChange === void 0 ? undefined : _onChange, _defaultChecked = param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? false : _defaultChecked;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__/* .Switch */ .r, {
        name: name,
        checked: checked,
        onChange: onChange,
        defaultChecked: defaultChecked,
        className: "\n        ".concat(className, "\n        ").concat(small ? "h-[18px] w-[28px] p-0.5" : "h-[30px] w-[48px] p-[3px]", "\n        relative inline-flex shrink-0 cursor-pointer items-center rounded-full bg-white/[.08] shadow-switch transition-colors duration-200 ease-in-out hover:bg-white/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-40\n        ui-checked:bg-gradient-to-b ui-checked:from-[#1772FF] ui-checked:to-[#004DFF]\n        ui-checked:hover:from-[#3883FF] ui-checked:hover:to-[#0062FC]\n      "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "sr-only",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "aria-hidden": "true",
                className: "".concat(small ? "h-3.5 w-3.5 ui-checked:translate-x-2.5" : "h-6 w-6 ui-checked:translate-x-[18px]", " pointer-events-none inline-flex translate-x-0 rounded-full ring-0 transition duration-200 ease-in-out"),
                style: {
                    background: small ? "radial-gradient(145.83% 83.33% at 50% 37.5%, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.128) 100%), conic-gradient(from 128.66deg at 50% 50%, #FFFFFF -0.28deg, rgba(255, 255, 255, 0.8) 35.99deg, rgba(255, 255, 255, 0.2) 57.9deg, rgba(255, 255, 255, 0) 90deg, rgba(255, 255, 255, 0.2) 114.78deg, rgba(255, 255, 255, 0.8) 140.55deg, #FFFFFF 180deg, rgba(255, 255, 255, 0.8) 213.39deg, rgba(255, 255, 255, 0.2) 237deg, rgba(255, 255, 255, 0) 269.43deg, rgba(255, 255, 255, 0.2) 300.96deg, rgba(255, 255, 255, 0.8) 324.11deg, #FFFFFF 359.72deg, rgba(255, 255, 255, 0.8) 395.99deg), #666666" : "radial-gradient(145.83% 83.33% at 50% 37.5%, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.128) 100%), conic-gradient(from 128.66deg at 50% 50%, #FFFFFF -0.28deg, rgba(255, 255, 255, 0.8) 35.99deg, rgba(255, 255, 255, 0.2) 57.9deg, rgba(255, 255, 255, 0) 90deg, rgba(255, 255, 255, 0.2) 114.78deg, rgba(255, 255, 255, 0.8) 140.55deg, #FFFFFF 180deg, rgba(255, 255, 255, 0.8) 213.39deg, rgba(255, 255, 255, 0.2) 237deg, rgba(255, 255, 255, 0) 269.43deg, rgba(255, 255, 255, 0.2) 300.96deg, rgba(255, 255, 255, 0.8) 324.11deg, #FFFFFF 359.72deg, rgba(255, 255, 255, 0.8) 395.99deg), #505050",
                    boxShadow: small ? "0px 1px 2px rgba(0, 0, 0, 0.08), 0px 0px 0px 1px rgba(0, 0, 0, 0.08), inset 0px 1px 0px rgba(255, 255, 255, 0.32), inset 0px 0px 0px 1px rgba(255, 255, 255, 0.12)" : "0px 8px 16px rgba(0, 0, 0, 0.08), 0px 4px 8px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.08), 0px 0px 0px 1px rgba(0, 0, 0, 0.08), inset 0px 1px 0px rgba(255, 255, 255, 0.32), inset 0px 0px 0px 1px rgba(255, 255, 255, 0.12)"
                }
            })
        ]
    });
}


/***/ }),

/***/ 4619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 38 modules
var esm = __webpack_require__(4166);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(4539);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-scroll.mjs + 25 modules
var use_scroll = __webpack_require__(521);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.mjs + 3 modules
var use_transform = __webpack_require__(2421);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 158 modules
var motion = __webpack_require__(3532);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/compareDesc/index.js
var compareDesc = __webpack_require__(7445);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(8420);
// EXTERNAL MODULE: ./node_modules/lodash/chunk.js
var chunk = __webpack_require__(8400);
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(3279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
;// CONCATENATED MODULE: ./public/assets/chevron-down.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.566 14.495c-.198.198-.297.297-.412.334a.5.5 0 0 1-.309 0c-.114-.037-.213-.136-.41-.334L7.47 10.53c-.165-.164-.247-.247-.286-.339a.5.5 0 0 1 0-.382c.039-.092.12-.175.286-.34.164-.164.247-.246.339-.284a.5.5 0 0 1 .382 0c.092.038.175.12.34.285l3.186 3.186c.1.1.149.149.206.168a.25.25 0 0 0 .154 0c.057-.019.107-.069.206-.168L15.47 9.47c.164-.165.247-.247.339-.285a.5.5 0 0 1 .382 0c.092.038.175.12.34.285.164.164.246.247.285.339a.5.5 0 0 1 0 .382c-.039.092-.121.175-.286.34l-3.964 3.964Z"
  })));
};
/* harmony default export */ var chevron_down = (SvgChevronDown);
;// CONCATENATED MODULE: ./components/Disclosure/Disclosure.tsx



var DisclosureButton = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
        className: "group flex w-full items-center justify-between overflow-hidden rounded-lg px-2 py-2 text-left text-xl font-semibold transition focus:outline-none focus-visible:shadow-input-focus ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "flex-1 truncate",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_down, {
                className: "fill-white/50 transition group-hover:fill-white/70 ui-open:rotate-180 ui-open:transform"
            })
        ]
    });
};
/* harmony default export */ var Disclosure = (disclosure/* Disclosure */.p);

;// CONCATENATED MODULE: ./components/Transitions/SlideIn.tsx

function SlideIn(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
}

;// CONCATENATED MODULE: ./components/Bundle/Bundle.tsx









function Bundle(param) {
    var productName = param.productName, shows = param.shows;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref = (0,react.useState)(null), hovering = ref[0], setHovering = ref[1];
    var scrollContainerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if ((window === null || window === void 0 ? void 0 : window.innerWidth) < 768 && (shows === null || shows === void 0 ? void 0 : shows.length) > 3) {
            var debounced = debounce_default()(function(e) {
                var ref;
                var dimensions = scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : (ref = scrollContainerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
                if (!dimensions) return;
                var top = dimensions.top - window.innerHeight;
                var bottom = dimensions.top + dimensions.height;
                var intersected = top + dimensions.height + 50 < 0 && bottom > 0;
                if (intersected) {
                    var ref1;
                    scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : (ref1 = scrollContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.scroll({
                        left: (0 - top) / bottom * dimensions.width / 4,
                        behavior: "smooth"
                    });
                }
            }, 50);
            window.addEventListener("scroll", debounced);
            return function() {
                return window.removeEventListener("scroll", debounced);
            };
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Disclosure, {
            defaultOpen: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclosureButton, {
                    children: t("in_the_bundle")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    enter: "origin-top-left transition duration-100 ease-out",
                    enterFrom: "transform scale-95 opacity-0",
                    enterTo: "transform scale-100 opacity-100",
                    leave: "origin-top-left transition duration-75 ease-out",
                    leaveFrom: "transform scale-100 opacity-100",
                    leaveTo: "transform scale-95 opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclosure.Panel, {
                        className: "px-2 pt-4 pb-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: scrollContainerRef,
                                            className: "no-scrollbar relative flex shrink-0 items-center gap-2 overflow-x-auto pr-16 md:hidden",
                                            children: shows.map(function(show, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative inline-flex h-32 w-32 shrink-0 rounded-md bg-white/10 md:aspect-square md:h-auto md:w-full",
                                                    onMouseEnter: function() {
                                                        return setHovering(show.title);
                                                    },
                                                    onMouseLeave: function() {
                                                        return setHovering(null);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: show.coverImageUrl,
                                                        layout: "fill",
                                                        className: "h-full w-full rounded-md"
                                                    })
                                                }, show.title + "-" + i);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hidden md:grid md:gap-4",
                                            children: chunk_default()(shows, 3).map(function(showChunk, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "grid grid-cols-3 gap-4",
                                                        children: showChunk.map(function(show, i) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "relative inline-flex h-32 w-32 shrink-0 rounded-md bg-white/10 md:aspect-square md:h-auto md:w-full",
                                                                onMouseEnter: function() {
                                                                    return setHovering(show.title);
                                                                },
                                                                onMouseLeave: function() {
                                                                    return setHovering(null);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: show.coverImageUrl,
                                                                    layout: "fill",
                                                                    className: "h-full w-full rounded-md"
                                                                })
                                                            }, show.title + "-desktop-" + i);
                                                        })
                                                    })
                                                }, "shows-" + i);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pointer-events-none absolute inset-y-0 right-0 h-full w-32 bg-gradient-to-r from-[#000]/0 to-[#000] md:hidden"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "font-semibold text-white",
                                                children: productName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "mt-1 text-[13px] leading-6 text-white/70",
                                                children: shows.map(function(show, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "".concat(hovering === show.title && "text-white", " transition"),
                                                        children: show.title
                                                    }, show.title + "-title-" + i);
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-fast-marquee/dist/index.js
var dist = __webpack_require__(6958);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(603);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(2699);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subDays/index.js + 1 modules
var subDays = __webpack_require__(5049);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistanceToNow/index.js + 12 modules
var formatDistanceToNow = __webpack_require__(4314);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 18 modules
var format = __webpack_require__(4850);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/sv/index.js + 5 modules
var sv = __webpack_require__(5155);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/de/index.js + 5 modules
var de = __webpack_require__(879);
;// CONCATENATED MODULE: ./utils/datetime.ts



var formatRelativeDate = function(string, locale) {
    var date = new Date(string);
    var dateLocale = locale === "sv" ? sv/* default */.Z : locale === "de" ? de/* default */.Z : undefined;
    if ((0,isAfter/* default */.Z)(date, (0,subDays/* default */.Z)(new Date(), 7))) {
        return (0,formatDistanceToNow/* default */.Z)(date, {
            addSuffix: true,
            locale: dateLocale
        });
    }
    var formatString = (0,isAfter/* default */.Z)(date, new Date("".concat(new Date().getFullYear() - 1, "-12-31"))) ? "d MMMM" : "d MMMM Y";
    if (dateLocale) {
        return (0,format/* default */.Z)(new Date(date), formatString, {
            locale: dateLocale
        });
    } else {
        return (0,format/* default */.Z)(new Date(date), formatString);
    }
};
var formatPlayerEpisodeTime = function(time, duration) {
    var isMoreThanAnHours = duration / 60 / 60 > 1;
    if (time && !isNaN(time)) {
        var hours = 0;
        var minutes = Math.floor(time / 60);
        if (minutes >= 60) {
            hours = Math.floor(minutes / 60);
            minutes = minutes - hours * 60;
        }
        var formatHours = hours > 0 ? hours < 10 ? "0".concat(hours, ":") : "".concat(hours, ":") : isMoreThanAnHours ? "00:" : "";
        var formatMinutes = minutes < 10 ? "0".concat(minutes, ":") : "".concat(minutes, ":");
        var seconds = Math.floor(time % 60);
        var formatSeconds = seconds < 10 ? "0".concat(seconds) : "".concat(seconds);
        return "".concat(formatHours).concat(formatMinutes).concat(formatSeconds);
    }
    if (isMoreThanAnHours) {
        return "00:00:00";
    } else {
        return "00:00";
    }
};
var formatEpisodeDuration = function(duration) {
    var ref = (0,_sliced_to_array/* default */.Z)(duration.split(":"), 3), hours = ref[0], minutes = ref[1], seconds = ref[2];
    if (!seconds) {
        minutes = hours;
        hours = 0;
    }
    return "".concat(hours > 0 ? +hours + "h" : "", " ").concat(minutes + "m");
};

;// CONCATENATED MODULE: ./public/assets/explicit.svg
var explicit_path;
function explicit_extends() { explicit_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return explicit_extends.apply(this, arguments); }

var SvgExplicit = function SvgExplicit(props) {
  return /*#__PURE__*/react.createElement("svg", explicit_extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), explicit_path || (explicit_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.245 2.229C1 2.709 1 3.339 1 4.6v2.8c0 1.26 0 1.89.245 2.371.216.424.56.768.984.984C2.709 11 3.339 11 4.6 11h2.8c1.26 0 1.89 0 2.371-.245.424-.216.768-.56.984-.984C11 9.291 11 8.661 11 7.4V4.6c0-1.26 0-1.89-.245-2.371a2.25 2.25 0 0 0-.984-.984C9.291 1 8.661 1 7.4 1H4.6c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 0 0-.984.984Zm2.727.953V9h4.056V7.858h-2.65V6.662H7.82V5.517H5.378V4.324h2.65V3.182H3.972Z"
  })));
};
/* harmony default export */ var explicit = (SvgExplicit);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./components/Tooltip/TooltipOnHover.tsx




function TooltipOnHover(_param) {
    var children = _param.children, text = _param.text, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "text",
        "className"
    ]);
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative ".concat(className),
        onMouseEnter: function() {
            return setShow(true);
        },
        onMouseLeave: function() {
            return setShow(false);
        },
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                show: show,
                enter: "transition ease-out duration-200",
                enterFrom: "opacity-0",
                enterTo: "opacity-100 scale-100",
                leave: "transition ease-in duration-200",
                leaveFrom: "opacity-100 scale-100",
                leaveTo: "opacity-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "absolute -top-1 left-1/2 block origin-bottom -translate-y-14 -translate-x-1/2 whitespace-nowrap rounded border border-white/10 bg-[#131619] px-2 py-1 text-xs",
                    children: text
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Player/Player.tsx









// Inspired by https://blog.logrocket.com/building-audio-player-react/#configuring-progress-bar-volume-slider for reference
function Player(param) {
    var activeEpisode = param.activeEpisode, setActiveEpisode = param.setActiveEpisode, previousEpisode = param.previousEpisode, nextEpisode = param.nextEpisode, autoplay = param.autoplay, playbackSpeed = param.playbackSpeed, setPlaybackSpeed = param.setPlaybackSpeed, handleIsPlaying = param.handleIsPlaying;
    var wrapper = (0,react.useRef)(null);
    var player = (0,react.useRef)(null);
    var audio = (0,react.useRef)(null);
    var scrubber = (0,react.useRef)(null);
    var playAnimationRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), initialized = ref[0], setInitialized = ref[1];
    var ref1 = (0,react.useState)(false), playing = ref1[0], setPlaying = ref1[1];
    var ref2 = (0,react.useState)(0), timeProgress = ref2[0], setTimeProgress = ref2[1];
    var ref3 = (0,react.useState)(0), duration = ref3[0], setDuration = ref3[1];
    var ref4 = (0,react.useState)(true), showMobilePlayer = ref4[0], setShowMobilePlayer = ref4[1];
    var handleUserKeyPress = (0,react.useCallback)(function(event) {
        var key = event.key, keyCode = event.keyCode;
        if (keyCode === 37) {
            audio.current.currentTime -= 5;
        } else if (keyCode === 39) {
            audio.current.currentTime += 5;
        }
    }, []);
    (0,react.useEffect)(function() {
        window.addEventListener("keydown", handleUserKeyPress);
        return function() {
            window.removeEventListener("keydown", handleUserKeyPress);
        };
    }, [
        handleUserKeyPress
    ]);
    (0,react.useEffect)(function() {
        setInitialized(true);
    });
    (0,react.useEffect)(function() {
        if (audio.current) {
            audio.current.playbackRate = playbackSpeed;
        }
    }, [
        activeEpisode,
        playbackSpeed
    ]);
    var ref5 = (0,esm/* useTranslation */.$G)("common"), t = ref5.t, i18n = ref5.i18n;
    var repeat = (0,react.useCallback)(function() {
        var ref;
        if (!scrubber.current) return;
        var currentTime = (ref = audio.current) === null || ref === void 0 ? void 0 : ref.currentTime;
        setTimeProgress(currentTime);
        scrubber.current.value = currentTime;
        var scrubberTimeout = setTimeout(function() {
            var ref, ref1;
            wrapper === null || wrapper === void 0 ? void 0 : (ref = wrapper.current) === null || ref === void 0 ? void 0 : ref.style.setProperty("--range-progress", "".concat((((ref1 = scrubber.current) === null || ref1 === void 0 ? void 0 : ref1.value) || 0) / duration * 100, "%"));
        }, 0);
        playAnimationRef.current = requestAnimationFrame(repeat);
        return function() {
            return clearTimeout(scrubberTimeout);
        };
    }, [
        audio,
        duration,
        scrubber,
        setTimeProgress
    ]);
    (0,react.useEffect)(function() {
        handleIsPlaying(playing);
        if (playing) {
            var ref;
            (ref = audio.current) === null || ref === void 0 ? void 0 : ref.play();
        } else {
            var ref1;
            (ref1 = audio.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
        }
        playAnimationRef.current = requestAnimationFrame(repeat);
    }, [
        playing,
        audio,
        repeat,
        playAnimationRef
    ]);
    var play = function() {
        setPlaying(true);
        audio.current.play();
    };
    var pause = function() {
        setPlaying(false);
        audio.current.pause();
    };
    var skipForward = function() {
        audio.current.currentTime += 30;
    };
    var skipBackward = function() {
        audio.current.currentTime -= 15;
    };
    var handleProgressChange = function() {
        audio.current.currentTime = scrubber.current.value;
    };
    var onLoadedMetadata = function() {
        var seconds = audio.current.duration;
        setDuration(seconds);
        scrubber.current.max = seconds;
    };
    var onEnded = function() {
        if (autoplay) {
            return nextEpisode();
        }
        audio.current.currentTime = 0;
        pause();
    };
    (0,react.useEffect)(function() {
        var handleKeydown = function(e) {
            var ref;
            if (e.code === "Space" && (![
                "a",
                "button",
                "input",
                "select",
                "textarea",
                "radio"
            ].includes(e.target.tagName.toLowerCase()) || ((ref = player.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)))) {
                e.preventDefault();
                playing ? pause() : play();
            }
        };
        document.addEventListener("keydown", handleKeydown);
        return function() {
            return document.removeEventListener("keydown", handleKeydown);
        };
    });
    var close = function() {
        playing && pause();
        setShowMobilePlayer(false);
        setActiveEpisode(null);
    };
    (0,react.useEffect)(function() {
        if (playing) {
            setShowMobilePlayer(true);
        }
    }, [
        playing
    ]);
    var previousActiveEpisode = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (activeEpisode !== null && !showMobilePlayer) {
            setShowMobilePlayer(true);
            setPlaying(true);
        }
        var episodeChanged = activeEpisode && JSON.stringify(activeEpisode) !== JSON.stringify(previousActiveEpisode.current);
        if (previousActiveEpisode.current !== null && episodeChanged) {
            setPlaying(true);
        }
        if (episodeChanged) {
            previousActiveEpisode.current = activeEpisode;
            setShowMobilePlayer(true);
        }
    }, [
        activeEpisode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapper,
        className: "player w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative hidden md:flex md:h-full md:min-h-screen md:w-full md:items-center md:px-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: player,
                    className: "relative w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pointer-events-auto relative mx-auto w-full max-w-[384px] overflow-hidden rounded-3xl bg-secondary-800 shadow-player",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative z-0 aspect-square w-full overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            backgroundImage: "url(".concat(activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.image_url, ")")
                                        },
                                        className: "absolute inset-0 h-full w-full bg-secondary-700 bg-contain bg-top",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute inset-0 h-full w-full bg-contain bg-top blur",
                                            style: {
                                                backgroundImage: "inherit",
                                                WebkitMaskImage: "linear-gradient(to bottom, transparent 50%, black)",
                                                maskImage: "linear-gradient(to bottom, transparent 50%, black)"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-x-0 bottom-0 h-1/2 w-full bg-gradient-to-b from-secondary-800/0 to-secondary-800"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative -mt-24 p-6 lg:px-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "h-12 text-center",
                                        children: [
                                            (activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.title.length) >= 30 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                speed: 20,
                                                delay: 3,
                                                pauseOnHover: true,
                                                className: "whitespace-no-wrap font-semibold leading-6 text-white",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pr-12",
                                                    children: (activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.title) || " "
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "font-semibold leading-6 text-white",
                                                children: (activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.title) || " "
                                            }),
                                            activeEpisode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "truncate whitespace-nowrap text-[13px] leading-6 text-white/70",
                                                children: [
                                                    activeEpisode && formatRelativeDate(activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.published_at),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-light",
                                                        children: " •"
                                                    }),
                                                    " ",
                                                    activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.metadata,
                                                    (activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.explicit) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "font-light",
                                                                children: " • "
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(explicit, {
                                                                className: "inline-block fill-white/70 pt-[1px] align-baseline"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "\xa0"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                ref: scrubber,
                                                type: "range",
                                                className: "scrubber w-full focus:outline-none",
                                                defaultValue: "0",
                                                onChange: handleProgressChange
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-3 flex select-none items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "relative w-[72px] font-digital text-sm font-black",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "absolute inset-0 text-[#5CE7FF0F]/10",
                                                        children: "88:88:88"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            textShadow: "0px 0px 8px rgba(232, 248, 255, 0.2)"
                                                        },
                                                        className: "text-white/90",
                                                        children: formatPlayerEpisodeTime(timeProgress, duration)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipOnHover, {
                                                text: t("player_speed"),
                                                className: "relative w-[120px] cursor-pointer capitalize",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: function() {
                                                        if (playbackSpeed === 1) {
                                                            setPlaybackSpeed(1.5);
                                                        } else if (playbackSpeed === 1.5) {
                                                            setPlaybackSpeed(2);
                                                        } else {
                                                            setPlaybackSpeed(1);
                                                        }
                                                    },
                                                    className: "flex justify-center font-digital text-sm font-black",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            textShadow: "0px 0px 8px rgba(133, 209, 255, 0.2)"
                                                        },
                                                        className: "flex ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex gap-1.5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat(playbackSpeed === 1 ? "text-[#85D1FF]" : "opacity-40"),
                                                                    children: "1X"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat(playbackSpeed === 1.5 ? "text-[#85D1FF]" : "opacity-40"),
                                                                    children: "1.5X"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat(playbackSpeed === 2 ? "text-[#85D1FF]" : "opacity-40"),
                                                                    children: "2X"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "relative w-[72px] font-digital text-sm font-black",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "absolute inset-0 text-right text-[#5CE7FF0F]/10",
                                                        children: "88:88:88"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            textShadow: "0px 0px 8px rgba(232, 248, 255, 0.2)"
                                                        },
                                                        className: "text-right text-white/90",
                                                        children: [
                                                            "-",
                                                            formatPlayerEpisodeTime(duration - timeProgress)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-5 flex items-center justify-center gap-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                onClick: previousEpisode,
                                                className: "inline-flex h-6 w-6 shrink-0 rounded-full transition hover:opacity-80 focus:outline-none focus:ring-0 focus-visible:shadow-input-focus disabled:opacity-30",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Go to previous track"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/assets/skip.svg",
                                                        width: 24,
                                                        height: 24,
                                                        className: "h-6 w-6 rotate-180"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                                                onClick: skipBackward,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Go back 15 seconds"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/assets/back-15.svg",
                                                        width: 24,
                                                        height: 24,
                                                        className: "h-6 w-6"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                                                onClick: function() {
                                                    return playing ? pause() : play();
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: playing ? "Pause" : "Play"
                                                    }),
                                                    playing ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/assets/pause.svg",
                                                        width: 24,
                                                        height: 24,
                                                        className: "h-6 w-6"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/assets/play.svg",
                                                        width: 24,
                                                        height: 24,
                                                        className: "h-6 w-6"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                                                onClick: skipForward,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Go forward 30 seconds"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/assets/forward-30.svg",
                                                        width: 24,
                                                        height: 24,
                                                        className: "h-6 w-6"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                onClick: nextEpisode,
                                                className: "inline-flex h-6 w-6 shrink-0 rounded-full transition hover:opacity-80 focus:outline-none focus:ring-0 focus-visible:shadow-input-focus disabled:opacity-30",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Go to next track"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/assets/skip.svg",
                                                        width: 24,
                                                        height: 24,
                                                        className: "h-6 w-6"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-x-0 bottom-0 z-50 mx-auto w-full max-w-xl overflow-hidden px-4 py-6 md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    show: showMobilePlayer,
                    enter: "transition ease-linear duration-200",
                    enterFrom: "opacity-0 translate-y-full",
                    enterTo: "opacity-100",
                    leave: "transition ease-linear duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0 translate-y-full",
                    as: "div",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rounded-full bg-secondary-800 p-1 shadow-player",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative overflow-hidden rounded-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute inset-y-0 left-0 w-[var(--range-progress)] bg-[rgba(232,248,255,0.04)]",
                                    style: {
                                        boxShadow: "0px 0px 0px 1px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(232, 248, 255, 0.02)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-0 bg-gradient-to-b from-white/[0.02] via-white/[0.04] to-white/[0.02]"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative flex items-center justify-between gap-4 p-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                                            onClick: function() {
                                                return playing ? pause() : play();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: playing ? "Pause" : "Play"
                                                }),
                                                playing ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/assets/pause.svg",
                                                    width: 24,
                                                    height: 24,
                                                    className: "h-6 w-6"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "/assets/play.svg",
                                                    width: 24,
                                                    height: 24,
                                                    className: "h-6 w-6"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex-1 overflow-hidden text-center",
                                            children: [
                                                (activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.title.length) >= 30 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                    speed: 20,
                                                    delay: 3,
                                                    pauseOnHover: true,
                                                    className: "text-sm font-semibold text-white",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "pr-12",
                                                        children: activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.title
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-center text-sm font-semibold text-white",
                                                    children: activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "flex text-xs text-white/70 ".concat((activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.title.length) < 30 && "justify-center text-center"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "block truncate",
                                                            children: [
                                                                activeEpisode && formatRelativeDate(activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.published_at, i18n.language),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-light",
                                                                    children: " • "
                                                                }),
                                                                activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.metadata
                                                            ]
                                                        }),
                                                        (activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.explicit) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-light",
                                                                    children: " • "
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(explicit, {
                                                                    className: "inline-block fill-white/70 pt-[1px] align-baseline"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mr-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                                                onClick: close,
                                                small: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Close"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/assets/player-close.svg",
                                                        width: 24,
                                                        height: 24,
                                                        className: "h-6 w-6"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            initialized && /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
                ref: audio,
                src: activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.media_url,
                controls: true,
                className: "hidden",
                onLoadedMetadata: onLoadedMetadata,
                onEnded: onEnded,
                autoPlay: false,
                preload: "none"
            })
        ]
    });
}
var Button = function(param) {
    var children = param.children, onClick = param.onClick, _small = param.small, small = _small === void 0 ? false : _small;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        onClick: onClick,
        className: "".concat(small ? "h-8 w-8" : "h-10 w-10", " relative inline-flex shrink-0 items-center justify-center rounded-full transition hover:opacity-80 focus:outline-none focus:ring-0 focus-visible:shadow-input-focus disabled:opacity-30"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 flex items-center justify-center rounded-full ",
                style: {
                    background: "#16191c",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 0px 0px 1px, rgba(0, 0, 0, 0.24) 0px 1px 2px 0px, rgba(0, 0, 0, 0.24) 0px 2px 4px 0px, rgba(0, 0, 0, 0.24) 0px 4px 8px 0px, rgba(0, 0, 0, 0.16) 0px -1px 1px 0px inset, rgba(255, 255, 255, 0.06) 0px 1px 1px 0px inset"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(small ? "h-[30px] w-[30px]" : "h-[38px] w-[38px]", " overflow-hidden rounded-full"),
                    style: {
                        backgroundImage: "linear-gradient(rgb(12, 15, 18) 0%, rgb(22, 25, 28) 100%)"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative flex h-full w-full items-center justify-center",
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-animate-height/dist/esm/index.js
var dist_esm = __webpack_require__(1073);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button_Button = __webpack_require__(1107);
;// CONCATENATED MODULE: ./public/assets/lock.svg
var lock_path;
function lock_extends() { lock_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lock_extends.apply(this, arguments); }

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/react.createElement("svg", lock_extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), lock_path || (lock_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 6.012c-.245.015-.42.049-.567.124a1.25 1.25 0 0 0-.547.546C3.5 6.95 3.5 7.3 3.5 8v2.6c0 .84 0 1.26.163 1.58a1.5 1.5 0 0 0 .656.656c.32.164.74.164 1.581.164h4.2c.84 0 1.26 0 1.581-.164a1.5 1.5 0 0 0 .655-.655c.164-.32.164-.741.164-1.581V8c0-.7 0-1.05-.136-1.318a1.25 1.25 0 0 0-.546-.546c-.149-.075-.323-.11-.568-.124V4.75a3.25 3.25 0 1 0-6.5 0v1.262ZM6 6h4V4.75a2 2 0 1 0-4 0V6Z"
  })));
};
/* harmony default export */ var lock = (SvgLock);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 3 modules
var listbox = __webpack_require__(8705);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/ChevronUpDownIcon.js
var ChevronUpDownIcon = __webpack_require__(6032);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/CheckIcon.js
var CheckIcon = __webpack_require__(4589);
;// CONCATENATED MODULE: ./components/Listbox/Listbox.tsx




function Listbox(param) {
    var selected = param.selected, onChange = param.onChange, options = param.options;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
            value: selected,
            onChange: onChange,
            by: "id",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mt-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
                        className: "relative flex h-10 w-full cursor-default items-center rounded-[10px] bg-surface-800 py-2 pl-4 pr-10 text-left font-medium leading-6 text-white/90 shadow-input hover:shadow-input-hover focus:outline-none focus-visible:shadow-input-focus sm:text-sm sm:leading-6 md:w-fit",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "block truncate",
                                children: selected === null || selected === void 0 ? void 0 : selected.label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUpDownIcon/* default */.Z, {
                                    className: "h-5 w-5 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        as: react.Fragment,
                        leave: "transition ease-in duration-100",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                            className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-[10px] bg-surface-800 p-px py-1 text-base shadow-input focus:outline-none sm:text-sm",
                            children: options === null || options === void 0 ? void 0 : options.map(function(option, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
                                    className: function(param) {
                                        var active = param.active;
                                        return "relative cursor-default select-none py-2 pl-10 pr-4 transition ".concat(active ? "bg-surface-700 text-white" : "text-white/70");
                                    },
                                    value: option,
                                    children: function(param) {
                                        var selected = param.selected;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "block truncate ".concat(selected ? "font-medium" : "font-normal"),
                                                    children: option.label
                                                }),
                                                selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "absolute inset-y-0 left-0 flex items-center pl-4 text-white/70",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                                                        className: "h-4 w-4",
                                                        "aria-hidden": "true"
                                                    })
                                                }) : null
                                            ]
                                        });
                                    }
                                }, index);
                            })
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./components/Switch/Switch.tsx
var Switch = __webpack_require__(5330);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./public/assets/audio-playing-lottie.json
var audio_playing_lottie_namespaceObject = JSON.parse('{"v":"5.7.5","fr":100,"ip":0,"op":175,"w":24,"h":24,"nm":"Comp 1","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":3,"nm":"","sr":1,"ks":{"o":{"a":0,"k":100,"ix":2},"r":{"a":0,"k":0,"ix":2},"p":{"a":0,"k":[12,12],"ix":2},"a":{"a":0,"k":[6,6],"ix":2},"s":{"a":0,"k":[100,100],"ix":2}},"ao":0,"ip":0,"op":175,"st":0,"bm":0,"hd":false},{"ddd":0,"ind":2,"ty":4,"nm":"Left","sr":1,"ks":{"o":{"a":0,"k":100,"ix":2},"r":{"a":0,"k":0,"ix":2},"p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":2},"s":{"a":0,"k":[100,100],"ix":2}},"ao":0,"hd":false,"parent":1,"shapes":[{"ty":"gr","hd":false,"it":[{"ty":"sh","hd":false,"d":1,"ks":{"a":1,"k":[{"t":0,"s":[{"c":false,"v":[[0,6.745504379272461],[0.05449676513671875,6.218507766723633],[0.2730050086975098,6],[0.8000001907348633,5.945503234863281],[2.199999809265137,5.945503234863281],[2.72700023651123,6],[2.945500373840332,6.218507766723633],[3,6.745504379272461],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,6.745504379272461]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[0.58],"y":[1]},"o":{"x":[0],"y":[0]}},{"t":15,"s":[{"c":false,"v":[[0,9.83190631866455],[0.05449676513671875,9.304910659790039],[0.2730050086975098,9.086402893066406],[0.8000001907348633,9.031906127929688],[2.199999809265137,9.031906127929688],[2.72700023651123,9.086402893066406],[2.945500373840332,9.304910659790039],[3,9.83190631866455],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,9.83190631866455]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[1],"y":[1]},"o":{"x":[0.42],"y":[0]}},{"t":75,"s":[{"c":false,"v":[[0,5.972751617431641],[0.05449676513671875,5.445755958557129],[0.2730050086975098,5.227248191833496],[0.8000001907348633,5.172751426696777],[2.199999809265137,5.172751426696777],[2.72700023651123,5.227248191833496],[2.945500373840332,5.445755958557129],[3,5.972751617431641],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,5.972751617431641]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[0.58],"y":[1]},"o":{"x":[0],"y":[0]}},{"t":120,"s":[{"c":false,"v":[[0,9.76940631866455],[0.05449676513671875,9.242410659790039],[0.2730050086975098,9.023902893066406],[0.8000001907348633,8.969406127929688],[2.199999809265137,8.969406127929688],[2.72700023651123,9.023902893066406],[2.945500373840332,9.242410659790039],[3,9.76940631866455],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,9.76940631866455]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[1],"y":[1]},"o":{"x":[0.42],"y":[0]}},{"t":150,"s":[{"c":false,"v":[[0,6.745503425598145],[0.05449676513671875,6.218507766723633],[0.2730050086975098,6],[0.8000001907348633,5.945503234863281],[2.199999809265137,5.945503234863281],[2.72700023651123,6],[2.945500373840332,6.218507766723633],[3,6.745503425598145],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,6.745503425598145]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[0.58],"y":[1]},"o":{"x":[0],"y":[0]}},{"t":175,"s":[{"c":false,"v":[[0,9.660412788391113],[0.05449676513671875,9.133417129516602],[0.27300500869750977,8.914909362792969],[0.8000001907348633,8.86041259765625],[2.1999998092651367,8.86041259765625],[2.7270002365112305,8.914909362792969],[2.945500373840332,9.133417129516602],[3,9.660412788391113],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,9.660412788391113]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[1],"y":[1]},"o":{"x":[0],"y":[0]}}],"ix":2}},{"ty":"fl","c":{"a":0,"k":[0.9882352941176471,0.9921568627450981,1],"ix":2},"o":{"a":0,"k":100,"ix":2},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":2},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":0,"ix":2},"m":1,"hd":false},{"ty":"tr","hd":false,"p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":2},"s":{"a":0,"k":[100,100],"ix":2},"r":{"a":0,"k":0,"ix":2},"o":{"a":0,"k":100,"ix":2},"sk":{"a":0,"k":0,"ix":2},"sa":{"a":0,"k":0,"ix":2}}]}],"ip":0,"op":175,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Middle","sr":1,"ks":{"o":{"a":0,"k":100,"ix":2},"r":{"a":0,"k":0,"ix":2},"p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":2},"s":{"a":0,"k":[100,100],"ix":2}},"ao":0,"hd":false,"parent":1,"shapes":[{"ty":"gr","hd":false,"it":[{"ty":"sh","hd":false,"d":1,"ks":{"a":1,"k":[{"t":0,"s":[{"c":false,"v":[[0,9.83190631866455],[0.05449676513671875,9.304910659790039],[0.2730050086975098,9.086402893066406],[0.8000001907348633,9.031906127929688],[2.199999809265137,9.031906127929688],[2.72700023651123,9.086402893066406],[2.945500373840332,9.304910659790039],[3,9.83190631866455],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,9.83190631866455]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[1],"y":[1]},"o":{"x":[0.42],"y":[0]}},{"t":30,"s":[{"c":false,"v":[[0,1.831906199455261],[0.05449676513671875,1.30491054058075],[0.2730045318603516,1.086402773857117],[0.8000001907348633,1.031906008720398],[2.199999809265137,1.031906008720398],[2.72700023651123,1.086402773857117],[2.945500373840332,1.30491054058075],[3,1.831906199455261],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,1.831906199455261]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[0.58],"y":[1]},"o":{"x":[0],"y":[0]}},{"t":75,"s":[{"c":false,"v":[[0,9.798704147338867],[0.05449676513671875,9.271708488464355],[0.2730045318603516,9.053200721740723],[0.8000001907348633,8.998703956604004],[2.199999809265137,8.998703956604004],[2.72700023651123,9.053200721740723],[2.945500373840332,9.271708488464355],[3,9.798704147338867],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,9.798704147338867]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[1],"y":[1]},"o":{"x":[0.42],"y":[0]}},{"t":120,"s":[{"c":false,"v":[[0,3.710649013519287],[0.05449676513671875,3.183653354644775],[0.2730045318603516,2.965145587921143],[0.8000001907348633,2.910648822784424],[2.199999809265137,2.910648822784424],[2.72700023651123,2.965145587921143],[2.945500373840332,3.183653354644775],[3,3.710649013519287],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,3.710649013519287]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[0.58],"y":[1]},"o":{"x":[0],"y":[0]}},{"t":150,"s":[{"c":false,"v":[[0,9.714910507202148],[0.05449676513671875,9.18791389465332],[0.2730045318603516,8.969406127929688],[0.8000001907348633,8.914909362792969],[2.199999809265137,8.914909362792969],[2.72700023651123,8.969406127929688],[2.945500373840332,9.18791389465332],[3,9.714910507202148],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,9.714910507202148]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[1],"y":[1]},"o":{"x":[0],"y":[0]}}],"ix":2}},{"ty":"fl","c":{"a":0,"k":[0.9882352941176471,0.9921568627450981,1],"ix":2},"o":{"a":0,"k":100,"ix":2},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":2},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":0,"ix":2},"m":1,"hd":false},{"ty":"tr","hd":false,"p":{"a":0,"k":[4.5,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":2},"s":{"a":0,"k":[100,100],"ix":2},"r":{"a":0,"k":0,"ix":2},"o":{"a":0,"k":100,"ix":2},"sk":{"a":0,"k":0,"ix":2},"sa":{"a":0,"k":0,"ix":2}}]}],"ip":0,"op":175,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Right","sr":1,"ks":{"o":{"a":0,"k":100,"ix":2},"r":{"a":0,"k":0,"ix":2},"p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":2},"s":{"a":0,"k":[100,100],"ix":2}},"ao":0,"hd":false,"parent":1,"shapes":[{"ty":"gr","hd":false,"it":[{"ty":"sh","hd":false,"d":1,"ks":{"a":1,"k":[{"t":0,"s":[{"c":false,"v":[[0,9.83190631866455],[0.05449676513671875,9.304910659790039],[0.2730050086975098,9.086402893066406],[0.8000001907348633,9.031906127929688],[2.199999809265137,9.031906127929688],[2.72700023651123,9.086402893066406],[2.945500373840332,9.304910659790039],[3,9.83190631866455],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,9.83190631866455]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[0.8],"y":[1]},"o":{"x":[0.4],"y":[0]}},{"t":45,"s":[{"c":false,"v":[[0,2.421227693557739],[0.05449676513671875,1.894232034683228],[0.2730045318603516,1.675724267959595],[0.8000001907348633,1.621227502822876],[2.200000762939453,1.621227502822876],[2.727001190185547,1.675724267959595],[2.945499420166016,1.894232034683228],[3,2.421227693557739],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,2.421227693557739]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[1],"y":[1]},"o":{"x":[0],"y":[0]}},{"t":90,"s":[{"c":false,"v":[[0,9.744207382202148],[0.05449676513671875,9.217211723327637],[0.2730045318603516,8.998703956604004],[0.8000001907348633,8.944207191467285],[2.200000762939453,8.944207191467285],[2.727001190185547,8.998703956604004],[2.945499420166016,9.217211723327637],[3,9.744207382202148],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,9.744207382202148]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[1],"y":[1]},"o":{"x":[0.42],"y":[0]}},{"t":120,"s":[{"c":false,"v":[[0.05449676513671875,6.745503425598145],[0.1089935302734375,6.218507766723633],[0.3275012969970703,6],[0.854496955871582,5.945503234863281],[2.254497528076172,5.945503234863281],[2.781497955322266,6],[2.999996185302734,6.218507766723633],[3.054496765136719,6.745503425598145],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0.05449676513671875,6.745503425598145]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[0.58],"y":[1]},"o":{"x":[0],"y":[0]}},{"t":150,"s":[{"c":false,"v":[[0,9.718255043029785],[0.05449676513671875,9.191259384155273],[0.2730045318603516,8.97275161743164],[0.8000001907348633,8.918254852294922],[2.200000762939453,8.918254852294922],[2.727001190185547,8.97275161743164],[2.945499420166016,9.191259384155273],[3,9.718255043029785],[3,11.2],[2.9455,11.727],[2.727,11.9455],[2.2,12],[0.8,12],[0.273005,11.9455],[0.0544967,11.727],[0,11.2],[0,9.718255043029785]],"i":[[0,0],[-0.0544967,0.106956],[-0.094081,0.047936299999999994],[-0.280026,0],[-0.4666666666666668,0],[-0.10695999999999994,-0.0544967],[-0.04793000000000003,-0.094081],[0,0],[0,0],[0.05449999999999999,-0.1070000000000011],[0.09407999999999994,-0.0478999999999985],[0.28003,0],[0.4666666666666668,0],[0.106956,0.05450000000000088],[0.047936299999999994,0.09409999999999918],[0,0],[0,0]],"o":[[0,0],[0.047936299999999994,-0.094081],[0.106956,-0.0544967],[0.4666666666666666,0],[0.28003,0],[0.09407999999999994,0.047936299999999994],[0.05449999999999999,0.106956],[0,0],[0,0],[-0.04793000000000003,0.09409999999999918],[-0.10695999999999994,0.05450000000000088],[-0.4666666666666668,0],[-0.280026,0],[-0.094081,-0.0478999999999985],[-0.0544967,-0.1070000000000011],[0,0],[0,0]]}],"i":{"x":[1],"y":[1]},"o":{"x":[0],"y":[0]}}],"ix":2}},{"ty":"fl","c":{"a":0,"k":[0.9882352941176471,0.9921568627450981,1],"ix":2},"o":{"a":0,"k":100,"ix":2},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":2},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":0,"ix":2},"m":1,"hd":false},{"ty":"tr","hd":false,"p":{"a":0,"k":[9,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":2},"s":{"a":0,"k":[100,100],"ix":2},"r":{"a":0,"k":0,"ix":2},"o":{"a":0,"k":100,"ix":2},"sk":{"a":0,"k":0,"ix":2},"sa":{"a":0,"k":0,"ix":2}}]}],"ip":0,"op":175,"st":0,"bm":0}],"markers":[]}');
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(5820);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/LockOpenIcon.js
var LockOpenIcon = __webpack_require__(2022);
// EXTERNAL MODULE: ./components/Dialog/Dialog.tsx
var Dialog = __webpack_require__(5379);
;// CONCATENATED MODULE: ./components/Episodes/EpisodeList.tsx
















function EpisodeList(param) {
    var episodes = param.episodes, seasons = param.seasons, activeEpisode = param.activeEpisode, setActiveEpisode = param.setActiveEpisode, activeSeason = param.activeSeason, setActiveSeason = param.setActiveSeason, autoplay = param.autoplay, setAutoplay = param.setAutoplay, loading = param.loading, isPlaying = param.isPlaying, playbackSpeed = param.playbackSpeed;
    var Lottie = dynamic_default()(function() {
        return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(260)]).then(__webpack_require__.t.bind(__webpack_require__, 9260, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(9260)
                ];
            }
        },
        ssr: false
    });
    var ref = (0,esm/* useTranslation */.$G)("common"), t = ref.t, i18n = ref.i18n;
    var activeEpisodeRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), showAll = ref1[0], setShowAll = ref1[1];
    var audioPlayingLottieIconRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), showSubscribeDialog = ref2[0], setShowSubscribeDialog = ref2[1];
    (0,react.useEffect)(function() {
        if (episodes.findIndex(function(episode) {
            return episode.id === (activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.id);
        }) > 0) {
            var ref;
            setShowAll(true);
            (ref = activeEpisodeRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: "auto",
                block: "center",
                inline: "center"
            });
        }
    }, [
        episodes
    ]);
    (0,react.useEffect)(function() {
        var ref;
        (ref = audioPlayingLottieIconRef.current) === null || ref === void 0 ? void 0 : ref.setSpeed(playbackSpeed);
        if (!isPlaying) {
            var ref1;
            (ref1 = audioPlayingLottieIconRef.current) === null || ref1 === void 0 ? void 0 : ref1.playSegments([
                150,
                175
            ], true);
        }
    }, [
        playbackSpeed,
        episodes,
        activeEpisode,
        isPlaying
    ]);
    var handleEpisodeClick = function(episode) {
        if (episode.unlocked || !episode.locked) {
            setActiveEpisode(episode);
        } else {
            setShowSubscribeDialog(episode);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                show: !!showSubscribeDialog,
                title: t("Hey there!"),
                image: "/assets/modal-juice.png",
                onClose: function() {
                    return setShowSubscribeDialog(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-4 text-center text-white/70",
                        children: "In order to unlock this episode, you need to subscribe to the podcast."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        href: "".concat(showSubscribeDialog.unlock_url),
                        importance: "primary",
                        className: "mt-8",
                        children: t("Subscribe")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        onClick: function() {
                            return setShowSubscribeDialog(false);
                        },
                        href: "#",
                        importance: "secondary",
                        className: "mt-4",
                        children: t("Cancel")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_esm/* default */.Z, {
                duration: 500,
                height: showAll || episodes.length <= 8 ? "auto" : 620,
                className: "relative -mx-1 overflow-y-clip overflow-x-visible px-1",
                children: [
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-6 py-0.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-10 w-full animate-shimmer rounded-md bg-gradient-to-r from-secondary-800 via-surface-600 to-secondary-800 bg-[length:400%_100%]"
                            }),
                            Array.from({
                                length: 5
                            }).map(function(_, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-1 items-center justify-between gap-4 rounded-md text-left",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-14 w-14 shrink-0 rounded-md bg-secondary-700"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex-1 space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "h-4 w-2/3 animate-shimmer rounded bg-gradient-to-r from-secondary-700 via-surface-600 to-secondary-700 bg-[length:400%_100%]"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "h-4 w-1/2 animate-shimmer rounded bg-gradient-to-r from-secondary-700 via-surface-600 to-secondary-700 bg-[length:400%_100%]"
                                                })
                                            ]
                                        })
                                    ]
                                }, "episode-placeholder-" + index);
                            })
                        ]
                    }, "loading") : /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                            className: "space-y-6 py-0.5",
                            initial: {
                                opacity: 0
                            },
                            animate: {
                                opacity: 1
                            },
                            exit: {
                                opacity: 0
                            },
                            children: [
                                activeSeason && seasons.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Listbox, {
                                    selected: activeSeason,
                                    onChange: setActiveSeason,
                                    options: seasons
                                }),
                                episodes.map(function(episode, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            (activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.id) === episode.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                ref: activeEpisodeRef,
                                                className: "mb-4 flex items-center gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/assets/headphones.svg",
                                                        width: "24",
                                                        height: "24"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "animate-text-shimmer bg-[linear-gradient(90deg,#e2e8f0,45%,#1e293b,55%,#e2e8f0)] bg-[length:250%_100%] bg-clip-text text-[13px] font-semibold text-transparent",
                                                        children: t("Playing now")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex w-full items-center gap-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    tabIndex: index > 5 && !showAll ? -1 : 0,
                                                    className: "group flex flex-1 items-center justify-between gap-4 rounded-md text-left focus:outline-none focus-visible:shadow-input-focus",
                                                    onClick: function() {
                                                        return handleEpisodeClick(episode);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "h-14 w-14 shrink-0 rounded-md ".concat(episode.image_url ? "" : "bg-white/50"),
                                                                    children: episode.image_url && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "relative flex h-14 w-14 items-center justify-center",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                layout: "fill",
                                                                                className: "".concat((activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.id) === episode.id && "opacity-20", " flex h-14 w-14 shrink-0  rounded-md transition"),
                                                                                src: episode.image_url,
                                                                                alt: episode.title
                                                                            }),
                                                                            (activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.id) === episode.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(Lottie, {
                                                                                className: "absolute h-6 w-6",
                                                                                animationData: audio_playing_lottie_namespaceObject,
                                                                                lottieRef: audioPlayingLottieIconRef,
                                                                                loop: !!isPlaying,
                                                                                initialSegment: [
                                                                                    0,
                                                                                    150
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "transition duration-500 group-hover:translate-x-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex gap-2 font-semibold text-white",
                                                                            children: [
                                                                                episode.locked && !episode.unlocked && /*#__PURE__*/ (0,jsx_runtime.jsx)(lock, {
                                                                                    className: " absolute mt-1 inline-block h-3.5 w-3.5 fill-white"
                                                                                }),
                                                                                episode.unlocked && /*#__PURE__*/ (0,jsx_runtime.jsx)(LockOpenIcon/* default */.Z, {
                                                                                    className: " absolute mt-1 inline-block h-3.5 w-3.5 fill-white"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "".concat(episode.locked ? "indent-5" : "", " block whitespace-normal"),
                                                                                    children: episode.title
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex flex-wrap items-center text-[13px] text-white/70",
                                                                            children: [
                                                                                formatRelativeDate(episode.published_at, i18n.language),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "text-white/50 md:hidden lg:flex",
                                                                                    children: [
                                                                                        "\xa0",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "font-light text-white/70",
                                                                                            children: " • "
                                                                                        }),
                                                                                        "\xa0",
                                                                                        t("Episode")
                                                                                    ]
                                                                                }),
                                                                                " ",
                                                                                episode.explicit && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "inline-flex items-center",
                                                                                    children: [
                                                                                        "\xa0",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "font-light",
                                                                                            children: " • "
                                                                                        }),
                                                                                        "\xa0",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(explicit, {
                                                                                            className: "inline-block fill-white/50 align-baseline"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "hidden shrink-0 whitespace-nowrap text-[13px] font-medium text-white/50 lg:block",
                                                            children: formatEpisodeDuration(episode.duration)
                                                        })
                                                    ]
                                                })
                                            }),
                                            (activeEpisode === null || activeEpisode === void 0 ? void 0 : activeEpisode.id) === episode.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-4 flex items-center justify-between gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center gap-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/assets/clock.svg",
                                                                width: "24",
                                                                height: "24"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-[13px] font-semibold text-white/50",
                                                                children: t("Next up")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: function() {
                                                            return setAutoplay(!autoplay);
                                                        },
                                                        className: "flex cursor-pointer items-center gap-1 ".concat(autoplay ? "!text-[#5CE7FF]" : "text-white/50"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                width: "16",
                                                                height: "16",
                                                                viewBox: "0 0 16 16",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M7.684 2.631c.331-.537 1.16-.263 1.108.365L8.5 6.5l2.74.365a.66.66 0 0 1 .475 1.001L8.316 13.37c-.331.536-1.16.263-1.108-.366L7.5 9.5l-2.74-.365a.66.66 0 0 1-.475-1.001L7.684 2.63Z",
                                                                    fill: "currentColor"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex items-center gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "transition-color text-[13px] font-semibold",
                                                                        children: t("Autoplay")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                                                                        label: t("Autoplay"),
                                                                        checked: autoplay,
                                                                        onChange: function(value) {
                                                                            return setAutoplay(value);
                                                                        },
                                                                        small: true
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, episode.id);
                                })
                            ]
                        }, "episodes")
                    }),
                    episodes.length > 8 && !showAll && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sticky bottom-0 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-32 w-full bg-gradient-to-b from-surface-800/0 to-surface-800"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "-mt-px flex justify-center bg-surface-800 pb-1 pt-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    className: "w-full lg:mx-auto lg:w-auto",
                                    size: "small",
                                    importance: "secondary",
                                    onClick: function() {
                                        return setShowAll(true);
                                    },
                                    children: t("more episodes")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Card/Card.tsx


var Card = function(param) {
    var children = param.children, title = param.title, _importance = param.importance, importance = _importance === void 0 ? "default" : _importance, _className = param.className, className = _className === void 0 ? "" : _className, header = param.header;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "premium-card-wrapper min-h-fit overflow-hidden rounded-3xl bg-surface-800 pt-5 pb-6 text-white/90 shadow-card md:py-6 lg:rounded-[32px] lg:py-8 ".concat(className),
        children: [
            importance === "default" && header,
            importance === "premium" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-premium-card-gradient absolute inset-0 h-[400px] w-full"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative flex items-center px-6 lg:px-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/assets/podspace-premium-colorized.png",
                                className: "",
                                width: "24",
                                height: "24",
                                quality: 100
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ml-3 text-xs font-[650] uppercase text-white/70",
                                children: title
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative px-6 pt-7 lg:px-12 lg:pt-10",
                children: children
            })
        ]
    });
};
/* harmony default export */ var Card_Card = (Card);

// EXTERNAL MODULE: ./components/Button/ButtonOrLink.tsx
var ButtonOrLink = __webpack_require__(7112);
;// CONCATENATED MODULE: ./components/PremiumBadge/PremiumBadge.tsx


function PremiumBadge(param) {
    var _small = param.small, small = _small === void 0 ? false : _small;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative shrink-0 overflow-hidden rounded ".concat(small ? "-mt-0.5" : "-mt-1"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: "relative inline-flex items-center rounded bg-white px-1 font-[800] uppercase tracking-wider text-surface-800 ".concat(small ? "text-[8px] leading-3" : "text-[10px] leading-4"),
            style: {
                textShadow: "0px 1px 0.5px rgba(253, 255, 255, 0.16)"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "pointer-events-none absolute top-0 -left-8 h-8 w-8 -translate-y-[.375rem] animate-slide",
                    style: {
                        backgroundImage: "radial-gradient(38.1% 92.19% at 50% 50%, #000000 0%, rgba(0, 0, 0, 0) 100%)",
                        mixBlendMode: "darken"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "pointer-events-none absolute inset-0 z-10 rounded border border-white/20 ".concat(small ? "h-3" : "h-4")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "relative",
                    children: t("premium_badge")
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/Row/Row.tsx

var Row = function(param) {
    var children = param.children, _classNameWrapper = param.classNameWrapper, classNameWrapper = _classNameWrapper === void 0 ? "" : _classNameWrapper, _className = param.className, className = _className === void 0 ? "" : _className, iconLeft = param.iconLeft;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center ".concat(classNameWrapper),
        children: [
            !!iconLeft && iconLeft,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center w-full py-2 gap-4 ".concat(className),
                children: children
            })
        ]
    });
};
/* harmony default export */ var Row_Row = (Row);

// EXTERNAL MODULE: ./node_modules/react-cookie-consent/dist/react-cookie-consent.esm.js
var react_cookie_consent_esm = __webpack_require__(143);
;// CONCATENATED MODULE: ./components/Footer/Footer.tsx



var Footer = function() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "relative pb-24 pt-12 text-center text-white md:pb-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "mt-11 flex flex-wrap items-center justify-center gap-8 text-[13px] md:mt-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/terms",
                        target: "_blank",
                        className: "rounded font-medium text-white/90 hover:text-white/90 focus:shadow-input-focus focus:outline-none focus:ring-0 md:text-white/70",
                        children: t("terms_of_service")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/privacy",
                        target: "_blank",
                        className: "rounded font-medium text-white/90 hover:text-white/90 focus:shadow-input-focus focus:outline-none focus:ring-0 md:text-white/70",
                        children: t("privacy_policy")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:help@podspace.com",
                        className: "rounded font-medium text-white/90 hover:text-white/90 focus:shadow-input-focus focus:outline-none focus:ring-0 md:text-white/70",
                        children: t("support")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mt-8 text-[13px] font-medium text-white/70",
                children: [
                    "\xa9 ",
                    new Date().getFullYear(),
                    " Podspace AB"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_cookie_consent_esm/* default */.ZP, {
                location: "bottom",
                buttonText: "I understand",
                cookieName: "cookie_consent",
                style: {
                    background: "#151a1c"
                },
                buttonStyle: {
                    background: "black",
                    color: "white",
                    padding: "8px 20px"
                },
                expires: 150,
                children: [
                    "This website uses cookies to enhance the user experience. See",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        className: "inline underline",
                        href: "/privacy",
                        children: "our privacy policy"
                    }),
                    " ",
                    "for details"
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ./public/assets/link-external.svg
var link_external_path;
function link_external_extends() { link_external_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return link_external_extends.apply(this, arguments); }

var SvgLinkExternal = function SvgLinkExternal(props) {
  return /*#__PURE__*/react.createElement("svg", link_external_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), link_external_path || (link_external_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4.75c0-.233 0-.35.038-.441a.5.5 0 0 1 .27-.27C13.9 4 14.018 4 14.25 4h5a.75.75 0 0 1 .75.75v5c0 .233 0 .35-.038.441a.5.5 0 0 1-.27.27c-.093.039-.209.039-.442.039s-.35 0-.441-.038a.5.5 0 0 1-.27-.27c-.039-.092-.039-.209-.039-.442V7.043c0-.15 0-.227-.03-.262a.125.125 0 0 0-.105-.043c-.046.003-.1.057-.206.164L12.4 12.66c-.164.165-.247.247-.339.285a.5.5 0 0 1-.382 0c-.092-.038-.175-.12-.34-.285-.164-.164-.246-.247-.284-.339a.5.5 0 0 1 0-.382c.038-.092.12-.175.285-.34l5.758-5.758c.107-.107.16-.16.164-.206a.125.125 0 0 0-.043-.105c-.035-.03-.111-.03-.263-.03H14.25c-.233 0-.35 0-.441-.038a.5.5 0 0 1-.27-.27c-.039-.093-.039-.209-.039-.442ZM9.121 6h2.129c.233 0 .35 0 .441.038a.5.5 0 0 1 .27.27c.039.093.039.209.039.442s0 .35-.038.441a.5.5 0 0 1-.27.27c-.092.039-.209.039-.442.039h-2.1c-.432 0-.712 0-.924.018-.204.017-.28.045-.316.064a.75.75 0 0 0-.328.328c-.02.037-.047.112-.064.316-.017.212-.018.492-.018.924v5.7c0 .432 0 .712.018.924.017.204.045.28.064.316a.75.75 0 0 0 .328.328c.037.02.112.047.316.064.212.017.492.018.924.018h5.7c.432 0 .712 0 .924-.018.204-.017.28-.045.316-.064a.75.75 0 0 0 .328-.328c.02-.037.047-.112.064-.316.017-.212.018-.492.018-.924v-2.1c0-.233 0-.35.038-.441a.5.5 0 0 1 .27-.27c.093-.039.209-.039.442-.039s.35 0 .441.038a.5.5 0 0 1 .27.27c.039.092.039.209.039.442v2.129c0 .395 0 .736-.023 1.017-.024.297-.078.592-.222.875-.216.424-.56.768-.983.984-.284.144-.58.198-.876.222-.28.023-.622.023-1.017.023H9.12c-.395 0-.736 0-1.017-.023-.297-.024-.592-.078-.875-.222a2.25 2.25 0 0 1-.984-.983c-.144-.284-.198-.58-.222-.876C6 15.616 6 15.274 6 14.88V9.12c0-.395 0-.736.023-1.017.024-.297.078-.592.222-.875a2.25 2.25 0 0 1 .984-.984c.283-.144.578-.198.875-.222C8.384 6 8.726 6 9.12 6Z"
  })));
};
/* harmony default export */ var link_external = (SvgLinkExternal);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/CheckCircleIcon.js
var CheckCircleIcon = __webpack_require__(1332);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/XMarkIcon.js
var XMarkIcon = __webpack_require__(5652);
;// CONCATENATED MODULE: ./components/Toast/Toast.tsx




function Toast(param) {
    var children = param.children, show = param.show, onClose = param.onClose;
    var timeout;
    var close = function() {
        onClose();
        clearTimeout(timeout);
    };
    (0,react.useEffect)(function() {
        if (show) {
            timeout = setTimeout(function() {
                onClose();
            }, 3000);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed inset-x-0 bottom-4 z-[100]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
            show: show,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 translate-y-full",
            enterTo: "opacity-100 translate-y-0",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 translate-y-0",
            leaveTo: "opacity-0 translate-y-full",
            appear: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto w-full max-w-2xl rounded-md bg-comp-yellow-600 p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-shrink-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleIcon/* default */.Z, {
                                className: "h-5 w-5 text-black/80",
                                "aria-hidden": "true"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-sm font-medium text-black",
                                children: children
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-auto pl-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "-mx-1.5 -my-1.5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: "focus:btn-shadow-focus inline-flex rounded-md p-1.5 text-black transition hover:text-black/80 focus:outline-none focus:ring-0",
                                    onClick: function() {
                                        return close();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Dismiss"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XMarkIcon/* default */.Z, {
                                            className: "h-5 w-5",
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/Button/CopyToClipboardButton.tsx






function CopyToClipboardButton(_param) {
    var text = _param.text, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "text",
        "children"
    ]);
    var ref = (0,react.useState)(false), copied = ref[0], setCopied = ref[1];
    var copyToClipboard = function() {
        if (!text) {
            return;
        }
        if (!navigator.clipboard) {
            return alert("Copying to clipboard only works on secure sites viewed through a modern browser.");
        }
        navigator.clipboard.writeText(text).then(function() {
            setCopied(true);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                onClick: copyToClipboard,
                children: children
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast, {
                show: copied,
                onClose: function() {
                    return setCopied(false);
                },
                children: "Copied to your clipboard"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./public/assets/copy.svg
var copy_path;
function copy_extends() { copy_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return copy_extends.apply(this, arguments); }

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/react.createElement("svg", copy_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), copy_path || (copy_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16h.879c.395 0 .736 0 1.017-.023.297-.024.592-.078.875-.222.424-.216.768-.56.984-.984.144-.283.198-.578.222-.875.023-.28.023-.622.023-1.017V7.12c0-.395 0-.736-.023-1.017-.024-.297-.078-.592-.222-.875a2.25 2.25 0 0 0-.983-.984c-.284-.144-.58-.198-.876-.222C17.616 4 17.274 4 16.88 4H11.12c-.395 0-.736 0-1.017.023-.297.024-.592.078-.875.222a2.25 2.25 0 0 0-.984.984c-.144.283-.198.578-.222.875C8 6.384 8 6.726 8 7.12V8h-.879c-.395 0-.736 0-1.017.023-.297.024-.592.078-.875.222a2.25 2.25 0 0 0-.984.984c-.144.283-.198.578-.222.875C4 10.384 4 10.726 4 11.12v5.758c0 .395 0 .736.023 1.017.024.297.078.592.222.875.216.424.56.768.984.984.283.144.578.198.875.222.28.023.622.023 1.017.023h5.758c.395 0 .736 0 1.017-.023.297-.024.592-.078.875-.222.424-.216.768-.56.984-.983.144-.284.198-.58.222-.876.023-.28.023-.622.023-1.017V16Zm0-1.5h.85c.432 0 .712 0 .924-.018.204-.017.28-.045.316-.064a.75.75 0 0 0 .328-.327c.02-.038.047-.113.064-.317.017-.212.018-.492.018-.924v-5.7c0-.432 0-.712-.018-.924-.017-.204-.045-.28-.064-.316a.75.75 0 0 0-.328-.328c-.037-.02-.112-.047-.316-.064a12.753 12.753 0 0 0-.924-.018h-5.7c-.432 0-.712 0-.924.018-.204.017-.28.045-.316.064a.75.75 0 0 0-.328.328c-.02.037-.047.112-.064.316-.017.212-.018.492-.018.924V8h3.379c.395 0 .736 0 1.017.023.297.024.592.078.875.222.424.216.768.56.984.984.144.283.198.578.222.875.023.28.023.622.023 1.017V14.5Zm-1.91 3.918c-.037.02-.112.047-.316.064-.212.017-.492.018-.924.018h-5.7c-.432 0-.712 0-.924-.018-.204-.017-.28-.045-.316-.064a.75.75 0 0 1-.328-.328c-.02-.037-.047-.112-.064-.316a12.755 12.755 0 0 1-.018-.924v-5.7c0-.432 0-.712.018-.924.017-.204.045-.28.064-.316a.75.75 0 0 1 .328-.328c.037-.02.112-.047.316-.064.212-.017.492-.018.924-.018h5.7c.432 0 .712 0 .924.018.204.017.28.045.317.064a.75.75 0 0 1 .327.328c.02.037.047.112.064.316.017.212.018.492.018.924v5.7c0 .432 0 .712-.018.924-.017.204-.045.28-.064.316a.75.75 0 0 1-.327.328Z"
  })));
};
/* harmony default export */ var copy = (SvgCopy);
;// CONCATENATED MODULE: ./components/Listen.tsx








var Listen = function(param) {
    var playbackOptions = param.playbackOptions;
    var filteredPlaybackOptions = playbackOptions === null || playbackOptions === void 0 ? void 0 : playbackOptions.filter(function(param) {
        var name = param.name;
        return name !== "Personal RSS-Feed";
    });
    var rssPlaybackOption = playbackOptions === null || playbackOptions === void 0 ? void 0 : playbackOptions.find(function(param) {
        var name = param.name;
        return name === "Personal RSS-Feed";
    });
    var ref = (0,react.useState)(false), rssExpanded = ref[0], setRssExpanded = ref[1];
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: "flex items-center gap-4 text-sm font-semibold text-white lg:text-base",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("Listen")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "h-px w-full flex-1 bg-white/[.08]"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "mt-6",
                children: [
                    filteredPlaybackOptions === null || filteredPlaybackOptions === void 0 ? void 0 : filteredPlaybackOptions.map(function(option, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonOrLink/* default */.Z, {
                                href: option.url,
                                target: "_blank",
                                className: "group flex items-center gap-4 rounded focus:shadow-input-focus focus:outline-none focus:ring-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "inline-flex shrink-0 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "sr-only",
                                                children: [
                                                    "$",
                                                    option.name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/assets/".concat(option.icon),
                                                width: "24",
                                                height: "24",
                                                className: "inline-block",
                                                "aria-hidden": "true",
                                                quality: 100
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-1 items-center justify-between gap-4 py-2.5 ".concat(i < (filteredPlaybackOptions === null || filteredPlaybackOptions === void 0 ? void 0 : filteredPlaybackOptions.length) - 1 && "border-b border-white/10"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-semibold",
                                                children: option.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-flex items-center rounded text-xs font-semibold text-white/50 transition group-hover:text-white/70",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t("play_now")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_external, {
                                                        className: "ml-2 h-6 w-6 fill-current"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, i);
                    }),
                    rssPlaybackOption && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-8 space-y-3 text-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-sm font-semibold text-white",
                                children: rssPlaybackOption.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between gap-3 overflow-hidden rounded-xl bg-surface-800 py-2 pl-4 pr-2 text-sm font-medium text-white/90 shadow-input-inactive transition-all",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: !rssExpanded ? "truncate" : "",
                                        onClick: function() {
                                            return setRssExpanded(true);
                                        },
                                        children: rssPlaybackOption.url
                                    }),
                                    !rssExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyToClipboardButton, {
                                        text: rssPlaybackOption.url,
                                        className: "group flex items-center gap-2 text-xs font-semibold text-white/50 transition hover:text-white/70",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("Copy")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(copy, {
                                                className: "fill-white/50 transition group-hover:fill-white/70"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xs text-white/70",
                                children: t("listen_other_description")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Listen = (Listen);

;// CONCATENATED MODULE: ./components/ShowDetailsDialog.tsx








var ShowDetailsDialog = function(param) {
    var show = param.show, _productName = param.productName, productName = _productName === void 0 ? "" : _productName, open = param.open, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        show: open,
        title: show === null || show === void 0 ? void 0 : show.title,
        image: show === null || show === void 0 ? void 0 : show.coverImageUrl,
        smallImage: true,
        onClose: function() {
            return onClose();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-3 flex h-5 items-center justify-center gap-3 overflow-hidden text-[13px]",
                    children: [
                        (show === null || show === void 0 ? void 0 : show.premium) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumBadge, {
                            small: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "whitepsace-nowrap inline truncate text-white/70",
                            children: show === null || show === void 0 ? void 0 : show.details
                        }),
                        (show === null || show === void 0 ? void 0 : show.explicit) && /*#__PURE__*/ (0,jsx_runtime.jsx)(explicit, {
                            className: "inline-block fill-white/70 pt-[1px] align-baseline"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-6 text-white/70",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                        i18nKey: "details_description",
                        children: [
                            "Your ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-white/90",
                                children: show === null || show === void 0 ? void 0 : show.productTitle
                            }),
                            " subscription unlocks",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-white/90",
                                children: show === null || show === void 0 ? void 0 : show.title
                            }),
                            ", listen in your favorite podcast app"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Listen, {
                        playbackOptions: show === null || show === void 0 ? void 0 : show.playbackOptions
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-8 text-xs text-white/70",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                        i18nKey: "contact_support_team",
                        children: [
                            "Please contact our",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonOrLink/* default */.Z, {
                                href: "mailto:help@podspace.com",
                                className: "rounded text-white/90 underline focus:shadow-input-focus focus:outline-none focus:ring-0",
                                children: "Support Team"
                            }),
                            " ",
                            "for any questions."
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_ShowDetailsDialog = (ShowDetailsDialog);

;// CONCATENATED MODULE: ./public/assets/plus.svg
var plus_path;
function plus_extends() { plus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus_extends.apply(this, arguments); }

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/react.createElement("svg", plus_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), plus_path || (plus_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.309 17.212c.091.038.208.038.441.038s.35 0 .441-.038a.5.5 0 0 0 .27-.27c.039-.093.039-.209.039-.442v-3.1c0-.14 0-.21.027-.264a.251.251 0 0 1 .11-.109C12.69 13 12.76 13 12.9 13H16c.233 0 .35 0 .441-.038a.5.5 0 0 0 .27-.27c.039-.092.039-.209.039-.442s0-.35-.038-.441a.5.5 0 0 0-.27-.27c-.093-.039-.209-.039-.442-.039h-3.1c-.14 0-.21 0-.264-.027a.251.251 0 0 1-.109-.11c-.027-.053-.027-.123-.027-.263V8c0-.233 0-.35-.038-.441a.5.5 0 0 0-.27-.27c-.092-.039-.209-.039-.442-.039s-.35 0-.441.038a.5.5 0 0 0-.27.27C11 7.652 11 7.768 11 8v3.1c0 .14 0 .21-.027.264a.251.251 0 0 1-.11.109c-.053.027-.123.027-.263.027H7.5c-.233 0-.35 0-.441.038a.5.5 0 0 0-.27.27c-.039.092-.039.209-.039.442s0 .35.038.441a.5.5 0 0 0 .27.27c.093.039.209.039.442.039h3.1c.14 0 .21 0 .264.027a.251.251 0 0 1 .109.11c.027.053.027.123.027.263v3.1c0 .233 0 .35.038.441a.5.5 0 0 0 .27.27Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ var plus = (SvgPlus);
;// CONCATENATED MODULE: ./components/FAQ/FAQ.tsx




var FAQ = function(param) {
    var question = param.question, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_Row, {
        className: "py-2",
        borderNone: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
            as: "div",
            className: "w-full",
            children: function(param) {
                var open = param.open;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                            className: "group flex w-full items-start justify-between overflow-hidden rounded py-1 text-left font-semibold transition focus:outline-none focus-visible:shadow-input-focus",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "flex-1 ".concat(!open && "truncate"),
                                    children: question
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(plus, {
                                    className: "".concat(open && "rotate-45 text-white/90 group-hover:text-white", " shrink-0 text-white/50 transition group-hover:text-white/70")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                            enter: "origin-top-left transition duration-100 ease-out",
                            enterFrom: "transform scale-95 opacity-0",
                            enterTo: "transform scale-100 opacity-100",
                            leave: "origin-top-left transition duration-75 ease-out",
                            leaveFrom: "transform scale-100 opacity-100",
                            leaveTo: "transform scale-95 opacity-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                className: "py-2 pr-8 text-sm text-white/70 md:text-base md:leading-[24px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-white/70",
                                    children: children
                                })
                            })
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var FAQ_FAQ = (FAQ);

;// CONCATENATED MODULE: ./components/DetailRow/DetailRow.tsx


var DetailRow = function(param) {
    var title = param.title, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_Row, {
        className: "flex-col-reverse !items-start !gap-0 py-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                className: "text-[13px] leading-[24px] text-white/70",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                className: "font-semibold leading-[24px] text-white",
                children: value
            })
        ]
    });
};
/* harmony default export */ var DetailRow_DetailRow = (DetailRow);

;// CONCATENATED MODULE: ./components/ListItem/CheckedListItem.tsx


function CheckedListItem(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex items-start gap-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/assets/check-circle-white.svg",
                "aria-hidden": "true",
                width: 24,
                height: 24,
                alt: "checked bullet",
                quality: 100
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "flex-1",
                children: children
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var src_extends = __webpack_require__(872);
;// CONCATENATED MODULE: ./components/Logos/GooglePodcasts.tsx





function GooglePodcasts(_param) {
    var props = (0,src_extends/* default */.Z)({}, _param);
    var ref = (0,react.useState)(1), step = ref[0], setStep = ref[1];
    (0,react.useEffect)(function() {
        var inerval = setInterval(function() {
            setStep(step >= 3 ? 1 : step + 1);
        }, 2000);
        return function() {
            return clearInterval(inerval);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21,12c0,4.9706-4.0294,9-9,9s-9-4.0294-9-9s4.02944-9,9-9s9,4.02944,9,9ZM13.9134,7.38061c-.9136-.37844-1.9189-.47746-2.8888-.28453s-1.86087.66913-2.56013,1.36839-1.17547,1.59013-1.36839,2.56013-.09391,1.9752.28452,2.8888s1.01931,1.6945,1.84155,2.2439C10.0444,16.7068,11.0111,17,12,17v2c-1.3845,0-2.73785-.4105-3.88899-1.1797s-2.04835-1.8624-2.57816-3.1415-.66844-2.6866-.39834-4.0444.93678-2.60518,1.91575-3.58415s2.22624-1.64565,3.58414-1.91574s2.7653-.13148,4.0444.39834s2.3723,1.42702,3.1415,2.57816s1.1797,2.50449,1.1797,3.88899h-2c0-.9889-.2932-1.9556-.8427-2.77785-.5494-.82224-1.3303-1.46311-2.2439-1.84154ZM12.574,10.6142c-.2741-.1135-.5757-.1433-.8666-.0854s-.5583.2008-.7681.4105c-.2097.2098-.3526.4771-.4105.7681s-.0281.5925.0854.8666.3058.5084.5524.6732.5367.2528.8334.2528v2c-.6922,0-1.3689-.2053-1.9445-.5899-.57557-.3845-1.02417-.9312-1.28908-1.5707s-.33422-1.3433-.19917-2.0222.46839-1.3026.95788-1.79207s1.11317-.82283,1.79207-.95788s1.3827-.06573,2.0222.19917s1.1862.71351,1.5707,1.28908c.3846.5756.5899,1.2523.5899,1.9445h-2c0-.2967-.088-.5867-.2528-.8334s-.3991-.4389-.6732-.5524Z",
                clipRule: "evenodd",
                fill: "#fdfdff",
                fillRule: "evenodd",
                opacity: Number(step == 1),
                style: {
                    transform: "scale(".concat(step == 1 ? 1 : 0, ")"),
                    transformOrigin: "center",
                    transition: "all 400ms cubic-bezier(.47,1.64,.41,.8)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12,21c4.9706,0,9-4.0294,9-9s-4.0294-9-9-9-9,4.02944-9,9s4.02944,9,9,9Zm.6964-14.80357C12.6964,5.8118,12.3846,5.5,12,5.5s-.6964.3118-.6964.69643v.92857c0,.38463.3118.69643.6964.69643s.6964-.3118.6964-.69643v-.92857Zm0,10.67857c0-.3846-.3118-.6964-.6964-.6964s-.6964.3118-.6964.6964v.9286c0,.3846.3118.6964.6964.6964s.6964-.3118.6964-.6964v-.9286Zm2.3215-8.70536c.3846,0,.6964.3118.6964.69643v.92857c0,.38466-.3118.69646-.6964.69646s-.6965-.3118-.6965-.69646v-.92857c0-.38463.3118-.69643.6965-.69643ZM9.67857,14.2054c0-.3847-.3118-.6965-.69643-.6965s-.69643.3118-.69643.6965v.9285c0,.3847.31181.6965.69643.6965s.69643-.3118.69643-.6965v-.9285Zm5.33933-2.7858c.3846,0,.6964.3118.6964.6965v3.0178c0,.3847-.3118.6965-.6964.6965s-.6965-.3118-.6965-.6965v-3.0178c0-.3847.3118-.6965.6965-.6965ZM9.67857,8.86607c0-.38463-.3118-.69643-.69643-.69643s-.69643.3118-.69643.69643v3.01783c0,.3847.31181.6965.69643.6965s.69643-.3118.69643-.6965v-3.01783ZM6.19643,10.8393c.38463,0,.69643.3118.69643.6964v.9286c0,.3846-.3118.6964-.69643.6964s-.69643-.3118-.69643-.6964v-.9286c0-.3846.3118-.6964.69643-.6964Zm10.91067.6964c0-.3846.3118-.6964.6965-.6964s.6964.3118.6964.6964v.9286c0,.3846-.3118.6964-.6964.6964s-.6965-.3118-.6965-.6964v-.9286ZM12,8.75c.3846,0,.6964.3118.6964.69643v5.10717c0,.3846-.3118.6964-.6964.6964s-.6964-.3118-.6964-.6964v-5.10717c0-.38463.3118-.69643.6964-.69643Z",
                transform: "matrix(.5 0 0 0.5 6 6)",
                opacity: Number(step == 2),
                style: {
                    transform: "scale(".concat(step == 2 ? 1 : 0, ")"),
                    transformOrigin: "center",
                    transition: "all 400ms cubic-bezier(.47,1.64,.41,.8)"
                },
                clipRule: "evenodd",
                fill: "#fdfdff",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21,12c0,4.9706-4.0294,9-9,9s-9-4.0294-9-9s4.02944-9,9-9s9,4.02944,9,9ZM14.3398,8.75574c-.6851-.49412-1.5091-.75866-2.3538-.75572s-1.6668.27324-2.34842.77214-1.18787,1.20078-1.4461,2.00504-.2552,1.6697.00863,2.4721.77494,1.5008,1.46006,1.995L8.19778,17.2719c-1.11332-.8029-1.94387-1.9377-2.3726-3.2417s-.43364-2.7103-.01402-4.0172s1.24222-2.44754,2.3499-3.25824s2.44364-1.24993,3.81624-1.25472s2.7116.42509,3.8249,1.22805s1.9439,1.93774,2.3726,3.24173.4337,2.71028.014,4.01718-1.2422,2.4475-2.3499,3.2582l-1.4765-2.0174c.6817-.4989,1.1879-1.2007,1.4461-2.005s.2552-1.6697-.0086-2.4721-.7749-1.50083-1.4601-1.99496ZM13.5,12c0,.8284-.6716,1.5-1.5,1.5s-1.5-.6716-1.5-1.5.6716-1.5,1.5-1.5s1.5.6716,1.5,1.5Z",
                transform: "matrix(.5 0 0 0.5 6 6)",
                opacity: Number(step == 3),
                style: {
                    transform: "scale(".concat(step == 3 ? 1 : 0, ")"),
                    transformOrigin: "center",
                    transition: "all 400ms cubic-bezier(.47,1.64,.41,.8)"
                },
                clipRule: "evenodd",
                fill: "#fdfdff",
                fillRule: "evenodd"
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./components/Button/PremiumButton.tsx





function PremiumButton(_param) {
    var className = _param.className, importance = _param.importance, size = _param.size, fullWidth = _param.fullWidth, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "importance",
        "size",
        "fullWidth"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative overflow-hidden isolate flex items-center p-[1px] rounded-2xl bg-gradient-to-b from-[#131619] via-[#0F1215] to-[#0E1114] shadow-btn-premium focus-within:ring-2 focus-within:ring-white/20 ".concat(props.disabled ? "shadow-btn-dark-inactive" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                className: "absolute transition animate-slide",
                width: "246",
                height: "203",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        filter: "url(#a)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M134.985 85.068c50.641 38.409 86.125 76.888 79.255 85.947-6.87 9.058-53.493-14.735-104.134-53.144-50.642-38.409-86.125-76.889-79.255-85.947 6.87-9.058 53.493 14.735 104.134 53.144Z",
                            fill: "url(#b)",
                            fillOpacity: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                id: "b",
                                x1: "30.851",
                                y1: "31.924",
                                x2: "214.24",
                                y2: "171.015",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        stopColor: "#FDFDFF"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#FDFDFF",
                                        stopOpacity: ".5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                                id: "a",
                                x: "0",
                                y: "0",
                                width: "245.091",
                                height: "202.939",
                                filterUnits: "userSpaceOnUse",
                                colorInterpolationFilters: "sRGB",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                        floodOpacity: "0",
                                        result: "BackgroundImageFix"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                        in: "SourceGraphic",
                                        in2: "BackgroundImageFix",
                                        result: "shape"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                        stdDeviation: "15",
                                        result: "effect1_foregroundBlur_641_13315"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonOrLink/* default */.Z, (0,_object_spread/* default */.Z)({
                className: "relative " + (0,Button_Button/* buttonStyles */.$)({
                    className: className,
                    importance: importance,
                    size: size,
                    fullWidth: fullWidth
                })
            }, props))
        ]
    });
}

// EXTERNAL MODULE: ./components/RadioGroup/RadioGroup.tsx
var RadioGroup = __webpack_require__(7237);
;// CONCATENATED MODULE: ./public/assets/arrow-right.svg
var arrow_right_path;
function arrow_right_extends() { arrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_right_extends.apply(this, arguments); }

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_right_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrow_right_path || (arrow_right_path = /*#__PURE__*/react.createElement("path", {
    clipRule: "evenodd",
    d: "M17.809 11.684c.198.198.297.297.334.412a.5.5 0 0 1 0 .309c-.037.114-.136.213-.334.41l-4.376 4.376c-.164.165-.247.247-.338.285a.5.5 0 0 1-.383 0c-.092-.038-.174-.12-.34-.285-.164-.165-.246-.247-.284-.34a.5.5 0 0 1 0-.382c.038-.092.12-.174.285-.339l3.13-3.13H6.75c-.233 0-.35 0-.441-.038a.5.5 0 0 1-.27-.27C6 12.6 6 12.482 6 12.25s0-.35.038-.441a.5.5 0 0 1 .27-.27c.093-.039.209-.039.442-.039h8.753l-3.13-3.13c-.165-.165-.247-.247-.285-.34a.5.5 0 0 1 0-.382c.038-.092.12-.174.285-.339.165-.165.247-.247.339-.285a.5.5 0 0 1 .383 0c.091.038.174.12.338.285l4.376 4.375Z"
  })));
};
/* harmony default export */ var arrow_right = (SvgArrowRight);
;// CONCATENATED MODULE: ./public/assets/stripe.svg
var _g, _defs;
function stripe_extends() { stripe_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stripe_extends.apply(this, arguments); }

var SvgStripe = function SvgStripe(props) {
  return /*#__PURE__*/react.createElement("svg", stripe_extends({
    width: 41,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#stripe_svg__a)",
    fill: "#FDFDFF"
  }, /*#__PURE__*/react.createElement("path", {
    d: "m19.38 2.638 2.637-.551V0l-2.638.55v2.088ZM8.152 1.787l2.56-.56.02 2.338h1.99v2.261h-1.99v3.865c0 1.604 1.652 1.11 1.99.966v2.174a4.02 4.02 0 0 1-1.845.357 2.676 2.676 0 0 1-2.725-2.773V1.787ZM16.075 3.45l.164.792a1.74 1.74 0 0 1 2.164-.793v2.464a1.807 1.807 0 0 0-1.98.56v6.358h-2.59V3.449h2.242Z"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.833 3.343a2.898 2.898 0 0 0-2.058.84l-.135-.666h-2.31V16l2.629-.57v-3.024a2.899 2.899 0 0 0 1.865.676c1.874 0 3.594-1.536 3.594-4.937 0-3.111-1.74-4.802-3.585-4.802Zm-.628 7.372a1.555 1.555 0 0 1-1.236-.502V6.24a1.585 1.585 0 0 1 1.256-.53c.966 0 1.623 1.09 1.623 2.492 0 1.4-.667 2.512-1.643 2.512ZM36.268 3.343c-2.531 0-4.068 2.184-4.068 4.937 0 3.256 1.817 4.908 4.406 4.908a5.914 5.914 0 0 0 2.899-.705v-2.174a5.594 5.594 0 0 1-2.609.6c-1.043 0-1.932-.378-2.068-1.643h5.198v-.967c.087-2.772-1.227-4.956-3.758-4.956Zm-1.42 3.932c0-1.217.744-1.73 1.4-1.73.658 0 1.353.513 1.353 1.73h-2.753Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M3.157 6.27c0-.425.348-.589.899-.589a5.7 5.7 0 0 1 2.608.696V3.836a6.763 6.763 0 0 0-2.608-.493C1.92 3.343.5 4.483.5 6.396c0 1.81 1.46 2.35 2.616 2.777.757.28 1.384.512 1.384 1.02 0 .503-.425.667-.966.667a6.55 6.55 0 0 1-2.899-.87v2.6a7.13 7.13 0 0 0 2.899.618c2.183 0 3.69-1.111 3.69-3.053C7.195 8.143 5.64 7.6 4.463 7.189c-.723-.252-1.305-.455-1.305-.919ZM19.38 3.517h2.637v9.314h-2.638V3.517Z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "stripe_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h40v16H0z"
  })))));
};
/* harmony default export */ var stripe = (SvgStripe);
;// CONCATENATED MODULE: ./components/ListItem/EpisodeListItem.tsx




function EpisodeListItem(param) {
    var episode = param.episode;
    var ref = (0,esm/* useTranslation */.$G)("common"), t = ref.t, i18n = ref.i18n;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex w-full items-center gap-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "group flex flex-1 items-center justify-between gap-4 rounded-md text-left focus:outline-none focus-visible:shadow-input-focus",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-14 w-14 shrink-0 rounded-md ".concat(episode.image_url ? "" : "bg-white/50"),
                                children: episode.image_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative flex h-14 w-14 items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        layout: "fill",
                                        className: "flex h-14 w-14 shrink-0  rounded-md transition",
                                        src: episode.image_url,
                                        alt: episode.title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "transition duration-500 group-hover:translate-x-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-semibold text-white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "block whitespace-normal ",
                                            children: episode.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-wrap items-center text-[13px] text-white/70",
                                        children: [
                                            formatRelativeDate(episode.published_at, i18n.language),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-white/50 md:hidden lg:flex",
                                                children: [
                                                    "\xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-light text-white/70",
                                                        children: " • "
                                                    }),
                                                    "\xa0",
                                                    t("Episode")
                                                ]
                                            }),
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden shrink-0 whitespace-nowrap text-[13px] font-medium text-white/50 lg:block",
                        children: formatEpisodeDuration(episode.duration)
                    })
                ]
            })
        })
    }, episode.id);
}

;// CONCATENATED MODULE: ./components/ProductDetails.tsx














function ProductDetails(param) {
    var data = param.data, productName = param.productName, trialDays = param.trialDays, selectedPaymentOption = param.selectedPaymentOption, setSelectedPaymentOption = param.setSelectedPaymentOption, setIsSignupDialogOpen = param.setIsSignupDialogOpen, setIsSigninDialogOpen = param.setIsSigninDialogOpen, slug = param.slug;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var ref15 = (0,esm/* useTranslation */.$G)("common"), t = ref15.t, i18n = ref15.i18n;
    var promotion = (ref = data.page) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.promotion;
    var formatDisplayPrice = (0,react.useCallback)(function(price, currency) {
        var hasDecimals = price % 1 !== 0;
        return price.toLocaleString(i18n.language, {
            currency: currency,
            currencySign: "accounting",
            currencyDisplay: "narrowSymbol",
            style: "currency",
            minimumFractionDigits: hasDecimals ? 2 : 0,
            maximumFractionDigits: hasDecimals ? 2 : 0
        });
    }, [
        i18n.language
    ]);
    var selectedPayementDisplayPrice = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        var purchaseOption = data === null || data === void 0 ? void 0 : (ref = data.page) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.purchaseOptions.find(function(param) {
            var identifier = param.identifier;
            return identifier == selectedPaymentOption;
        });
        var displayPrice = purchaseOption === null || purchaseOption === void 0 ? void 0 : (ref2 = purchaseOption.price) === null || ref2 === void 0 ? void 0 : ref2.displayPrice;
        if (promotion && (purchaseOption === null || purchaseOption === void 0 ? void 0 : (ref3 = purchaseOption.price) === null || ref3 === void 0 ? void 0 : ref3.price)) {
            if (promotion.percentOff) {
                var ref4, ref5, ref6;
                var price = (purchaseOption === null || purchaseOption === void 0 ? void 0 : (ref4 = purchaseOption.price) === null || ref4 === void 0 ? void 0 : ref4.price) - (purchaseOption === null || purchaseOption === void 0 ? void 0 : (ref5 = purchaseOption.price) === null || ref5 === void 0 ? void 0 : ref5.price) * promotion.percentOff / 100;
                return formatDisplayPrice(price, (purchaseOption === null || purchaseOption === void 0 ? void 0 : (ref6 = purchaseOption.price) === null || ref6 === void 0 ? void 0 : ref6.currency) || "");
            }
            if (promotion.amountOff) {
                var ref7;
                var price1 = (purchaseOption === null || purchaseOption === void 0 ? void 0 : (ref7 = purchaseOption.price) === null || ref7 === void 0 ? void 0 : ref7.price) - promotion.amountOff;
                return formatDisplayPrice(price1, promotion.currency || "");
            }
        }
        return displayPrice;
    }, [
        data === null || data === void 0 ? void 0 : (ref2 = data.page) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.product) === null || ref3 === void 0 ? void 0 : ref3.purchaseOptions,
        formatDisplayPrice,
        promotion,
        selectedPaymentOption
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "font-display text-[32px] font-bold leading-none lg:text-[40px]",
                children: trialDays > 0 ? t("subscribe_header_trial") : t("subscribe_header")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-6 text-white/70",
                children: trialDays > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                    i18nKey: "subscribe_subheader_trial",
                    children: [
                        "Enjoy ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-white/90",
                            children: data === null || data === void 0 ? void 0 : data.page.hero.title
                        }),
                        " for free until",
                        " ",
                        data === null || data === void 0 ? void 0 : data.page.product.purchaseOptions[0].startDate,
                        ", then only",
                        " ",
                        data === null || data === void 0 ? void 0 : data.page.product.purchaseOptions[0].price.displayPrice,
                        " per month thereafter."
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                    i18nKey: "subscribe_subheader",
                    children: [
                        "Enjoy ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-white/90",
                            children: data === null || data === void 0 ? void 0 : data.page.hero.title
                        }),
                        " for only",
                        " ",
                        data === null || data === void 0 ? void 0 : data.page.product.purchaseOptions[0].price.displayPrice,
                        " per month."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-white/70",
                children: t("subscribe_subheader2")
            }),
            slug == "thirdear" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-white/70",
                children: "Har du en promokod s\xe5 fyller du den i n\xe4sta steg."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mt-6 list-none space-y-4 font-medium lg:mt-8",
                children: data === null || data === void 0 ? void 0 : (ref4 = data.page) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.product) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.features) === null || ref6 === void 0 ? void 0 : ref6.map(function(checkedListItem, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            checkedListItem.type === "text" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedListItem, {
                                children: checkedListItem.content
                            }, index),
                            checkedListItem.type === "episode" && checkedListItem.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(EpisodeListItem, {
                                episode: JSON.parse(checkedListItem.data)
                            }, index),
                            checkedListItem.type === "localized_key" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedListItem, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "flex items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                                        i18nKey: "listen on",
                                        children: [
                                            "Listen on\xa0",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipOnHover, {
                                                text: t("spotify"),
                                                className: "h-6 w-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    unoptimized: true,
                                                    alt: "spotify",
                                                    loading: "eager",
                                                    src: "/assets/app-spotify-colorized.png",
                                                    width: "24",
                                                    height: "24",
                                                    className: "inline-block transition hover:scale-90",
                                                    "aria-hidden": "true",
                                                    quality: 100
                                                })
                                            }),
                                            ", \xa0",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipOnHover, {
                                                text: t("apple_podcasts"),
                                                className: "h-6 w-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    alt: "apple podcasts",
                                                    unoptimized: true,
                                                    loading: "eager",
                                                    src: "/assets/app-apple-podcast-colorized.png",
                                                    width: "24",
                                                    height: "24",
                                                    className: "inline-block transition hover:scale-90",
                                                    "aria-hidden": "true",
                                                    quality: 100
                                                })
                                            }),
                                            "and \xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GooglePodcasts, {
                                                className: "h-6 w-6"
                                            })
                                        ]
                                    })
                                })
                            }, index)
                        ]
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                        name: "select-plan",
                        defaultValue: selectedPaymentOption,
                        onChange: setSelectedPaymentOption,
                        label: t("choose_plan"),
                        children: data === null || data === void 0 ? void 0 : (ref7 = data.page) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.product) === null || ref8 === void 0 ? void 0 : ref8.purchaseOptions.map(function(option) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
                            var optionPrice = option.price.price;
                            if ((ref = data.page) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.promotion) {
                                var ref13, ref14, ref15, ref16, ref17, ref18;
                                if ((ref13 = data.page) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.product) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.promotion) === null || ref15 === void 0 ? void 0 : ref15.amountOff) {
                                    var ref19, ref20, ref21;
                                    optionPrice = option.price.price - ((ref19 = data.page) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.product) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.promotion) === null || ref21 === void 0 ? void 0 : ref21.amountOff);
                                }
                                if ((ref16 = data.page) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.product) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.promotion) === null || ref18 === void 0 ? void 0 : ref18.percentOff) {
                                    var ref22, ref23, ref24;
                                    optionPrice = option.price.price - option.price.price * ((ref22 = data.page) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.product) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.promotion) === null || ref24 === void 0 ? void 0 : ref24.percentOff) / 100;
                                }
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* RadioGroupItem */.m, {
                                id: option.identifier,
                                value: option.identifier,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "",
                                        children: t(option.name)
                                    }),
                                    ((ref2 = data.page) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.product) === null || ref3 === void 0 ? void 0 : ref3.promotion) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "ml-3 rounded-lg px-1.5 py-1 text-xs text-white/50 ring-2 ring-inset ring-white/10 transition ui-checked:bg-gradient-to-b ui-checked:from-[#3377FF] ui-checked:to-[#0055FF] ui-checked:text-white ui-checked:ring-transparent",
                                        children: [
                                            "-",
                                            " ",
                                            ((ref4 = data.page) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.product) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.promotion) === null || ref6 === void 0 ? void 0 : ref6.percentOff) ? ((ref7 = data.page) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.product) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.promotion) === null || ref9 === void 0 ? void 0 : ref9.percentOff) + "%" : ((ref10 = data.page.product.promotion) === null || ref10 === void 0 ? void 0 : ref10.amountOff) && formatDisplayPrice((ref11 = data.page.product.promotion) === null || ref11 === void 0 ? void 0 : ref11.amountOff, (ref12 = data.page.product.promotion) === null || ref12 === void 0 ? void 0 : ref12.currency)
                                        ]
                                    }),
                                    option.identifier == "1a64e5f5-e662-4bc9-8e69-5b7155dae8f6" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-3 rounded-lg px-1.5 py-1 text-xs text-white/50 ring-2 ring-inset ring-white/10 transition ui-checked:bg-gradient-to-b ui-checked:from-[#3377FF] ui-checked:to-[#0055FF] ui-checked:text-white ui-checked:ring-transparent",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                            children: formatDisplayPrice(79, "SEK")
                                        })
                                    }),
                                    option.identifier == "9f5c648d-9b74-4f6c-9daa-41c0118e7515" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-3 rounded-lg px-1.5 py-1 text-xs text-white/50 ring-2 ring-inset ring-white/10 transition ui-checked:bg-gradient-to-b ui-checked:from-[#3377FF] ui-checked:to-[#0055FF] ui-checked:text-white ui-checked:ring-transparent",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                            children: formatDisplayPrice(790, "SEK")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "ml-auto text-white/50 transition group-hover:!text-white ui-checked:text-white/90",
                                        children: [
                                            formatDisplayPrice(optionPrice, option.price.currency),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-sm font-medium text-white/50 transition group-hover:text-white ui-checked:text-white/90",
                                                children: [
                                                    "/",
                                                    t(option.billingFrequency.toLowerCase())
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, option.identifier);
                        })
                    }),
                    trialDays > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PremiumButton, {
                                    fullWidth: true,
                                    size: "large",
                                    importance: "premium",
                                    onClick: function() {
                                        return setIsSignupDialogOpen(true);
                                    },
                                    children: [
                                        t("start_trial_button", {
                                            days: data === null || data === void 0 ? void 0 : data.page.product.purchaseOptions[0].trialDays
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right, {
                                            className: "ml-2 fill-white"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mt-6 text-center text-xs text-white/70",
                                children: [
                                    promotion && promotion.duration && t("start_trial_description_with_promotion", {
                                        title: productName,
                                        trialDays: trialDays,
                                        promoPrice: selectedPayementDisplayPrice,
                                        promoDuration: promotion.duration,
                                        price: (ref11 = data === null || data === void 0 ? void 0 : (ref9 = data.page) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.product) === null || ref10 === void 0 ? void 0 : ref10.purchaseOptions.find(function(param) {
                                            var identifier = param.identifier;
                                            return identifier == selectedPaymentOption;
                                        })) === null || ref11 === void 0 ? void 0 : ref11.price.displayPrice,
                                        interval: selectedPaymentOption == (data === null || data === void 0 ? void 0 : data.page.product.purchaseOptions[0].identifier) ? t("month") : t("year")
                                    }),
                                    promotion && !promotion.duration && t("start_trial_description", {
                                        title: productName,
                                        trialDays: trialDays,
                                        price: selectedPayementDisplayPrice,
                                        interval: selectedPaymentOption == (data === null || data === void 0 ? void 0 : data.page.product.purchaseOptions[0].identifier) ? t("month") : t("year")
                                    }),
                                    !promotion && t("start_trial_description", {
                                        title: productName,
                                        trialDays: trialDays,
                                        price: (ref14 = data === null || data === void 0 ? void 0 : (ref12 = data.page) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.product) === null || ref13 === void 0 ? void 0 : ref13.purchaseOptions.find(function(param) {
                                            var identifier = param.identifier;
                                            return identifier == selectedPaymentOption;
                                        })) === null || ref14 === void 0 ? void 0 : ref14.price.displayPrice,
                                        interval: selectedPaymentOption == (data === null || data === void 0 ? void 0 : data.page.product.purchaseOptions[0].identifier) ? t("month") : t("year")
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PremiumButton, {
                            fullWidth: true,
                            size: "large",
                            importance: "premium",
                            onClick: function() {
                                return setIsSignupDialogOpen(true);
                            },
                            children: [
                                t("subscribe_header"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right, {
                                    className: "ml-2 fill-white"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-center text-xs text-white/70",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lock, {
                                title: "secure payments",
                                className: "mr-2 inline-block fill-white/70"
                            }),
                            t("secure_payments"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stripe, {
                                title: "stripe",
                                className: "ml-[6px] inline-block"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-10 flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            className: "w-full lg:mx-auto lg:w-auto",
                            size: "small",
                            importance: "secondary",
                            onClick: function() {
                                return setIsSigninDialogOpen(true);
                            },
                            children: t("sign_in_button")
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
;// CONCATENATED MODULE: ./public/assets/chevron-right.svg
var chevron_right_path;
function chevron_right_extends() { chevron_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_right_extends.apply(this, arguments); }

var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_right_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), chevron_right_path || (chevron_right_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.495 11.434c.198.198.297.297.334.412a.5.5 0 0 1 0 .309c-.037.114-.136.213-.334.41L10.53 16.53c-.164.165-.247.247-.339.285a.5.5 0 0 1-.382 0c-.092-.038-.175-.12-.34-.285-.164-.164-.246-.247-.284-.339a.5.5 0 0 1 0-.382c.038-.092.12-.175.285-.34l3.186-3.186c.1-.1.149-.149.167-.206a.249.249 0 0 0 0-.154c-.018-.057-.068-.107-.167-.206L9.47 8.53c-.165-.164-.247-.247-.286-.339a.5.5 0 0 1 0-.382c.039-.092.12-.175.286-.34.164-.164.247-.246.339-.284a.5.5 0 0 1 .382 0c.092.038.175.12.34.285l3.964 3.964Z"
  })));
};
/* harmony default export */ var chevron_right = (SvgChevronRight);
;// CONCATENATED MODULE: ./public/assets/link-slash.svg
var link_slash_path;
function link_slash_extends() { link_slash_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return link_slash_extends.apply(this, arguments); }

var SvgLinkSlash = function SvgLinkSlash(props) {
  return /*#__PURE__*/react.createElement("svg", link_slash_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: "link-slash_svg__size-6"
  }, props), link_slash_path || (link_slash_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M19.892 4.09a3.75 3.75 0 0 0-5.303 0l-4.5 4.5c-.074.074-.144.15-.21.229l4.965 4.966a3.75 3.75 0 0 0-1.986-4.428.75.75 0 0 1 .646-1.353 5.253 5.253 0 0 1 2.502 6.944l5.515 5.515a.75.75 0 0 1-1.061 1.06l-18-18.001A.75.75 0 0 1 3.521 2.46l5.294 5.295a5.31 5.31 0 0 1 .213-.227l4.5-4.5a5.25 5.25 0 1 1 7.425 7.425l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.756-1.757a3.75 3.75 0 0 0 0-5.304ZM5.846 11.773a.75.75 0 0 1 0 1.06l-1.757 1.758a3.75 3.75 0 0 0 5.303 5.304l3.129-3.13a.75.75 0 1 1 1.06 1.061l-3.128 3.13a5.25 5.25 0 1 1-7.425-7.426l1.757-1.757a.75.75 0 0 1 1.061 0Zm2.401.26a.75.75 0 0 1 .957.458c.18.512.474.992.885 1.403.31.311.661.555 1.035.733a.75.75 0 0 1-.647 1.354 5.244 5.244 0 0 1-1.449-1.026 5.232 5.232 0 0 1-1.24-1.965.75.75 0 0 1 .46-.957Z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ var link_slash = (SvgLinkSlash);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/ArrowPathIcon.js
var ArrowPathIcon = __webpack_require__(6558);
// EXTERNAL MODULE: ./node_modules/strftime/strftime.js
var strftime = __webpack_require__(2001);
var strftime_default = /*#__PURE__*/__webpack_require__.n(strftime);
;// CONCATENATED MODULE: ./gql/graphql.ts
/* eslint-disable */ var BillingFrequency;
(function(BillingFrequency) {
    BillingFrequency["Monthly"] = "MONTHLY";
    BillingFrequency["OneTime"] = "ONE_TIME";
    BillingFrequency["Weekly"] = "WEEKLY";
    BillingFrequency["Yearly"] = "YEARLY";
})(BillingFrequency || (BillingFrequency = {}));
var SubscriptionStatus;
(function(SubscriptionStatus) {
    SubscriptionStatus["Active"] = "ACTIVE";
    SubscriptionStatus["Cancelled"] = "CANCELLED";
    SubscriptionStatus["Expired"] = "EXPIRED";
    SubscriptionStatus["InTrial"] = "IN_TRIAL";
})(SubscriptionStatus || (SubscriptionStatus = {}));
var PageDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "page"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "slug"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "resourceId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    },
                    "defaultValue": {
                        "kind": "NullValue"
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "promoCode"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    },
                    "defaultValue": {
                        "kind": "NullValue"
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "page"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "slug"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "slug"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "resourceId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "resourceId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "promoCode"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "promoCode"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "language"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "hero"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "author"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "badgeTitle"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "explicit"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "iconUrl"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "mediaUrl"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subtitle"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "title"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "metadata"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "contentBlocks"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "content"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "title"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "data"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "type"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "product"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "promotion"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "name"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "description"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "code"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "percentOff"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "duration"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "amountOff"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "currency"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shows"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "title"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "coverImageUrl"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "features"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "content"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "type"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "data"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "purchaseOptions"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "billingFrequency"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "checkoutUrl"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "trialDays"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "startDate"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "displayPrice"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "price"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "price"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "currency"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "displayPrice"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "name"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "identifier"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
var Create_UserDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CREATE_USER"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "email"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "paymentOptionId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "userCreate"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "email"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "email"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "paymentOptionId"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "paymentOptionId"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "result"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "session"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "email"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "authToken"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
var User_Unlink_SpotifyDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "USER_UNLINK_SPOTIFY"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "authToken"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "userUnlinkSpotify"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "token"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "authToken"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "result"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
var Get_User_VerifyDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GET_USER_VERIFY"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "code"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "slug"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "userVerify"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "verificationCode"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "code"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "slug"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "slug"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "email"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "authToken"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscription"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
var Get_SubscriptionDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GET_SUBSCRIPTION"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "authToken"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "slug"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "resourceId"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscription"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "slug"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "slug"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "token"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "authToken"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "resourceId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "resourceId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastPayment"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "nextBillingAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "trialPeriodEndsAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "cancelAt"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "spotifyConnected"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "reference"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "status"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "manageUrl"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "premiumUserEmail"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "product"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shows"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "title"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "coverImageUrl"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "subtitle"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "explicit"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "playbackOptions"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "icon"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "url"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "discount"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "endTime"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "discountFormatted"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "purchaseOption"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "price"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "price"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "currency"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "trialDays"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "billingFrequency"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
var Signin_UserDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "SIGNIN_USER"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "email"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "slug"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "userSignIn"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "email"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "email"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "slug"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "slug"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "result"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};

;// CONCATENATED MODULE: ./components/SubscriptionDetailRow/SubscriptionDetailRow.tsx



var SubscriptionDetailRow = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "border-b border-white/10 py-3 ".concat(className),
        children: children
    });
};
var SubscriptionDetailTitleRow = function(param) {
    var first = param.first, second = param.second;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-start justify-between gap-x-4 font-medium font-semibold leading-[24px] text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "min-w-0 break-words",
                children: first
            }),
            second
        ]
    });
};
var SubscriptionDetailSubtitleRow = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-[13px] leading-[24px] ".concat(className),
        children: children
    });
};
var CopyIcon = function(param) {
    var srText = param.srText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "inline-flex items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: srText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(copy, {
                className: "h-6 w-6 fill-white/50 transition group-hover:fill-white/70",
                "aria-hidden": "true"
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/SubscriptionDetailTable/Components/CustomerSupportMessage.tsx



function CustomerSupportMessage() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "mt-2 text-xs text-white/70",
        children: [
            t("customer_support_prefix"),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonOrLink/* default */.Z, {
                href: "mailto:help@podspace.com",
                className: "rounded text-white underline transition hover:text-white/70 focus:shadow-input-focus focus:outline-none focus:ring-0",
                children: t("customer_support")
            }),
            " ",
            t("customer_support_suffix"),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonOrLink/* default */.Z, {
                href: "#faq",
                className: "rounded text-white underline transition hover:text-white/70 focus:shadow-input-focus focus:outline-none focus:ring-0",
                smoothScroll: true,
                children: t("faq")
            }),
            "."
        ]
    });
}

;// CONCATENATED MODULE: ./components/SubscriptionDetailTable/Components/CancellationMessage.tsx




function CancellationMessage(param) {
    var subscription = param.subscription;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-6 text-xs text-white/70",
                children: t("cancellation_message", {
                    date: strftime_default()("%B %d, %Y", new Date(subscription.cancelAt))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSupportMessage, {})
        ]
    });
}

;// CONCATENATED MODULE: ./components/SubscriptionDetailTable/SubscriptionDetailTable.tsx









function SubscriptionDetailTable(param) {
    var subscription = param.subscription;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            subscription.status === SubscriptionStatus.InTrial && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubscriptionDetailRow, {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetailTitleRow, {
                        first: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("days_free_trial", {
                                days: subscription.purchaseOption.trialDays
                            })
                        }),
                        second: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                t("free"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-white/70",
                                    children: "(0,00 kr)"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubscriptionDetailSubtitleRow, {
                        className: "text-comp-yellow-600",
                        children: [
                            t("ending"),
                            " ",
                            strftime_default()("%B %d, %Y", new Date(subscription.trialPeriodEndsAt))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubscriptionDetailRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetailTitleRow, {
                        first: subscription.purchaseOption.billingFrequency === BillingFrequency.Monthly ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                t("Monthly"),
                                " ",
                                t("subscription")
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                t("Yearly"),
                                " ",
                                t("subscription")
                            ]
                        }),
                        second: Intl.NumberFormat("sv-SE", {
                            style: "currency",
                            currency: subscription.purchaseOption.price.currency || "kr"
                        }).format(Number(subscription.purchaseOption.price.price))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubscriptionDetailSubtitleRow, {
                        className: "text-white/50",
                        children: [
                            subscription.status === SubscriptionStatus.InTrial && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    t("starting"),
                                    " ",
                                    strftime_default()("%B %d, %Y", new Date(subscription.nextBillingAt))
                                ]
                            }),
                            subscription.status === SubscriptionStatus.Active && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    t("next_billing"),
                                    " ",
                                    strftime_default()("%B %d, %Y", new Date(subscription.nextBillingAt))
                                ]
                            })
                        ]
                    })
                ]
            }),
            subscription.premiumUserEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetailRow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyToClipboardButton, {
                    text: subscription.premiumUserEmail,
                    className: "group w-full rounded text-left focus:shadow-input-focus focus:outline-none focus:ring-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetailTitleRow, {
                            first: subscription.premiumUserEmail,
                            second: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyIcon, {
                                srText: t("copy_email_address")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetailSubtitleRow, {
                            className: "text-white/50",
                            children: t("account")
                        })
                    ]
                })
            }),
            subscription.discount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubscriptionDetailRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetailTitleRow, {
                        first: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("discount")
                        }),
                        second: subscription.discount.discountFormatted
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubscriptionDetailSubtitleRow, {
                        className: "text-comp-yellow-600",
                        children: [
                            t("code"),
                            ": ",
                            subscription.discount.name,
                            subscription.discount.endTime && ", ".concat(t("ending"), " ").concat(strftime_default()("%B %d, %Y", new Date(subscription.discount.endTime)))
                        ]
                    })
                ]
            }),
            subscription.reference && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetailRow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyToClipboardButton, {
                    text: subscription.reference || "",
                    className: "group w-full rounded text-left focus:shadow-input-focus focus:outline-none focus:ring-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetailTitleRow, {
                            first: subscription.reference,
                            second: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyIcon, {
                                srText: t("copy_reference_code")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetailSubtitleRow, {
                            className: "text-white/50",
                            children: t("reference_code")
                        })
                    ]
                })
            }),
            subscription.cancelAt ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancellationMessage, {
                subscription: subscription
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    subscription.nextBillingAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-6 text-xs text-white/70",
                        children: t("renewal_message", {
                            date: strftime_default()("%B %d, %Y", new Date(subscription.nextBillingAt))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mt-2 text-xs text-white/70",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonOrLink/* default */.Z, {
                                href: subscription.manageUrl,
                                className: "rounded text-white underline transition hover:text-white/70 focus:shadow-input-focus focus:outline-none focus:ring-0",
                                children: t("cancel_subscription")
                            }),
                            " ",
                            t("cancel_hint")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSupportMessage, {})
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/SubscriptionDetails.tsx

















function SubscriptionDetails(param) {
    var subscriptionData = param.subscriptionData, data = param.data, multipleShows = param.multipleShows, displayShowDetailsDialog = param.displayShowDetailsDialog, token = param.token;
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref5 = (0,react.useState)(false), showSpotifyUnlinkedToast = ref5[0], setShowSpotifyUnlinkedToast = ref5[1];
    var ref6 = (0,react.useState)(false), isSpotifyUnlinked = ref6[0], setIsSpotifyUnlinked = ref6[1];
    var ref7 = (0,react.useState)(false), isUnlinkingSpotify = ref7[0], setIsUnlinkingSpotify = ref7[1];
    var unlinkSpotify = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsUnlinkingSpotify(true);
                        return [
                            4,
                            fetch("/api/unlink-spotify", {
                                method: "POST",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    authToken: token
                                })
                            }).then(function(res) {
                                return res.json();
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response) {
                            setIsUnlinkingSpotify(false);
                            setShowSpotifyUnlinkedToast(true);
                            setIsSpotifyUnlinked(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function unlinkSpotify() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast, {
                show: showSpotifyUnlinkedToast,
                onClose: function() {
                    return setShowSpotifyUnlinkedToast(false);
                },
                children: "Spotify successfully unlinked"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "font-display text-[32px] font-bold leading-none lg:text-[40px]",
                children: t("subscribed_header")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mt-6 text-white/70",
                children: [
                    t("subscribed_subheader1"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-white/90",
                        children: subscriptionData === null || subscriptionData === void 0 ? void 0 : (ref = subscriptionData.subscription) === null || ref === void 0 ? void 0 : ref.product.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-white/70",
                children: t("subscribed_subheader2")
            }),
            !multipleShows && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Listen, {
                    playbackOptions: (ref1 = subscriptionData.subscription) === null || ref1 === void 0 ? void 0 : ref1.product.shows[0].playbackOptions
                })
            }),
            multipleShows && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mt-11",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "flex items-center gap-4 text-sm font-semibold text-white lg:text-base",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("shows")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h-px w-full flex-1 bg-white/[.08]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mt-6 space-y-5",
                        children: subscriptionData === null || subscriptionData === void 0 ? void 0 : (ref2 = subscriptionData.subscription) === null || ref2 === void 0 ? void 0 : ref2.product.shows.map(function(show, i) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonOrLink/* default */.Z, {
                                    onClick: function() {
                                        var ref, ref1;
                                        return displayShowDetailsDialog({
                                            title: show.title,
                                            productTitle: data === null || data === void 0 ? void 0 : (ref = data.page) === null || ref === void 0 ? void 0 : ref.hero.title,
                                            coverImageUrl: show.coverImageUrl,
                                            details: data === null || data === void 0 ? void 0 : (ref1 = data.page) === null || ref1 === void 0 ? void 0 : ref1.hero.metadata.join("・"),
                                            premium: true,
                                            explicit: show.explicit,
                                            playbackOptions: show.playbackOptions
                                        });
                                    },
                                    className: "group flex w-full items-center gap-4 rounded focus:shadow-input-focus focus:outline-none focus:ring-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "h-14 w-14 shrink-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "w-l4 h-14 rounded",
                                                src: show.coverImageUrl || "",
                                                width: "56",
                                                height: "56",
                                                quality: 100,
                                                alt: "Cover image for " + show.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex-1 overflow-hidden",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center justify-between gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-semibold",
                                                            children: show.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right, {
                                                            className: "h-6 w-6 fill-white/50 transition group-hover:fill-white/90"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "mt-0.5 flex text-[13px] font-medium text-white/70 md:text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "truncate",
                                                            children: show.subtitle
                                                        }),
                                                        show.explicit && /*#__PURE__*/ (0,jsx_runtime.jsx)(explicit, {
                                                            className: "inline-block shrink-0 fill-white/70 pt-[1px] align-baseline"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, i);
                        })
                    })
                ]
            }),
            (subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscription) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mt-11",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "flex items-center gap-4 text-sm font-semibold text-white lg:text-base",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "capitalize",
                                children: t("subscription")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h-px w-full flex-1 bg-white/[.08]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetailTable, {
                        subscription: subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-11",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-center text-xs text-white/70",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lock, {
                                title: "secure payments",
                                className: "mr-2 inline-block fill-white/70"
                            }),
                            t("secure_payments"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stripe, {
                                title: "stripe",
                                className: "ml-[6px] inline-block"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-10 flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                className: "w-full lg:mx-auto lg:w-auto",
                                size: "small",
                                importance: "secondary",
                                href: subscriptionData === null || subscriptionData === void 0 ? void 0 : (ref3 = subscriptionData.subscription) === null || ref3 === void 0 ? void 0 : ref3.manageUrl,
                                children: t("manage_subscription")
                            }),
                            (subscriptionData === null || subscriptionData === void 0 ? void 0 : (ref4 = subscriptionData.subscription) === null || ref4 === void 0 ? void 0 : ref4.spotifyConnected) && !isSpotifyUnlinked && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                className: "flex w-full cursor-pointer items-center gap-2.5 lg:mx-auto lg:w-auto",
                                size: "small",
                                importance: "clear",
                                onClick: unlinkSpotify,
                                children: [
                                    isUnlinkingSpotify ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowPathIcon/* default */.Z, {
                                        className: "inline-block h-4 w-4 animate-spin fill-white"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(link_slash, {
                                        className: "inline-block h-4 w-4 fill-white"
                                    }),
                                    "Unlink Spotify account"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/SubscriptionDetailsSingle.tsx







function SubscriptionDetailsSingle_SubscriptionDetails(param) {
    var subscriptionData = param.subscriptionData, data = param.data, multipleShows = param.multipleShows, displayShowDetailsDialog = param.displayShowDetailsDialog;
    var ref, ref1;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "font-display text-[32px] font-bold leading-none lg:text-[40px]",
                children: t("your_content")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mt-6 text-white/70",
                children: [
                    t("your_content_subheader"),
                    " "
                ]
            }),
            !multipleShows && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Listen, {
                    playbackOptions: (ref = subscriptionData.subscription) === null || ref === void 0 ? void 0 : ref.product.shows[0].playbackOptions
                })
            }),
            multipleShows && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mt-11",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "flex items-center gap-4 text-sm font-semibold text-white lg:text-base",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("shows")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h-px w-full flex-1 bg-white/[.08]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mt-6 space-y-5",
                        children: subscriptionData === null || subscriptionData === void 0 ? void 0 : (ref1 = subscriptionData.subscription) === null || ref1 === void 0 ? void 0 : ref1.product.shows.map(function(show, i) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonOrLink/* default */.Z, {
                                    onClick: function() {
                                        return displayShowDetailsDialog({
                                            title: show.title,
                                            productTitle: data === null || data === void 0 ? void 0 : data.page.hero.title,
                                            art: show.coverImageUrl,
                                            details: data === null || data === void 0 ? void 0 : data.page.hero.metadata.join("・"),
                                            premium: true,
                                            explicit: show.explicit,
                                            playbackOptions: show.playbackOptions
                                        });
                                    },
                                    className: "group flex w-full items-center gap-4 rounded focus:shadow-input-focus focus:outline-none focus:ring-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "h-14 w-14 shrink-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "w-l4 h-14 rounded",
                                                src: show.coverImageUrl,
                                                width: "56",
                                                height: "56",
                                                quality: 100
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex-1 overflow-hidden",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center justify-between gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-semibold",
                                                            children: show.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right, {
                                                            className: "h-6 w-6 fill-white/50 transition group-hover:fill-white/90"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "mt-0.5 flex text-[13px] font-medium text-white/70 md:text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "truncate",
                                                            children: show.subtitle
                                                        }),
                                                        show.explicit && /*#__PURE__*/ (0,jsx_runtime.jsx)(explicit, {
                                                            className: "inline-block shrink-0 fill-white/70 pt-[1px] align-baseline"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, i);
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
;// CONCATENATED MODULE: ./utils/validation.ts

var emailSchema = lib.z.string().email();

// EXTERNAL MODULE: ./components/Input/Input.tsx
var Input = __webpack_require__(5998);
;// CONCATENATED MODULE: ./public/assets/apple.svg
var apple_path, _path2;
function apple_extends() { apple_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return apple_extends.apply(this, arguments); }

var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/react.createElement("svg", apple_extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), apple_path || (apple_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.72 5.598c.819 0 1.846-.57 2.458-1.332.553-.69.957-1.654.957-2.617 0-.131-.011-.262-.034-.369-.912.036-2.008.63-2.666 1.428-.52.606-.993 1.558-.993 2.533 0 .143.023.286.035.333.058.012.15.024.242.024ZM9.833 19.992c1.12 0 1.616-.773 3.012-.773 1.42 0 1.731.75 2.978.75 1.223 0 2.043-1.166 2.816-2.308.866-1.309 1.223-2.594 1.246-2.653-.08-.024-2.423-1.011-2.423-3.783 0-2.403 1.846-3.486 1.95-3.569C18.19 5.848 16.332 5.8 15.823 5.8c-1.373 0-2.492.857-3.196.857-.762 0-1.766-.809-2.955-.809-2.262 0-4.558 1.927-4.558 5.567 0 2.26.854 4.652 1.904 6.198.9 1.309 1.685 2.38 2.816 2.38Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M15.373 4.422c.583-.727 1.013-1.744 1.013-2.773 0-.144-.013-.293-.04-.422l-.045-.205-.21.008c-.994.04-2.152.675-2.848 1.517-.546.64-1.05 1.645-1.05 2.694 0 .164.025.326.041.392l.037.154.155.032c.073.015.182.03.293.03.464 0 .967-.16 1.427-.412a4.145 4.145 0 0 0 1.226-1.015Zm3.474 13.379.001-.002a10.647 10.647 0 0 0 1.271-2.7l.099-.254-.261-.077-.007-.003c-.03-.013-.16-.07-.347-.183a4.032 4.032 0 0 1-.782-.612c-.559-.559-1.108-1.438-1.108-2.745 0-2.094 1.48-3.113 1.803-3.335l.054-.039.18-.144-.13-.19c-1.297-1.918-3.27-1.967-3.796-1.967-.737 0-1.397.23-1.942.446l-.27.11c-.167.068-.32.13-.466.182-.22.078-.388.119-.519.119-.15 0-.324-.04-.534-.113-.164-.056-.334-.127-.52-.204l-.169-.069c-.496-.203-1.084-.423-1.732-.423-2.42 0-4.808 2.06-4.808 5.817 0 2.315.871 4.754 1.947 6.338l.001.002c.448.65.883 1.267 1.354 1.719.476.456 1.014.768 1.668.768.583 0 1.017-.192 1.424-.373l.08-.035c.429-.19.863-.365 1.508-.365.656 0 1.05.17 1.45.352l.045.02c.399.183.825.377 1.483.377.7 0 1.269-.335 1.75-.794.476-.456.889-1.056 1.273-1.623Z",
    stroke: "#000",
    strokeOpacity: 0.16,
    strokeWidth: 0.5
  })));
};
/* harmony default export */ var apple = (SvgApple);
// EXTERNAL MODULE: ./public/assets/google.svg
var google = __webpack_require__(5914);
;// CONCATENATED MODULE: ./components/Auth/SignupDialog.tsx














function stripeUrl(authToken, purchaseOptionsId, promoCode, resourceId) {
    return "".concat("https://pod.space", "/premium/purchase?token=").concat(authToken, "&id=").concat(purchaseOptionsId, "&promo=").concat(promoCode, "&resource_id=").concat(resourceId);
}
function Signup(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, selectedPaymentOption = param.selectedPaymentOption, productName = param.productName, trialDays = param.trialDays, promoCode = param.promoCode, resourceId = param.resourceId;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var _query = router.query, result = _query.result, payment_option_id = _query.payment_option_id, token = _query.token, code = _query.code;
    var slug = ((ref = router.query.slug) === null || ref === void 0 ? void 0 : ref[0]) || "";
    var ref3 = (0,react.useState)(""), emailError = ref3[0], setEmailError = ref3[1];
    var ref4 = (0,react.useState)(1), step = ref4[0], setStep = ref4[1];
    var ref5 = (0,react.useState)(false), isRedirecting = ref5[0], setIsRedirecting = ref5[1];
    var ref6 = (0,react.useState)(false), confirmEmail = ref6[0], setConfirmEmail = ref6[1];
    var ref7 = (0,react.useState)(router.query.email || ""), email = ref7[0], setEmail = ref7[1];
    var createAccount = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var validatedEmail, ref, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isRedirecting) return [
                            2
                        ];
                        try {
                            validatedEmail = emailSchema.parse(email.trim());
                        } catch (err) {
                            return [
                                2,
                                setEmailError(t("errors_invalid_email"))
                            ];
                        }
                        if (router.query.result == "confirm") {
                            ;
                            router.push(stripeUrl((ref = router.query) === null || ref === void 0 ? void 0 : ref.auth, selectedPaymentOption, promoCode, resourceId));
                            return [
                                2
                            ];
                        }
                        setEmailError("");
                        setIsRedirecting(true);
                        setConfirmEmail(true);
                        return [
                            4,
                            fetch("/api/auth/signup", {
                                method: "POST",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    email: validatedEmail,
                                    paymentOptionId: selectedPaymentOption
                                })
                            }).then(function(res) {
                                return res.json();
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        if (data) {
                            if ((data === null || data === void 0 ? void 0 : data.userCreate.result) === "verification_sent") {
                                setIsRedirecting(false);
                                setConfirmEmail(false);
                                return [
                                    2,
                                    setStep(2)
                                ];
                            }
                            router.push(stripeUrl(data === null || data === void 0 ? void 0 : data.userCreate.session.authToken, selectedPaymentOption, promoCode));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function createAccount() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = router.query) === null || ref === void 0 ? void 0 : ref.email) {
            if (router.query.result == "confirm") {
                setConfirmEmail(true);
            } else {
                setStep(2);
            }
        }
        if (result === "failed") {
            setStep(3);
        }
    }, [
        (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.email,
        (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.result,
        result
    ]);
    var ref8 = (0,react.useState)(code || ""), verificationCode = ref8[0], setVerificationCode = ref8[1];
    var ref9 = (0,react.useState)(""), verificationCodeError = ref9[0], setVerificationCodeError = ref9[1];
    var verify = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!verificationCode) {
                            return [
                                2,
                                setVerificationCodeError(t("errors_invalid_verification"))
                            ];
                        } else {
                            setEmailError("");
                        }
                        setIsRedirecting(true);
                        setConfirmEmail(true);
                        return [
                            4,
                            fetch("/api/auth/verify", {
                                method: "POST",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    code: verificationCode.trim(),
                                    slug: slug
                                })
                            }).then(function(res) {
                                return res.json();
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        if (!data.userVerify) {
                            setIsRedirecting(false);
                            return [
                                2,
                                setVerificationCodeError(t("errors_invalid_verification"))
                            ];
                        } else {
                            setIsRedirecting(false);
                            setConfirmEmail(false);
                            router.push(stripeUrl(data === null || data === void 0 ? void 0 : data.userVerify.authToken, selectedPaymentOption || payment_option_id, promoCode, resourceId));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function verify() {
            return _ref.apply(this, arguments);
        };
    }();
    var Dialogue_Metas = {
        "1": {
            title: t("signup_title"),
            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    t("signup_description", {
                        trialDays: trialDays
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "font-normal text-white/90",
                        children: productName
                    }),
                    "."
                ]
            }),
            image: "/assets/modal-hello.png"
        },
        "2": {
            title: t("signup_verification_title"),
            description: t("signup_verification_description"),
            image: "/assets/modal-inbox.png"
        },
        "3": {
            title: t("payment_issues_title"),
            description: t("payment_issues_description"),
            image: "/assets/modal-power.png"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
            show: isOpen,
            title: Dialogue_Metas[step].title,
            description: Dialogue_Metas[step].description,
            image: Dialogue_Metas[step].image,
            onClose: function() {
                return setIsOpen(false);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    show: step == 1,
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 scale-95",
                    enterTo: "opacity-100 scale-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                show: !confirmEmail,
                                as: react.Fragment,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(transition/* Transition.Child */.u.Child, {
                                    enter: "ease-out duration-300",
                                    enterFrom: "opacity-0 scale-95",
                                    enterTo: "opacity-100 scale-100",
                                    leave: "ease-in duration-200",
                                    leaveFrom: "opacity-100 scale-100",
                                    leaveTo: "opacity-0 scale-95",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                            fullWidth: true,
                                            className: "mt-6 flex items-center gap-2",
                                            importance: "secondary",
                                            href: "".concat("https://pod.space", "/premium/register/apple?payment_option_id=").concat(selectedPaymentOption, "&src=signup"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(apple, {
                                                    className: "w-6"
                                                }),
                                                " ",
                                                t("signup_apple")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                            fullWidth: true,
                                            className: "mt-4 flex items-center gap-2",
                                            importance: "secondary",
                                            href: "".concat("https://pod.space", "/premium/register/google?payment_option_id=").concat(selectedPaymentOption, "&src=signup"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(google/* default */.Z, {
                                                    className: "w-6"
                                                }),
                                                " ",
                                                t("signup_google")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-4 flex items-center gap-4 px-6 text-sm font-semibold leading-6 text-white/70",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "h-px w-full flex-1 bg-white/[.08]"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("or")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "h-px w-full flex-1 bg-white/[.08]"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                onSubmit: function(e) {
                                    e.preventDefault();
                                    createAccount();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            name: "email",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailIcon, {}),
                                            placeholder: t("input_placeholder_email"),
                                            value: email,
                                            error: emailError,
                                            onChange: function(e) {
                                                return setEmail(e.target.value);
                                            },
                                            disabled: confirmEmail,
                                            inputmode: "email"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        fullWidth: true,
                                        className: "mt-4",
                                        importance: "primary",
                                        type: "submit",
                                        children: isRedirecting ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "h-4 w-4 animate-spin-fast",
                                            src: "/assets/spinner.png"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: confirmEmail ? t("start_subscription") : t("signup_button_create")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mt-6 text-center text-xs text-white/70",
                                children: [
                                    t("signup_terms_description"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/privacy",
                                        target: "_blank",
                                        className: "rounded text-white underline focus-visible:shadow-input-focus focus-visible:outline-none",
                                        children: t("privacy_policy")
                                    }),
                                    " ",
                                    t("and"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/terms",
                                        target: "_blank",
                                        className: "rounded text-white underline focus-visible:shadow-input-focus focus-visible:outline-none",
                                        children: t("terms_of_service")
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    show: step == 2,
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 scale-95",
                    enterTo: "opacity-100 scale-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: function(e) {
                                e.preventDefault();
                                verify();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        name: "email",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSentIcon, {}),
                                        placeholder: "Enter your email",
                                        value: email,
                                        error: emailError,
                                        onChange: function(e) {
                                            return setEmail(e.target.value);
                                        },
                                        disabled: true,
                                        inputmode: "email"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            name: "verification-code",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerificationIcon, {}),
                                            label: "Verification code",
                                            placeholder: "Paste verification code",
                                            info: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("no_code_message"),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        className: "rounded text-white/90 underline focus:shadow-input-focus focus:outline-none",
                                                        children: t("resend_code")
                                                    })
                                                ]
                                            }),
                                            value: verificationCode,
                                            error: verificationCodeError,
                                            onChange: function(e) {
                                                return setVerificationCode(e.target.value);
                                            },
                                            onKeyDown: function(e) {
                                                return e.key == "Enter" && (e.preventDefault() || verify());
                                            },
                                            disabled: isRedirecting
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "mt-3 text-left text-xs text-white/70",
                                            children: [
                                                t("verification_sent", {
                                                    email: email
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: function(e) {
                                                        return e.preventDefault() || setStep(1);
                                                    },
                                                    className: "rounded text-white/90 underline focus:shadow-input-focus focus:outline-none",
                                                    children: t("wrong_email_message")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    fullWidth: true,
                                    className: "mt-4",
                                    importance: "primary",
                                    type: "submit",
                                    children: isRedirecting ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "h-4 w-4 animate-spin-fast",
                                        src: "/assets/spinner.png"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("signup_button_verify")
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    show: step == 3,
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 scale-95",
                    enterTo: "opacity-100 scale-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                onClick: function() {
                                    router.push(stripeUrl(token, payment_option_id, promoCode, resourceId));
                                },
                                fullWidth: true,
                                importance: "primary",
                                className: "mt-8",
                                children: t("Try again")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                onClick: function() {
                                    return setIsOpen(false);
                                },
                                fullWidth: true,
                                importance: "secondary",
                                className: "mt-4",
                                children: t("Cancel")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-6 text-center text-xs text-white/70",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                                    i18nKey: "contact_support_team",
                                    children: [
                                        "Please contact our",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonOrLink/* default */.Z, {
                                            href: "mailto:help@podspace.com",
                                            className: "rounded text-white/90 underline focus:shadow-input-focus focus:outline-none focus:ring-0",
                                            children: "Support Team"
                                        }),
                                        " ",
                                        "for any questions."
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var EmailIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "w-4 shrink-0 text-white/50 transition group-focus-within:text-white",
        viewBox: "0 0 16 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.879 0H3.12c-.395 0-.736 0-1.017.023-.297.024-.592.078-.875.222a2.25 2.25 0 0 0-.984.984c-.144.283-.198.578-.222.875C0 2.384 0 2.726 0 3.12v7.758c0 .395 0 .736.023 1.017.024.297.078.592.222.875.216.424.56.768.984.984.283.144.578.198.875.222.28.023.622.023 1.017.023h9.758c.395 0 .736 0 1.017-.023.297-.024.592-.078.875-.222a2.25 2.25 0 0 0 .984-.984c.144-.283.198-.578.222-.875.023-.28.023-.622.023-1.017V3.12c0-.395 0-.736-.023-1.017-.024-.297-.078-.592-.222-.875a2.25 2.25 0 0 0-.984-.984c-.283-.144-.578-.198-.875-.222C13.616 0 13.274 0 12.88 0ZM2.205 1.52l.02-.002c.213-.017.493-.018.925-.018h9.7a12.753 12.753 0 0 1 .945.02l-1.442 1.184c-1.366 1.123-2.732 2.246-4.1 3.367-.09.074-.135.111-.185.126a.25.25 0 0 1-.136 0c-.05-.015-.095-.052-.186-.126-1.367-1.121-2.733-2.244-4.1-3.367L2.207 1.52ZM1.5 2.882v7.968c0 .432 0 .712.018.924.017.204.045.28.064.317a.75.75 0 0 0 .328.327c.037.02.112.047.316.064.212.017.492.018.924.018h9.7c.432 0 .712 0 .924-.018.204-.017.28-.045.317-.064a.75.75 0 0 0 .327-.327c.02-.038.047-.113.064-.317.017-.212.018-.492.018-.924V2.882L8.97 7.424c-.078.064-.165.136-.247.193-.093.066-.22.143-.383.189a1.25 1.25 0 0 1-.68 0 1.253 1.253 0 0 1-.383-.19c-.082-.056-.169-.128-.247-.192L1.5 2.882Z",
            fill: "currentColor"
        })
    });
};
var EmailSentIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "w-4 shrink-0 text-white/50 transition group-focus-within:text-white",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.121 0h9.758c.395 0 .736 0 1.017.023.297.024.592.078.875.222.424.216.768.56.984.984.144.283.198.578.222.875.023.28.023.622.023 1.017V6.25c0 .233 0 .35-.038.441a.5.5 0 0 1-.27.27C15.6 7 15.482 7 15.25 7s-.35 0-.441-.038a.5.5 0 0 1-.27-.27c-.039-.093-.039-.209-.039-.442V2.882L8.97 7.424a4.397 4.397 0 0 1-.247.193c-.093.066-.22.143-.383.189a1.25 1.25 0 0 1-.68 0 1.253 1.253 0 0 1-.383-.19c-.082-.056-.169-.128-.247-.192L1.5 2.882v7.968c0 .432 0 .712.018.924.017.204.045.28.064.317a.75.75 0 0 0 .328.327c.037.02.112.047.316.064.212.017.492.018.924.018h10.896c.152 0 .228 0 .263-.03a.125.125 0 0 0 .043-.105c-.003-.046-.057-.1-.164-.206L12.81 10.78c-.165-.164-.247-.247-.286-.339a.5.5 0 0 1 0-.382c.039-.092.12-.175.286-.34.164-.164.247-.246.339-.284a.5.5 0 0 1 .382 0c.092.038.175.12.34.285l2.964 2.964c.198.198.297.297.334.412a.5.5 0 0 1 0 .309c-.037.114-.136.213-.334.41L13.87 16.78c-.164.165-.247.247-.339.285a.5.5 0 0 1-.382 0c-.092-.038-.175-.12-.34-.285-.164-.164-.246-.247-.284-.339a.5.5 0 0 1 0-.382c.038-.092.12-.175.285-.34l1.378-1.378c.107-.107.16-.16.164-.206a.125.125 0 0 0-.043-.105c-.035-.03-.111-.03-.262-.03H3.12c-.395 0-.736 0-1.017-.023-.297-.024-.592-.078-.875-.222a2.25 2.25 0 0 1-.984-.984c-.144-.283-.198-.578-.222-.875C0 11.616 0 11.274 0 10.88V3.12c0-.395 0-.736.023-1.017.024-.297.078-.592.222-.875A2.25 2.25 0 0 1 1.23.245c.283-.144.578-.198.875-.222C2.384 0 2.726 0 3.12 0Zm-.916 1.52 1.442 1.184c1.366 1.123 2.732 2.246 4.1 3.367.09.074.135.111.185.126a.25.25 0 0 0 .136 0c.05-.015.095-.052.186-.126 1.367-1.121 2.733-2.244 4.1-3.367l1.44-1.184-.02-.002a12.753 12.753 0 0 0-.924-.018h-9.7a12.754 12.754 0 0 0-.945.02Z",
            fill: "currentColor"
        })
    });
};
var VerificationIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "w-4 shrink-0 text-white/50 transition group-focus-within:text-white",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.481 12.804v-6.13L5.343 9.11c.376.238.707.447 1.077.532.324.075.66.075.985 0 .37-.085.7-.294 1.077-.532l3.862-2.435v1.547c0 .233 0 .349.037.44.05.122.146.22.267.27.091.038.206.038.436.038s.345 0 .436-.038a.496.496 0 0 0 .267-.27c.038-.092.038-.208.038-.44V6.048c0-.422 0-.794-.112-1.139a2.246 2.246 0 0 0-.473-.814c-.243-.267-.564-.448-.93-.654L9.4 1.797 7.97.988 7.917.96c-.2-.113-.424-.24-.675-.293a1.615 1.615 0 0 0-.66 0c-.252.052-.477.18-.676.293l-.051.03-1.43.808c-.97.548-1.94 1.097-2.911 1.644-.366.206-.687.387-.93.654a2.246 2.246 0 0 0-.473.814C-.001 5.254 0 5.626 0 6.048a2743.257 2743.257 0 0 1 0 6.785c0 .394 0 .734.023 1.014.024.295.077.589.22.871.212.422.552.765.97.98.28.144.572.197.865.221.277.023.614.023 1.004.023h3.09c.23 0 .345 0 .436-.038a.496.496 0 0 0 .267-.27c.037-.09.037-.207.037-.439s0-.348-.037-.44a.496.496 0 0 0-.267-.27c-.091-.037-.206-.037-.436-.037H3.11c-.427 0-.703 0-.913-.018-.201-.016-.276-.045-.312-.063a.744.744 0 0 1-.324-.327c-.019-.037-.046-.112-.063-.315-.017-.212-.018-.49-.018-.92ZM6.887 2.128c-.08.03-.156.075-.23.12l-.077.044-4.265 2.41c-.387.218-.524.302-.594.36l4.328 2.73c.502.316.606.37.7.392.107.025.22.025.328 0 .093-.021.197-.076.699-.392l4.328-2.73c-.07-.058-.207-.142-.594-.36l-4.265-2.41a4.11 4.11 0 0 1-.077-.045c-.074-.044-.15-.089-.23-.119a.147.147 0 0 0-.051 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.646 11.248c-.174-.152-.26-.229-.353-.26a.49.49 0 0 0-.377.025c-.088.044-.164.131-.316.306l-2.762 3.185c-.085.098-.128.147-.18.17a.245.245 0 0 1-.144.015c-.055-.011-.107-.05-.21-.129l-1.133-.857c-.184-.139-.276-.208-.371-.233a.49.49 0 0 0-.374.054c-.085.05-.154.143-.292.329-.138.186-.207.279-.231.374a.502.502 0 0 0 .053.378c.05.085.142.155.326.294l1.939 1.467c.206.156.31.234.42.256a.49.49 0 0 0 .29-.03c.103-.045.188-.143.358-.34l3.426-3.95c.152-.174.228-.261.259-.355a.502.502 0 0 0-.025-.38c-.044-.09-.13-.166-.303-.319Z",
                fill: "currentColor"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Auth/SigninDialog.tsx













function SigninDialog(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, selectedPaymentOption = param.selectedPaymentOption, productName = param.productName, showSubscriptionError = param.showSubscriptionError;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var _query = router.query, result = _query.result, code = _query.code, reason = _query.reason;
    var slug = router.query.slug[0];
    var ref = (0,react.useState)(""), emailError = ref[0], setEmailError = ref[1];
    var ref1 = (0,react.useState)(1), step = ref1[0], setStep = ref1[1];
    var ref2 = (0,react.useState)(false), isRedirecting = ref2[0], setIsRedirecting = ref2[1];
    var ref3 = (0,react.useState)(router.query.email || ""), email = ref3[0], setEmail = ref3[1];
    var signinAccount = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var validatedEmail, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isRedirecting) return [
                            2
                        ];
                        try {
                            validatedEmail = emailSchema.parse(email.trim());
                        } catch (err) {
                            return [
                                2,
                                setEmailError(t("errors_invalid_email"))
                            ];
                        }
                        setEmailError("");
                        setIsRedirecting(true);
                        return [
                            4,
                            fetch("/api/auth/signin", {
                                method: "POST",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    email: validatedEmail,
                                    slug: slug
                                })
                            }).then(function(res) {
                                return res.json();
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        if (data) {
                            setIsRedirecting(false);
                            if ((data === null || data === void 0 ? void 0 : data.userSignIn.result) === "verification_sent") {
                                return [
                                    2,
                                    setStep(2)
                                ];
                            } else {
                                return [
                                    2,
                                    setEmailError(t("errors_no_user"))
                                ];
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function signinAccount() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref4 = (0,react.useState)(code || ""), verificationCode = ref4[0], setVerificationCode = ref4[1];
    var ref5 = (0,react.useState)(""), verificationCodeError = ref5[0], setVerificationCodeError = ref5[1];
    var verify = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!verificationCode) {
                        return [
                            2,
                            setVerificationCodeError(t("errors_invalid_verification"))
                        ];
                    } else {
                        setEmailError("");
                    }
                    setIsRedirecting(true);
                    return [
                        4,
                        fetch("/api/auth/verify", {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                code: verificationCode,
                                slug: slug,
                                setCookie: true
                            })
                        }).then(function(res) {
                            return res.json();
                        })
                    ];
                case 1:
                    data = _state.sent();
                    if (!data.userVerify) {
                        setIsRedirecting(false);
                        return [
                            2,
                            setVerificationCodeError(t("errors_invalid_verification"))
                        ];
                    } else if (!data.userVerify.subscription) {
                        setIsRedirecting(false);
                        showSubscriptionError && showSubscriptionError();
                    } else {
                        setIsRedirecting(false);
                        location.href = "/".concat(slug);
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        verificationCode,
        slug,
        t,
        router
    ]);
    (0,react.useEffect)(function() {
        if (code) {
            setStep(2);
            verify();
        }
    }, [
        code,
        verify
    ]);
    (0,react.useEffect)(function() {
        if (result === "failed") {
            setEmailError(t(reason));
        }
    }, [
        result,
        reason,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
            show: isOpen,
            title: step == 1 ? t("signin_title") : t("signin_verify_title"),
            description: step == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    t("signin_description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "font-normal text-white/90",
                        children: productName
                    }),
                    " ",
                    t("subscription"),
                    "."
                ]
            }) : t("signin_verify_description"),
            image: step == 1 ? "/assets/modal-hello.png" : "/assets/modal-inbox.png",
            onClose: function() {
                setIsOpen(false);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    show: step == 1,
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 scale-95",
                    enterTo: "opacity-100 scale-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                show: !isRedirecting,
                                as: react.Fragment,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(transition/* Transition.Child */.u.Child, {
                                    enter: "ease-out duration-300",
                                    enterFrom: "opacity-0 scale-95",
                                    enterTo: "opacity-100 scale-100",
                                    leave: "ease-in duration-200",
                                    leaveFrom: "opacity-100 scale-100",
                                    leaveTo: "opacity-0 scale-95",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                            fullWidth: true,
                                            className: "mt-6 flex items-center gap-2",
                                            importance: "secondary",
                                            href: "".concat("https://pod.space", "/premium/register/apple?payment_option_id=").concat(selectedPaymentOption, "&src=signin"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(apple, {
                                                    className: "w-6"
                                                }),
                                                " ",
                                                t("signup_apple")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                                            fullWidth: true,
                                            className: "mt-4 flex items-center gap-2",
                                            importance: "secondary",
                                            href: "".concat("https://pod.space", "/premium/register/google?payment_option_id=").concat(selectedPaymentOption, "&src=signin"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(google/* default */.Z, {
                                                    className: "w-6"
                                                }),
                                                " ",
                                                t("signup_google")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-4 flex items-center gap-4 px-6 text-sm font-semibold leading-6 text-white/70",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "h-px w-full flex-1 bg-white/[.08]"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("or")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "h-px w-full flex-1 bg-white/[.08]"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                onSubmit: function(e) {
                                    e.preventDefault();
                                    signinAccount();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            name: "email",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SigninDialog_EmailIcon, {}),
                                            placeholder: t("input_placeholder_email"),
                                            value: email,
                                            error: emailError,
                                            onChange: function(e) {
                                                return setEmail(e.target.value);
                                            },
                                            disabled: isRedirecting,
                                            inputmode: "email"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        fullWidth: true,
                                        className: "mt-4",
                                        importance: "primary",
                                        type: "submit",
                                        children: isRedirecting ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "h-4 w-4 animate-spin-fast",
                                            src: "/assets/spinner.png"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("signin_button")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mt-6 text-center text-xs text-white/70",
                                children: [
                                    t("signin_terms_description"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/privacy",
                                        target: "_blank",
                                        className: "rounded text-white underline focus-visible:shadow-input-focus focus-visible:outline-none",
                                        children: t("privacy_policy")
                                    }),
                                    " ",
                                    t("and"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/terms",
                                        target: "_blank",
                                        className: "rounded text-white underline focus-visible:shadow-input-focus focus-visible:outline-none",
                                        children: t("terms_of_service")
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    show: step == 2,
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 scale-95",
                    enterTo: "opacity-100 scale-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: function(e) {
                                e.preventDefault();
                                verify();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        name: "email",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SigninDialog_EmailSentIcon, {}),
                                        placeholder: t("input_placeholder_email"),
                                        value: email,
                                        error: emailError,
                                        onChange: function(e) {
                                            return setEmail(e.target.value);
                                        },
                                        disabled: true,
                                        inputmode: "email"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            name: "verification-code",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SigninDialog_VerificationIcon, {}),
                                            label: t("input_label_verification"),
                                            placeholder: t("input_placeholder_verification"),
                                            info: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    t("no_code_message"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        className: "rounded text-white/90 underline focus:shadow-input-focus focus:outline-none",
                                                        children: t("resend_code")
                                                    })
                                                ]
                                            }),
                                            value: verificationCode,
                                            onKeyDown: function(e) {
                                                return e.key == "Enter" && (e.preventDefault() || verify());
                                            },
                                            error: verificationCodeError,
                                            onChange: function(e) {
                                                return setVerificationCode(e.target.value);
                                            },
                                            disabled: isRedirecting
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "mt-3 text-left text-xs text-white/70",
                                            children: [
                                                t("verification_sent", {
                                                    email: email
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    onClick: function(e) {
                                                        return e.preventDefault() || setStep(1);
                                                    },
                                                    className: "rounded text-white/90 underline focus:shadow-input-focus focus:outline-none",
                                                    children: t("wrong_email_message")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    fullWidth: true,
                                    className: "mt-4",
                                    importance: "primary",
                                    type: "submit",
                                    children: isRedirecting ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "h-4 w-4 animate-spin-fast",
                                        src: "/assets/spinner.png"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("signup_button_verify")
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
var SigninDialog_EmailIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "w-4 shrink-0 text-white/50 transition group-focus-within:text-white",
        viewBox: "0 0 16 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.879 0H3.12c-.395 0-.736 0-1.017.023-.297.024-.592.078-.875.222a2.25 2.25 0 0 0-.984.984c-.144.283-.198.578-.222.875C0 2.384 0 2.726 0 3.12v7.758c0 .395 0 .736.023 1.017.024.297.078.592.222.875.216.424.56.768.984.984.283.144.578.198.875.222.28.023.622.023 1.017.023h9.758c.395 0 .736 0 1.017-.023.297-.024.592-.078.875-.222a2.25 2.25 0 0 0 .984-.984c.144-.283.198-.578.222-.875.023-.28.023-.622.023-1.017V3.12c0-.395 0-.736-.023-1.017-.024-.297-.078-.592-.222-.875a2.25 2.25 0 0 0-.984-.984c-.283-.144-.578-.198-.875-.222C13.616 0 13.274 0 12.88 0ZM2.205 1.52l.02-.002c.213-.017.493-.018.925-.018h9.7a12.753 12.753 0 0 1 .945.02l-1.442 1.184c-1.366 1.123-2.732 2.246-4.1 3.367-.09.074-.135.111-.185.126a.25.25 0 0 1-.136 0c-.05-.015-.095-.052-.186-.126-1.367-1.121-2.733-2.244-4.1-3.367L2.207 1.52ZM1.5 2.882v7.968c0 .432 0 .712.018.924.017.204.045.28.064.317a.75.75 0 0 0 .328.327c.037.02.112.047.316.064.212.017.492.018.924.018h9.7c.432 0 .712 0 .924-.018.204-.017.28-.045.317-.064a.75.75 0 0 0 .327-.327c.02-.038.047-.113.064-.317.017-.212.018-.492.018-.924V2.882L8.97 7.424c-.078.064-.165.136-.247.193-.093.066-.22.143-.383.189a1.25 1.25 0 0 1-.68 0 1.253 1.253 0 0 1-.383-.19c-.082-.056-.169-.128-.247-.192L1.5 2.882Z",
            fill: "currentColor"
        })
    });
};
var SigninDialog_EmailSentIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "w-4 shrink-0 text-white/50 transition group-focus-within:text-white",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.121 0h9.758c.395 0 .736 0 1.017.023.297.024.592.078.875.222.424.216.768.56.984.984.144.283.198.578.222.875.023.28.023.622.023 1.017V6.25c0 .233 0 .35-.038.441a.5.5 0 0 1-.27.27C15.6 7 15.482 7 15.25 7s-.35 0-.441-.038a.5.5 0 0 1-.27-.27c-.039-.093-.039-.209-.039-.442V2.882L8.97 7.424a4.397 4.397 0 0 1-.247.193c-.093.066-.22.143-.383.189a1.25 1.25 0 0 1-.68 0 1.253 1.253 0 0 1-.383-.19c-.082-.056-.169-.128-.247-.192L1.5 2.882v7.968c0 .432 0 .712.018.924.017.204.045.28.064.317a.75.75 0 0 0 .328.327c.037.02.112.047.316.064.212.017.492.018.924.018h10.896c.152 0 .228 0 .263-.03a.125.125 0 0 0 .043-.105c-.003-.046-.057-.1-.164-.206L12.81 10.78c-.165-.164-.247-.247-.286-.339a.5.5 0 0 1 0-.382c.039-.092.12-.175.286-.34.164-.164.247-.246.339-.284a.5.5 0 0 1 .382 0c.092.038.175.12.34.285l2.964 2.964c.198.198.297.297.334.412a.5.5 0 0 1 0 .309c-.037.114-.136.213-.334.41L13.87 16.78c-.164.165-.247.247-.339.285a.5.5 0 0 1-.382 0c-.092-.038-.175-.12-.34-.285-.164-.164-.246-.247-.284-.339a.5.5 0 0 1 0-.382c.038-.092.12-.175.285-.34l1.378-1.378c.107-.107.16-.16.164-.206a.125.125 0 0 0-.043-.105c-.035-.03-.111-.03-.262-.03H3.12c-.395 0-.736 0-1.017-.023-.297-.024-.592-.078-.875-.222a2.25 2.25 0 0 1-.984-.984c-.144-.283-.198-.578-.222-.875C0 11.616 0 11.274 0 10.88V3.12c0-.395 0-.736.023-1.017.024-.297.078-.592.222-.875A2.25 2.25 0 0 1 1.23.245c.283-.144.578-.198.875-.222C2.384 0 2.726 0 3.12 0Zm-.916 1.52 1.442 1.184c1.366 1.123 2.732 2.246 4.1 3.367.09.074.135.111.185.126a.25.25 0 0 0 .136 0c.05-.015.095-.052.186-.126 1.367-1.121 2.733-2.244 4.1-3.367l1.44-1.184-.02-.002a12.753 12.753 0 0 0-.924-.018h-9.7a12.754 12.754 0 0 0-.945.02Z",
            fill: "currentColor"
        })
    });
};
var SigninDialog_VerificationIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "w-4 shrink-0 text-white/50 transition group-focus-within:text-white",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.481 12.804v-6.13L5.343 9.11c.376.238.707.447 1.077.532.324.075.66.075.985 0 .37-.085.7-.294 1.077-.532l3.862-2.435v1.547c0 .233 0 .349.037.44.05.122.146.22.267.27.091.038.206.038.436.038s.345 0 .436-.038a.496.496 0 0 0 .267-.27c.038-.092.038-.208.038-.44V6.048c0-.422 0-.794-.112-1.139a2.246 2.246 0 0 0-.473-.814c-.243-.267-.564-.448-.93-.654L9.4 1.797 7.97.988 7.917.96c-.2-.113-.424-.24-.675-.293a1.615 1.615 0 0 0-.66 0c-.252.052-.477.18-.676.293l-.051.03-1.43.808c-.97.548-1.94 1.097-2.911 1.644-.366.206-.687.387-.93.654a2.246 2.246 0 0 0-.473.814C-.001 5.254 0 5.626 0 6.048a2743.257 2743.257 0 0 1 0 6.785c0 .394 0 .734.023 1.014.024.295.077.589.22.871.212.422.552.765.97.98.28.144.572.197.865.221.277.023.614.023 1.004.023h3.09c.23 0 .345 0 .436-.038a.496.496 0 0 0 .267-.27c.037-.09.037-.207.037-.439s0-.348-.037-.44a.496.496 0 0 0-.267-.27c-.091-.037-.206-.037-.436-.037H3.11c-.427 0-.703 0-.913-.018-.201-.016-.276-.045-.312-.063a.744.744 0 0 1-.324-.327c-.019-.037-.046-.112-.063-.315-.017-.212-.018-.49-.018-.92ZM6.887 2.128c-.08.03-.156.075-.23.12l-.077.044-4.265 2.41c-.387.218-.524.302-.594.36l4.328 2.73c.502.316.606.37.7.392.107.025.22.025.328 0 .093-.021.197-.076.699-.392l4.328-2.73c-.07-.058-.207-.142-.594-.36l-4.265-2.41a4.11 4.11 0 0 1-.077-.045c-.074-.044-.15-.089-.23-.119a.147.147 0 0 0-.051 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.646 11.248c-.174-.152-.26-.229-.353-.26a.49.49 0 0 0-.377.025c-.088.044-.164.131-.316.306l-2.762 3.185c-.085.098-.128.147-.18.17a.245.245 0 0 1-.144.015c-.055-.011-.107-.05-.21-.129l-1.133-.857c-.184-.139-.276-.208-.371-.233a.49.49 0 0 0-.374.054c-.085.05-.154.143-.292.329-.138.186-.207.279-.231.374a.502.502 0 0 0 .053.378c.05.085.142.155.326.294l1.939 1.467c.206.156.31.234.42.256a.49.49 0 0 0 .29-.03c.103-.045.188-.143.358-.34l3.426-3.95c.152-.174.228-.261.259-.355a.502.502 0 0 0-.025-.38c-.044-.09-.13-.166-.303-.319Z",
                fill: "currentColor"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Auth/ExpiredSubscriptionDialog.tsx







function ExpiredSubscriptionDialog(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, selectedPaymentOption = param.selectedPaymentOption, setSelectedPaymentOption = param.setSelectedPaymentOption, purchaseOptions = param.purchaseOptions, productName = param.productName, trialDays = param.trialDays, token = param.token;
    var ref;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var router = (0,next_router.useRouter)();
    var openStripe = function() {
        router.push("".concat("https://pod.space", "/premium/purchase?token=").concat(token, "&id=").concat(selectedPaymentOption));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        show: isOpen || false,
        title: t("expired_subscription_header"),
        image: "/assets/modal-juice.png",
        onClose: function() {
            return setIsOpen();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-4 text-center text-white/70",
                children: t("expired_subscription_description", {
                    title: productName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                        name: "select-plan",
                        defaultValue: selectedPaymentOption,
                        onChange: setSelectedPaymentOption,
                        label: t("choose_plan"),
                        children: purchaseOptions.map(function(option) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* RadioGroupItem */.m, {
                                id: option.identifier,
                                value: option.identifier,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "",
                                        children: t(option.name)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "ml-auto text-white/50 transition group-hover:!text-white ui-checked:text-white/90",
                                        children: [
                                            "".concat(t("displayPrice", {
                                                price: option.price.price
                                            }), " ").concat(option.price.currency === "SEK" ? "kr" : option.price.currency, " "),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-sm font-medium text-white/50 transition group-hover:text-white ui-checked:text-white/90",
                                                children: [
                                                    "/",
                                                    t(option.billingFrequency.toLowerCase())
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, option.identifier);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        href: "#",
                        importance: "primary",
                        className: "mt-6",
                        onClick: function() {
                            return openStripe();
                        },
                        children: t("start_subscription")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        onClick: function() {
                            return setIsOpen(false);
                        },
                        importance: "secondary",
                        className: "mt-4",
                        fullWidth: true,
                        children: t("Cancel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-6 text-center text-xs text-white/70",
                        children: t("start_trial_description", {
                            title: productName,
                            trialDays: trialDays,
                            price: (ref = purchaseOptions.find(function(param) {
                                var identifier = param.identifier;
                                return identifier == selectedPaymentOption;
                            })) === null || ref === void 0 ? void 0 : ref.price.displayPrice,
                            interval: selectedPaymentOption == purchaseOptions[0].identifier ? t("month") : t("year")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-4 text-center text-xs text-white/70",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                    i18nKey: "contact_support_team",
                    children: [
                        "Please contact our",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonOrLink/* default */.Z, {
                            href: "mailto:help@podspace.com",
                            className: "rounded text-white/90 underline focus:shadow-input-focus focus:outline-none focus:ring-0",
                            children: "Support Team"
                        }),
                        " ",
                        "for any questions."
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(7856);
;// CONCATENATED MODULE: ./utils/string.ts

var getSanitizedHtml = function(rawHtml, allowedTags) {
    return purify.sanitize(rawHtml, {
        ALLOWED_TAGS: allowedTags
    });
};

;// CONCATENATED MODULE: ./components/ProductDetailsSingle.tsx













function ProductDetailsSingle(param) {
    var data = param.data, selectedPaymentOption = param.selectedPaymentOption, setSelectedPaymentOption = param.setSelectedPaymentOption, setIsSignupDialogOpen = param.setIsSignupDialogOpen, setIsSigninDialogOpen = param.setIsSigninDialogOpen;
    var ref, ref1, ref2;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-white/70",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                    i18nKey: "purchase_subheader",
                    children: [
                        "Get episodes of ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-white/90",
                            children: data === null || data === void 0 ? void 0 : data.page.hero.title
                        }),
                        " for only",
                        " ",
                        data === null || data === void 0 ? void 0 : data.page.product.purchaseOptions[0].price.displayPrice,
                        "."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mt-6 list-none space-y-4 font-medium lg:mt-8",
                children: data === null || data === void 0 ? void 0 : (ref = data.page) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.features) === null || ref2 === void 0 ? void 0 : ref2.map(function(checkedListItem, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            checkedListItem.type === "text" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedListItem, {
                                children: checkedListItem.content
                            }, index),
                            checkedListItem.type === "episode" && /*#__PURE__*/ (0,jsx_runtime.jsx)(EpisodeListItem, {
                                episode: JSON.parse(checkedListItem.data)
                            }, index),
                            checkedListItem.type === "localized_key" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedListItem, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "flex items-center",
                                    children: [
                                        "Listen on ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Spotify"
                                        }),
                                        "\xa0",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipOnHover, {
                                            text: t("spotify"),
                                            className: "h-6 w-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                unoptimized: true,
                                                alt: "spotify",
                                                loading: "eager",
                                                src: "/assets/app-spotify-colorized.png",
                                                width: "24",
                                                height: "24",
                                                className: "inline-block transition hover:scale-90",
                                                "aria-hidden": "true",
                                                quality: 100
                                            })
                                        }),
                                        ",",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Apple Podcasts"
                                        }),
                                        "\xa0",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipOnHover, {
                                            text: t("apple_podcasts"),
                                            className: "h-6 w-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                alt: "apple podcasts",
                                                unoptimized: true,
                                                loading: "eager",
                                                src: "/assets/app-apple-podcast-colorized.png",
                                                width: "24",
                                                height: "24",
                                                className: "inline-block transition hover:scale-90",
                                                "aria-hidden": "true",
                                                quality: 100
                                            })
                                        }),
                                        ", and",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Google Podcasts"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GooglePodcasts, {
                                            className: "h-6 w-6"
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                        name: "select-plan",
                        defaultValue: selectedPaymentOption,
                        onChange: setSelectedPaymentOption,
                        label: "",
                        children: data === null || data === void 0 ? void 0 : data.page.product.purchaseOptions.map(function(option) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* RadioGroupItem */.m, {
                                value: option.identifier,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "",
                                        children: t(option.name)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-auto text-white/50 transition group-hover:!text-white ui-checked:text-white/90",
                                        children: "".concat(t("displayPrice", {
                                            price: option.price.price
                                        }), " ").concat(option.price.currency === "SEK" ? "kr" : option.price.currency, " ")
                                    })
                                ]
                            }, option.identifier);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PremiumButton, {
                            fullWidth: true,
                            size: "large",
                            importance: "premium",
                            onClick: function() {
                                return setIsSignupDialogOpen(true);
                            },
                            children: [
                                t("purchase_header"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right, {
                                    className: "ml-2 fill-white"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-center text-xs text-white/70",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lock, {
                                title: "secure payments",
                                className: "mr-2 inline-block fill-white/70"
                            }),
                            t("secure_payments"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stripe, {
                                title: "stripe",
                                className: "ml-[6px] inline-block"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-10 flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            className: "w-full lg:mx-auto lg:w-auto",
                            size: "small",
                            importance: "secondary",
                            onClick: function() {
                                return setIsSigninDialogOpen(true);
                            },
                            children: t("sign_in_button")
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/[...slug]/index.tsx









// Components



























var Premium = function(param) {
    var data = param.data, subscriptionData = param.subscriptionData, _hasSubscriptionError = param.hasSubscriptionError, hasSubscriptionError = _hasSubscriptionError === void 0 ? false : _hasSubscriptionError, _hasLinkedError = param.hasLinkedError, hasLinkedError = _hasLinkedError === void 0 ? false : _hasLinkedError, token = param.token, children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var router = (0,next_router.useRouter)();
    var planIndex = ((ref = router.query) === null || ref === void 0 ? void 0 : ref.plan) || 0;
    var ref20 = (0,react.useState)(subscriptionData != null && ((ref1 = subscriptionData.subscription) === null || ref1 === void 0 ? void 0 : ref1.status) != SubscriptionStatus.Expired), isSubscribed = ref20[0], setIsSubscribed = ref20[1];
    var ref21 = (0,react.useState)(false), showFullDescription = ref21[0], setShowFullDescription = ref21[1];
    var ref22 = (0,react.useState)(true), isDescriptionShrinked = ref22[0], setIsDescriptionShrinked = ref22[1];
    var ref23 = (0,react.useState)(hasSubscriptionError), showSubscriptionError = ref23[0], setShowSubscriptionError = ref23[1];
    var ref24 = (0,react.useState)(hasLinkedError), showLinkedError = ref24[0], setShowLinkedError = ref24[1];
    var ref25 = (0,react.useState)(null), activeShow = ref25[0], setActiveShow = ref25[1];
    var ref26 = (0,react.useState)(false), showShowDetailsDialog = ref26[0], setShowShowDetailsDialog = ref26[1];
    var ref27 = (0,react.useState)(((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.paymentOption) || ((ref3 = data === null || data === void 0 ? void 0 : data.page.product) === null || ref3 === void 0 ? void 0 : ref3.purchaseOptions[planIndex].identifier) || ""), selectedPaymentOption = ref27[0], setSelectedPaymentOption = ref27[1];
    var ref28 = (0,react.useState)(((ref4 = data === null || data === void 0 ? void 0 : data.page.product) === null || ref4 === void 0 ? void 0 : ref4.name) || ""), productName = ref28[0], setProductName = ref28[1];
    var ref29 = (0,react.useState)(((ref5 = data === null || data === void 0 ? void 0 : data.page.product) === null || ref5 === void 0 ? void 0 : ref5.purchaseOptions[planIndex].trialDays) || 0), trialDays = ref29[0], setTrialDays = ref29[1];
    var ref30 = (0,react.useState)(((ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.signup) == "1"), isSignupDialogOpen = ref30[0], setIsSignupDialogOpen = ref30[1];
    var ref31 = (0,react.useState)(((ref7 = router.query) === null || ref7 === void 0 ? void 0 : ref7.signin) == "1" && !subscriptionData), isSigninDialogOpen = ref31[0], setIsSigninDialogOpen = ref31[1];
    var ref32 = (0,react.useState)((subscriptionData === null || subscriptionData === void 0 ? void 0 : (ref8 = subscriptionData.subscription) === null || ref8 === void 0 ? void 0 : ref8.status) == SubscriptionStatus.Expired), isExpiredSubscriptionDialogOpen = ref32[0], setIsExpiredSubscriptionDialogOpen = ref32[1];
    var ref33 = (0,react.useState)(((ref9 = router.query) === null || ref9 === void 0 ? void 0 : ref9.spotify_unlinked) === "1"), showSpotifyUnlinkedDialog = ref33[0], setShowSpotifyUnlinkedDialog = ref33[1];
    var ref34 = (0,react.useState)(1), playbackSpeed = ref34[0], setPlaybackSpeed = ref34[1];
    var ref35 = (0,react.useState)(false), isPlayingAudio = ref35[0], setIsPlayingAudio = ref35[1];
    (0,react.useEffect)(function() {
        if (isSubscribed && router.query.soa == "1" && router.query.src) {
            router.push("".concat("https://pod.space", "/spotify/connect?spotifyShowUri=spotify:show:").concat(router.query.src, "&state_t=").concat(token));
        }
    }, [
        isSubscribed,
        router,
        token
    ]);
    var displayShowDetailsDialog = function(show) {
        setActiveShow(show);
        setShowShowDetailsDialog(true);
    };
    var closeShowDetailsDialog = function() {
        setShowShowDetailsDialog(false);
        setTimeout(function() {
            return setActiveShow(null);
        }, 300);
    };
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var slug = router.query.slug[0];
    var episode = router.query.slug[1];
    var multipleShows = function() {
        var ref;
        var ref1;
        return (ref1 = ((ref = data === null || data === void 0 ? void 0 : data.page.product) === null || ref === void 0 ? void 0 : ref.shows.length) > 1) !== null && ref1 !== void 0 ? ref1 : false;
    };
    var scrollY = (0,use_scroll/* useScroll */.v)().scrollY;
    var y = (0,use_transform/* useTransform */.H)(scrollY, [
        0,
        500
    ], [
        0,
        125
    ]);
    var ref36 = (0,react.useState)(false), isInitialized = ref36[0], setIsInitialized = ref36[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setIsInitialized(true);
        });
    }, []);
    var descriptionRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (descriptionRef.current.scrollHeight !== descriptionRef.current.clientHeight) {
            setIsDescriptionShrinked(true);
        }
    }, [
        descriptionRef.current
    ]);
    var ref37 = (0,react.useState)(true), episodesLoading = ref37[0], setEpisodesLoading = ref37[1];
    var ref38 = (0,react.useState)([]), episodes = ref38[0], setEpisodes = ref38[1];
    var ref39 = (0,react.useState)([]), seasons = ref39[0], setSeasons = ref39[1];
    var ref40 = (0,react.useState)(), activeEpisode = ref40[0], setActiveEpisode = ref40[1];
    var ref41 = (0,react.useState)(), activeSeason = ref41[0], setActiveSeason = ref41[1];
    var ref42 = (0,react.useState)([]), filteredEpisodes = ref42[0], setFilteredEpisodes = ref42[1];
    var ref43 = (0,react.useState)(false), autoplay = ref43[0], setAutoplay = ref43[1];
    (0,react.useEffect)(function() {
        if (multipleShows()) return;
        if (data === null || data === void 0 ? void 0 : data.page.product) return;
        axios/* default.get */.Z.get("".concat("https://api.pod.space", "/podcasts/").concat(slug), {
            headers: {
                Authorization: "Bearer ".concat("wFh54nKxBMPayMM5jsCj8K4MxSUdTJhMcVJdHKhnVXTcvojSJMPsxGXHtp3XJSb5qgVyHimcPoZFQ4CWCjdz8XEs6kxR9B3Vw77h8GZAH7aQNPWHxTUkQLnRqKJYjYMD"),
                userToken: token
            }
        }).then(function(param) {
            var data = param.data;
            var tempEpisodes = data.episodes;
            setEpisodesLoading(false);
            if (!tempEpisodes) {
                return;
            }
            var seasons = tempEpisodes.reduce(function(carry, episode) {
                if (carry.findIndex(function(c) {
                    return c.id === episode.season_number;
                }) < 0) {
                    carry.push({
                        id: episode.season_number,
                        label: episode.season_number !== null ? "Season ".concat(episode.season_number) : "No season"
                    });
                }
                return carry;
            }, []).sort(function(a, b) {
                return a.id - b.id;
            });
            setEpisodes(tempEpisodes);
            setSeasons(seasons);
            var tempActiveEpisode;
            if (episode) {
                tempActiveEpisode = tempEpisodes === null || tempEpisodes === void 0 ? void 0 : tempEpisodes.filter(function(e) {
                    return e.url.split("/")[1] === episode;
                })[0];
            } else {
                tempActiveEpisode = tempEpisodes === null || tempEpisodes === void 0 ? void 0 : tempEpisodes.filter(function(e) {
                    return !e.locked;
                }).sort(function(episodeLeft, episodeRight) {
                    return (0,compareDesc/* default */.Z)((0,parseISO/* default */.Z)(episodeLeft.published_at), (0,parseISO/* default */.Z)(episodeRight.published_at));
                })[0];
            }
            setActiveEpisode(tempActiveEpisode);
            // Set active season to active episode's season
            if (tempActiveEpisode === null || tempActiveEpisode === void 0 ? void 0 : tempActiveEpisode.season_number) {
                setActiveSeason(seasons === null || seasons === void 0 ? void 0 : seasons.find(function(season) {
                    return season.id === tempActiveEpisode.season_number;
                }));
            } else {
                setActiveSeason(seasons[seasons.length - 1]);
            }
        });
    }, []);
    var updateFilteredEpisodes = function() {
        setFilteredEpisodes(episodes === null || episodes === void 0 ? void 0 : episodes.filter(function(episode) {
            return episode.season_number === (activeSeason === null || activeSeason === void 0 ? void 0 : activeSeason.id);
        }));
    };
    (0,react.useEffect)(function() {
        return updateFilteredEpisodes();
    }, [
        activeSeason
    ]);
    (0,react.useEffect)(function() {
        if (activeEpisode) {
            router.push("".concat(activeEpisode.url), undefined, {
                scroll: false
            });
            if (activeEpisode.season_number !== (activeSeason === null || activeSeason === void 0 ? void 0 : activeSeason.id)) {
                setActiveSeason(seasons.filter(function(s) {
                    return s.id === activeEpisode.season_number;
                })[0]);
            }
        }
    }, [
        activeEpisode
    ]);
    var previousEpisode = function() {
        var currentEpisodeIndex = filteredEpisodes.findIndex(function(e) {
            return e.id === activeEpisode.id;
        });
        var previous = filteredEpisodes[currentEpisodeIndex - 1];
        if (previous && !previous.locked) {
            setActiveEpisode(previous);
        } else {
            var currentSeasonIndex = seasons.findIndex(function(s) {
                return s.id === activeSeason.id;
            });
            var previousSeason = seasons[currentSeasonIndex - 1];
            if (previousSeason) {
                setActiveSeason(previousSeason);
                if (previous = episodes.filter(function(e) {
                    return e.season_number === previousSeason.id && !e.locked;
                })[0]) {
                    setActiveEpisode(previous);
                }
            }
        }
    };
    var nextEpisode = function() {
        var currentEpisodeIndex = filteredEpisodes.findIndex(function(e) {
            return e.id === activeEpisode.id;
        });
        var next = filteredEpisodes[currentEpisodeIndex + 1];
        if (next && !next.locked) {
            setActiveEpisode(next);
        } else {
            var currentSeasonIndex = seasons.findIndex(function(s) {
                return s.id === activeSeason.id;
            });
            var nextSeason = seasons[currentSeasonIndex + 1];
            if (nextSeason) {
                setActiveSeason(nextSeason);
                if (next = episodes.filter(function(e) {
                    return e.season_number === nextSeason.id && !e.locked;
                })[0]) {
                    setActiveEpisode(next);
                }
            }
        }
    };
    var title = "".concat(data.page.hero.title, " | Podspace");
    var category = (ref10 = data === null || data === void 0 ? void 0 : data.page.contentBlocks.find(function(block) {
        return block.title === "Category";
    })) === null || ref10 === void 0 ? void 0 : ref10.content;
    var _title, _title1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Listen to ".concat(data.page.hero.title, " on Podspace")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content:  true && (window.location.href || "https://premium.pod.space/".concat(router.asPath))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "".concat(data.page.hero.title, " | Podspace")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "Listen to ".concat(data.page.hero.title, " on Podspace")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: data === null || data === void 0 ? void 0 : data.page.hero.mediaUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:domain",
                        content:  true && (window.location.host || "https://premium.pod.space")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content:  true && (window.location.href || "https://premium-dev.podspace.tech/".concat(router.asPath))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "".concat(data.page.hero.title, " | Podspace")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "Listen to ".concat(data.page.hero.title, " on Podspace")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: data === null || data === void 0 ? void 0 : data.page.hero.mediaUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@podspace_app"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        type: "application/rss+xml",
                        title: data.page.hero.title,
                        href: "https://feed.pod.space/".concat(slug)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://play.pod.space/".concat(slug)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "pointer-events-none fixed inset-x-0 z-10 mx-auto flex max-w-screen-2xl items-center justify-between px-8 py-5 lg:px-9 lg:py-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: "Navigation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pointer-events-auto flex items-center gap-3"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "min-h-screen overflow-hidden md:max-h-screen",
                children: [
                    activeEpisode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                        className: "relative md:pointer-events-none md:fixed md:inset-y-0 md:left-0 md:flex md:h-screen md:w-1/2 md:items-center md:justify-center md:border-r md:border-white/[0.03] md:bg-[#0E0E10] md:text-white md:after:absolute md:after:-right-1 md:after:h-full md:after:w-[1px] md:after:border md:after:border-black/[0.32]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Player, {
                            activeEpisode: activeEpisode,
                            setActiveEpisode: setActiveEpisode,
                            previousEpisode: previousEpisode,
                            nextEpisode: nextEpisode,
                            autoplay: autoplay,
                            playbackSpeed: playbackSpeed,
                            setPlaybackSpeed: function(speed) {
                                return setPlaybackSpeed(speed);
                            },
                            handleIsPlaying: function(isPlaying) {
                                return setIsPlayingAudio(isPlaying);
                            }
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                        className: "hidden h-screen bg-[#09090C] text-white md:pointer-events-none md:fixed md:inset-y-0 md:left-0 md:flex md:w-1/2 md:items-center md:justify-center md:border-r md:border-white/[0.03] md:after:absolute md:after:-right-1 md:after:h-full md:after:w-[1px] md:after:border md:after:border-black/[0.32]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-auto flex w-full max-w-[800px] justify-center px-6 lg:px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full lg:w-[480px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "aspect-square w-full overflow-hidden md:rounded-3xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: data === null || data === void 0 ? void 0 : data.page.hero.mediaUrl,
                                        alt: data === null || data === void 0 ? void 0 : data.page.hero.title,
                                        width: 800,
                                        height: 800,
                                        layout: "responsive",
                                        objectFit: "contain",
                                        priority: true,
                                        quality: 100
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "content",
                        className: "overflow-y-auto overflow-x-hidden  text-white md:h-screen md:pb-20 md:pl-[50%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mr-auto flex w-full max-w-[800px] justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full md:max-w-[33rem] md:px-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                        className: "relative z-[1] aspect-square overflow-hidden px-4 text-center md:z-auto md:aspect-auto md:pt-[144px] md:text-left",
                                        children: [
                                            slug != "perfectday" && slug != "billgrenwood" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonOrLink/* default */.Z, {
                                                href: "http://podspace.com",
                                                target: "_blank",
                                                className: "absolute top-12 hidden rounded p-1 focus:shadow-input-focus focus:outline-none focus:ring-0 md:inline-flex md:items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/podspace-logo.svg",
                                                        className: "h-6 md:h-8",
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Podspace"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute top-0 -z-10 -mx-4 aspect-square w-full overflow-hidden transition duration-1000 ease-in-out md:hidden ".concat(!isInitialized ? "scale-110 opacity-0" : "scale-100"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                                    style: {
                                                        y: y
                                                    },
                                                    className: "h-full w-full",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            backgroundImage: "url(".concat(data === null || data === void 0 ? void 0 : data.page.hero.mediaUrl, ")")
                                                        },
                                                        className: "absolute inset-0 bottom-0 h-full w-full bg-cover bg-top",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute inset-0 h-full w-full bg-cover bg-top blur",
                                                            style: {
                                                                backgroundImage: "inherit",
                                                                WebkitMaskImage: "linear-gradient(to bottom, transparent 50%, black)",
                                                                maskImage: "linear-gradient(to bottom, transparent 50%, black)"
                                                            }
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute bottom-0 top-0 -z-10 -mx-4 aspect-square w-full overflow-hidden md:hidden",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute inset-x-0 bottom-0 h-full w-full overflow-hidden md:hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "absolute inset-x-0 bottom-0 h-1/2 w-full bg-gradient-to-b from-[#000]/0 to-[#000]"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute inset-x-0 bottom-0 z-[1] px-4 md:relative md:px-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                                            children: [
                                                                (data === null || data === void 0 ? void 0 : data.page.hero.iconUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "mx-auto mb-2 block w-8 md:ml-0 md:w-12 lg:w-16",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: data === null || data === void 0 ? void 0 : data.page.hero.iconUrl,
                                                                        alt: data === null || data === void 0 ? void 0 : data.page.hero.title,
                                                                        width: 64,
                                                                        height: 64,
                                                                        priority: true,
                                                                        className: "rounded-full",
                                                                        quality: 100
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                                                    className: "text-[10px] font-bold uppercase leading-none tracking-wider text-white/50 md:text-xs md:font-semibold",
                                                                    children: data === null || data === void 0 ? void 0 : data.page.hero.author
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                            className: "mt-3 hyphens-auto break-words font-display text-[32px] font-bold leading-none md:text-[40px] lg:text-5xl",
                                                            children: data === null || data === void 0 ? void 0 : data.page.hero.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center justify-center gap-3 overflow-hidden pb-1 pt-3 md:justify-start",
                                                            children: [
                                                                (data === null || data === void 0 ? void 0 : data.page.product) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumBadge, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "truncate whitespace-nowrap text-[13px] font-medium text-white/70 md:text-sm",
                                                                    children: [
                                                                        category && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                category,
                                                                                "・"
                                                                            ]
                                                                        }),
                                                                        data === null || data === void 0 ? void 0 : data.page.hero.metadata.join("・"),
                                                                        (data === null || data === void 0 ? void 0 : data.page.hero.explicit) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                "・",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(explicit, {
                                                                                    className: "inline-block fill-white/70 pt-[1px] align-baseline"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                        className: "relative z-10 mx-auto -mt-1 w-full max-w-xl bg-almostBlack px-4 pt-7 text-white/90 md:max-w-none lg:text-xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                ref: descriptionRef,
                                                className: showFullDescription ? "line-clamp-none" : "line-clamp-3 md:line-clamp-4",
                                                dangerouslySetInnerHTML: {
                                                    __html: isInitialized ? getSanitizedHtml((ref13 = (ref12 = (ref11 = data === null || data === void 0 ? void 0 : data.page.contentBlocks[0].content) === null || ref11 === void 0 ? void 0 : ref11.replace(/\n{2,}/g, '</p><p style="margin-top:1em">')) === null || ref12 === void 0 ? void 0 : ref12.replace(/([^\n])\n(?!\n)/g, "$1<br>")) === null || ref13 === void 0 ? void 0 : ref13.replace(/  /g, "&nbsp;&nbsp;"), [
                                                        "a",
                                                        "p",
                                                        "br"
                                                    ]) : ""
                                                }
                                            }),
                                            isDescriptionShrinked && !showFullDescription && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                onClick: function() {
                                                    return setShowFullDescription(!showFullDescription);
                                                },
                                                className: "mt-2 inline-flex items-center rounded text-sm font-semibold text-white/50 transition hover:text-white/70 focus:shadow-input-focus focus:outline-none focus:ring-0 md:mt-4",
                                                children: [
                                                    t("show_more"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "m8 10.5 4 4 4-4",
                                                            stroke: "currentColor",
                                                            strokeWidth: "1.5",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.page.product) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative mx-auto mt-6 w-full max-w-xl px-2 md:mt-8 md:max-w-none md:px-0 lg:mt-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card, {
                                            title: t("premium pass"),
                                            importance: "premium",
                                            children: isSubscribed ? (data === null || data === void 0 ? void 0 : data.page.product.purchaseOptions.some(function(o) {
                                                return o.billingFrequency === BillingFrequency.OneTime;
                                            })) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetailsSingle_SubscriptionDetails, {
                                                subscriptionData: subscriptionData,
                                                data: data,
                                                multipleShows: multipleShows(),
                                                displayShowDetailsDialog: displayShowDetailsDialog
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetails, {
                                                subscriptionData: subscriptionData,
                                                data: data,
                                                multipleShows: multipleShows(),
                                                displayShowDetailsDialog: displayShowDetailsDialog,
                                                token: token
                                            }) : (data === null || data === void 0 ? void 0 : data.page.product.purchaseOptions.some(function(o) {
                                                return o.billingFrequency === BillingFrequency.OneTime;
                                            })) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailsSingle, {
                                                data: data,
                                                selectedPaymentOption: selectedPaymentOption,
                                                setSelectedPaymentOption: setSelectedPaymentOption,
                                                setIsSignupDialogOpen: setIsSignupDialogOpen,
                                                setIsSigninDialogOpen: setIsSigninDialogOpen
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {
                                                data: data,
                                                trialDays: trialDays,
                                                productName: productName,
                                                selectedPaymentOption: selectedPaymentOption,
                                                setSelectedPaymentOption: setSelectedPaymentOption,
                                                setIsSignupDialogOpen: setIsSignupDialogOpen,
                                                setIsSigninDialogOpen: setIsSigninDialogOpen,
                                                slug: slug
                                            })
                                        })
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.page.product) && multipleShows() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto mt-12 w-full max-w-xl px-2 md:mt-16 md:max-w-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bundle, {
                                            productName: productName,
                                            shows: data.page.product.shows
                                        })
                                    }),
                                    episodes.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            className: "mx-auto mt-12 w-full max-w-xl px-2 md:mt-16 md:max-w-none",
                                            children: (data === null || data === void 0 ? void 0 : data.page.product) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Disclosure, {
                                                defaultOpen: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclosureButton, {
                                                        children: t("episodes_header")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                                        enter: "origin-top-left transition duration-100 ease-out",
                                                        enterFrom: "transform scale-95 opacity-0",
                                                        enterTo: "transform scale-100 opacity-100",
                                                        leave: "origin-top-left transition duration-75 ease-out",
                                                        leaveFrom: "transform scale-100 opacity-100",
                                                        leaveTo: "transform scale-95 opacity-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclosure.Panel, {
                                                            className: "px-2 pb-8 pt-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EpisodeList, {
                                                                slug: slug,
                                                                episodes: filteredEpisodes,
                                                                seasons: seasons,
                                                                activeEpisode: activeEpisode,
                                                                setActiveEpisode: setActiveEpisode,
                                                                activeSeason: activeSeason,
                                                                setActiveSeason: setActiveSeason,
                                                                autoplay: autoplay,
                                                                setAutoplay: setAutoplay,
                                                                loading: episodesLoading,
                                                                isPlaying: isPlayingAudio,
                                                                playbackSpeed: playbackSpeed
                                                            })
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "px-2 pb-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EpisodeList, {
                                                    slug: slug,
                                                    episodes: filteredEpisodes,
                                                    seasons: seasons,
                                                    activeEpisode: activeEpisode,
                                                    setActiveEpisode: setActiveEpisode,
                                                    activeSeason: activeSeason,
                                                    setActiveSeason: setActiveSeason,
                                                    autoplay: autoplay,
                                                    setAutoplay: setAutoplay,
                                                    loading: episodesLoading,
                                                    isPlaying: isPlayingAudio,
                                                    playbackSpeed: playbackSpeed
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            className: "mx-auto w-full max-w-xl px-2 md:max-w-none ".concat(multipleShows() ? "mt-4" : "mt-6 md:mt-16"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Disclosure, {
                                                defaultOpen: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclosureButton, {
                                                        children: t("details_header")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                                        enter: "origin-top-left transition duration-100 ease-out",
                                                        enterFrom: "transform scale-95 opacity-0",
                                                        enterTo: "transform scale-100 opacity-100",
                                                        leave: "origin-top-left transition duration-75 ease-out",
                                                        leaveFrom: "transform scale-100 opacity-100",
                                                        leaveTo: "transform scale-95 opacity-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclosure.Panel, {
                                                            className: "px-2 pb-8",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                                                                className: "divide-y divide-white/10",
                                                                children: data === null || data === void 0 ? void 0 : data.page.contentBlocks.slice(1).map(function(block, index) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
                                                                        children: block.type === "link" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_Row, {
                                                                            className: "justify-between py-3",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonOrLink/* default */.Z, {
                                                                                href: block.data,
                                                                                className: "group flex w-full items-center justify-between gap-4 rounded focus:shadow-input-focus focus:outline-none focus:ring-0",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "flex flex-col-reverse !items-start",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                                                className: "text-[13px] leading-[24px] text-white/70",
                                                                                                children: t((_title = block.title) !== null && _title !== void 0 ? _title : "")
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                                                className: "font-semibold leading-[24px] text-white",
                                                                                                children: block.content
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_external, {
                                                                                        className: "h-6 w-6 fill-white/50 transition group-hover:fill-white/70"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailRow_DetailRow, {
                                                                            title: t((_title1 = block.title) !== null && _title1 !== void 0 ? _title1 : ""),
                                                                            value: block.content
                                                                        })
                                                                    }, index);
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    slug.includes("thirdear") && (data === null || data === void 0 ? void 0 : data.page.product) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            id: "faq",
                                            className: "mx-auto mt-4 w-full max-w-xl scroll-m-8 px-2 md:max-w-none",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Disclosure, {
                                                defaultOpen: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclosureButton, {
                                                        children: t("faq_header")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                                        enter: "origin-top-left transition duration-100 ease-out",
                                                        enterFrom: "transform scale-95 opacity-0",
                                                        enterTo: "transform scale-100 opacity-100",
                                                        leave: "origin-top-left transition duration-75 ease-out",
                                                        leaveFrom: "transform scale-100 opacity-100",
                                                        leaveTo: "transform scale-95 opacity-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Disclosure.Panel, {
                                                            className: "divide-y divide-white/10 px-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ_FAQ, {
                                                                        question: t("faq_question_1", {
                                                                            title: productName
                                                                        }),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: t("faq_answer_1", {
                                                                                    title: productName,
                                                                                    trialDays: trialDays
                                                                                })
                                                                            }
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ_FAQ, {
                                                                        question: t("faq_question_2"),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: t("faq_answer_2", {
                                                                                    priceMonth: (ref14 = data === null || data === void 0 ? void 0 : data.page.product) === null || ref14 === void 0 ? void 0 : ref14.purchaseOptions[0].price.displayPrice,
                                                                                    priceYear: (ref15 = data === null || data === void 0 ? void 0 : data.page.product) === null || ref15 === void 0 ? void 0 : ref15.purchaseOptions[1].price.displayPrice
                                                                                })
                                                                            }
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ_FAQ, {
                                                                        question: t("faq_question_3"),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: t("faq_answer_3")
                                                                            }
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ_FAQ, {
                                                                        question: t("faq_question_4"),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: t("faq_answer_4")
                                                                            }
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideIn, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ_FAQ, {
                                                                        question: t("faq_question_5"),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            dangerouslySetInnerHTML: {
                                                                                __html: t("faq_answer_5")
                                                                            }
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                        show: showSubscriptionError,
                        title: t("error_no_subscription_title"),
                        image: "/assets/modal-power.png",
                        onClose: function() {
                            return setShowSubscriptionError(false);
                        },
                        small: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-4 text-center text-white/70",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                                    i18nKey: "error_no_subscription_body",
                                    children: [
                                        "No ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-white/90",
                                            children: productName
                                        }),
                                        " subscription."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                importance: "primary",
                                className: "mt-8 w-full",
                                onClick: function() {
                                    return setShowSubscriptionError(false);
                                },
                                children: t("error_no_subscription_button")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-6 text-center text-xs text-white/70",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Trans */.cC, {
                                    i18nKey: "contact_support_team",
                                    children: [
                                        "Please contact our",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonOrLink/* default */.Z, {
                                            href: "mailto:help@podspace.com",
                                            className: "rounded text-white/90 underline focus:shadow-input-focus focus:outline-none focus:ring-0",
                                            children: "Support Team"
                                        }),
                                        " ",
                                        "for any questions."
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                        show: showLinkedError,
                        title: "Already linked",
                        image: "/assets/modal-power.png",
                        onClose: function() {
                            return setShowLinkedError(false);
                        },
                        small: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mt-4 text-center text-white/70",
                                children: [
                                    "It seems like your account is already linked to another Spotify account. You can visit",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://content-access.spotify.com",
                                        className: "text-white/90 underline",
                                        children: "Spotify"
                                    }),
                                    " ",
                                    "from the previously linked account to unlink it."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                importance: "primary",
                                className: "mt-8 w-full",
                                onClick: function() {
                                    return setShowLinkedError(false);
                                },
                                children: t("error_no_subscription_button")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                        show: showSpotifyUnlinkedDialog,
                        title: t("spotify_unlinked_title"),
                        image: "/assets/modal-power.png",
                        onClose: function() {
                            return setShowSpotifyUnlinkedDialog(false);
                        },
                        small: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-4 text-center text-white/70",
                                children: t("spotify_unlinked_body")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                importance: "primary",
                                className: "mt-8 w-full",
                                onClick: function() {
                                    return setShowSpotifyUnlinkedDialog(false);
                                },
                                children: t("error_no_subscription_button")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ShowDetailsDialog, {
                        show: activeShow,
                        productName: productName,
                        open: showShowDetailsDialog,
                        onClose: closeShowDetailsDialog
                    }),
                    isSignupDialogOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Signup, {
                        selectedPaymentOption: selectedPaymentOption,
                        productName: productName,
                        isOpen: isSignupDialogOpen,
                        setIsOpen: setIsSignupDialogOpen,
                        trialDays: trialDays,
                        promoCode: (ref16 = data.page) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.product) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.promotion) === null || ref18 === void 0 ? void 0 : ref18.code
                    }),
                    isSigninDialogOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(SigninDialog, {
                        showSubscriptionError: function() {
                            setIsSigninDialogOpen(false);
                            setShowSubscriptionError(true);
                        },
                        selectedPaymentOption: selectedPaymentOption,
                        productName: productName,
                        isOpen: isSigninDialogOpen,
                        setIsOpen: setIsSigninDialogOpen
                    }),
                    (data === null || data === void 0 ? void 0 : data.page.product) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredSubscriptionDialog, {
                        selectedPaymentOption: selectedPaymentOption,
                        productName: productName,
                        purchaseOptions: (ref19 = data === null || data === void 0 ? void 0 : data.page.product) === null || ref19 === void 0 ? void 0 : ref19.purchaseOptions,
                        trialDays: trialDays,
                        isOpen: isExpiredSubscriptionDialogOpen,
                        setIsOpen: setIsExpiredSubscriptionDialogOpen,
                        token: token
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (Premium);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,695,610,234,963,774,888,179], function() { return __webpack_exec__(5620); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);